import { myApi as api } from "../common/redux/my-api";
export const addTagTypes = [
  "Organization",
  "Document",
  "Ai",
  "Assessment",
  "Misc",
  "Agent",
  "SourcingEvent",
  "Bid",
  "Upload",
  "EmailInvite",
  "Espd",
  "BidV2",
  "Doffin",
  "Contract",
  "Product",
  "TextDocument",
  "ContributingEntity",
  "CPV",
  "Industry",
  "LibraryElement",
  "Notification",
  "Home",
  "Need",
  "Me",
  "Project",
  "Scim",
  "Search",
  "SourcingEventTemplate",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      adminListAllEntities: build.query<
        AdminListAllEntitiesApiResponse,
        AdminListAllEntitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/all-entities`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            entityType: queryArg.entityType,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminMigrateFencyDocuments: build.mutation<
        AdminMigrateFencyDocumentsApiResponse,
        AdminMigrateFencyDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency`,
          method: "POST",
          body: queryArg.adminMigrateFencyRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminRestampFencyAccess: build.mutation<
        AdminRestampFencyAccessApiResponse,
        AdminRestampFencyAccessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency/access`,
          method: "POST",
          body: queryArg.adminRestampFencyAccessRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminMigrateFencyContractMetadata: build.mutation<
        AdminMigrateFencyContractMetadataApiResponse,
        AdminMigrateFencyContractMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency/contract-metadata`,
          method: "POST",
          body: queryArg.adminMigrateFencyContractMetadataRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminGetFencyMigrationStats: build.query<
        AdminGetFencyMigrationStatsApiResponse,
        AdminGetFencyMigrationStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/migrate-fency/stats`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            targetOrganizationId: queryArg.targetOrganizationId,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminListOrganizations: build.query<
        AdminListOrganizationsApiResponse,
        AdminListOrganizationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            skip: queryArg.skip,
            limit: queryArg.limit,
            name: queryArg.name,
          },
        }),
        providesTags: ["Organization"],
      }),
      adminUpdateOrganization: build.mutation<
        AdminUpdateOrganizationApiResponse,
        AdminUpdateOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs/${queryArg.orgId}`,
          method: "PATCH",
          body: queryArg.adminUpdateOrganizationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      adminChangeOrganizationOwner: build.mutation<
        AdminChangeOrganizationOwnerApiResponse,
        AdminChangeOrganizationOwnerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/admin/orgs/${queryArg.orgId}/owner`,
          method: "PUT",
          body: queryArg.adminChangeOrganizationOwnerRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      sendAiChatMessage: build.mutation<
        SendAiChatMessageApiResponse,
        SendAiChatMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/ai/chat`,
          method: "POST",
          body: queryArg.aiChatRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      createAiCompletion: build.mutation<
        CreateAiCompletionApiResponse,
        CreateAiCompletionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/ai/completions`,
          method: "POST",
          body: queryArg.createAiCompletionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Ai"],
      }),
      createAssessmentTemplate: build.mutation<
        CreateAssessmentTemplateApiResponse,
        CreateAssessmentTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/assessment-templates`,
          method: "POST",
          body: queryArg.createAssessmentTemplateRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Assessment"],
      }),
      getAssessmentTemplate: build.query<
        GetAssessmentTemplateApiResponse,
        GetAssessmentTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/assessment-templates/${queryArg.id}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Assessment"],
      }),
      createAssessment: build.mutation<
        CreateAssessmentApiResponse,
        CreateAssessmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/assessments`,
          method: "POST",
          body: queryArg.createAssessmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Assessment"],
      }),
      getAssessment: build.query<GetAssessmentApiResponse, GetAssessmentApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/assessments/${queryArg.id}`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          providesTags: ["Assessment"],
        },
      ),
      getBaseData: build.query<GetBaseDataApiResponse, GetBaseDataApiArg>({
        query: () => ({ url: `/api/base-data` }),
        providesTags: ["Misc"],
      }),
      getTypes: build.query<GetTypesApiResponse, GetTypesApiArg>({
        query: () => ({ url: `/api/base-data/types` }),
        providesTags: ["Misc"],
      }),
      recordAgentAuditEntry: build.mutation<
        RecordAgentAuditEntryApiResponse,
        RecordAgentAuditEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/audit`,
          method: "POST",
          body: queryArg.agentAuditEntryDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      listAgentConversations: build.query<
        ListAgentConversationsApiResponse,
        ListAgentConversationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Agent"],
      }),
      createAgentConversation: build.mutation<
        CreateAgentConversationApiResponse,
        CreateAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations`,
          method: "POST",
          body: queryArg.createAgentConversationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      deleteAgentConversation: build.mutation<
        DeleteAgentConversationApiResponse,
        DeleteAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations/${queryArg.conversationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      getAgentConversation: build.query<
        GetAgentConversationApiResponse,
        GetAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations/${queryArg.conversationId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Agent"],
      }),
      updateAgentConversation: build.mutation<
        UpdateAgentConversationApiResponse,
        UpdateAgentConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/conversations/${queryArg.conversationId}`,
          method: "PUT",
          body: queryArg.updateAgentConversationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      createAgentDocumentSearchSession: build.mutation<
        CreateAgentDocumentSearchSessionApiResponse,
        CreateAgentDocumentSearchSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/document-search-sessions`,
          method: "POST",
          body: queryArg.createAgentDocumentSearchSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      resolveAgentDocumentSources: build.mutation<
        ResolveAgentDocumentSourcesApiResponse,
        ResolveAgentDocumentSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/document-sources`,
          method: "POST",
          body: queryArg.resolveAgentDocumentSourcesRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      getAgentModels: build.query<
        GetAgentModelsApiResponse,
        GetAgentModelsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/models`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Agent"],
      }),
      planAgentTurn: build.mutation<
        PlanAgentTurnApiResponse,
        PlanAgentTurnApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/agent/plan`,
          method: "POST",
          body: queryArg.agentPlanRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Agent"],
      }),
      createBasicSourcingEvent: build.mutation<
        CreateBasicSourcingEventApiResponse,
        CreateBasicSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/deps/${queryArg.depId}/events`,
          method: "POST",
          body: queryArg.createSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getNegotiationRound: build.query<
        GetNegotiationRoundApiResponse,
        GetNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/negotiation/${queryArg.negotiationId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getBasicSourcingEvent: build.query<
        GetBasicSourcingEventApiResponse,
        GetBasicSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      updateBasicSourcingEvent: build.mutation<
        UpdateBasicSourcingEventApiResponse,
        UpdateBasicSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}`,
          method: "PUT",
          body: queryArg.editSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      awardToBid: build.mutation<AwardToBidApiResponse, AwardToBidApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/award`,
          method: "POST",
          body: queryArg.awardToBidRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listReceivedBids: build.query<
        ListReceivedBidsApiResponse,
        ListReceivedBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/bids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            negotiationRound: queryArg.negotiationRound,
          },
        }),
        providesTags: ["Bid"],
      }),
      getReceivedBseBid: build.query<
        GetReceivedBseBidApiResponse,
        GetReceivedBseBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/bids/${queryArg.bidId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Bid"],
      }),
      cancelSourcingEvent: build.mutation<
        CancelSourcingEventApiResponse,
        CancelSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/cancel`,
          method: "PUT",
          body: queryArg.cancelSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      closeSourcingEvent: build.mutation<
        CloseSourcingEventApiResponse,
        CloseSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/close`,
          method: "PUT",
          body: queryArg.closeSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      completeEvaluation: build.mutation<
        CompleteEvaluationApiResponse,
        CompleteEvaluationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/complete`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createSourcingEventCopy: build.mutation<
        CreateSourcingEventCopyApiResponse,
        CreateSourcingEventCopyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/copy`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSourcingEventDescription: build.mutation<
        CreateUploadForSourcingEventDescriptionApiResponse,
        CreateUploadForSourcingEventDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createEmailInviteReminder: build.mutation<
        CreateEmailInviteReminderApiResponse,
        CreateEmailInviteReminderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/invites/${queryArg.inviteId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      createNegotiationRound: build.mutation<
        CreateNegotiationRoundApiResponse,
        CreateNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/negotiation`,
          method: "POST",
          body: queryArg.createNegotiationRoundRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      openCompletedEvent: build.mutation<
        OpenCompletedEventApiResponse,
        OpenCompletedEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/open`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishBasicSourcingEvent: build.mutation<
        PublishBasicSourcingEventApiResponse,
        PublishBasicSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/publishing`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createBseQuestionAsBuyer: build.mutation<
        CreateBseQuestionAsBuyerApiResponse,
        CreateBseQuestionAsBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/questions`,
          method: "POST",
          body: queryArg.createBseQuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateBseQuestion: build.mutation<
        UpdateBseQuestionApiResponse,
        UpdateBseQuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/questions/${queryArg.questionId}`,
          method: "PATCH",
          body: queryArg.updateBseQuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createBseQuestionCommentAsBuyer: build.mutation<
        CreateBseQuestionCommentAsBuyerApiResponse,
        CreateBseQuestionCommentAsBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/questions/${queryArg.questionId}/comments`,
          method: "POST",
          body: queryArg.createBseQuestionCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForBse: build.mutation<
        CreateUploadForBseApiResponse,
        CreateUploadForBseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/basic/events/${queryArg.eventId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      evaluateSingleBidWithAi: build.mutation<
        EvaluateSingleBidWithAiApiResponse,
        EvaluateSingleBidWithAiApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/bids/evaluate-with-ai`,
          method: "POST",
          body: queryArg.evaluateSingleBidWithAiRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Bid"],
      }),
      removeContactPerson: build.mutation<
        RemoveContactPersonApiResponse,
        RemoveContactPersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            email: queryArg.email,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listContactPersons: build.query<
        ListContactPersonsApiResponse,
        ListContactPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            name: queryArg.name,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Organization"],
      }),
      addContactPerson: build.mutation<
        AddContactPersonApiResponse,
        AddContactPersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          method: "POST",
          body: queryArg.addContactPersonRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      editContactPerson: build.mutation<
        EditContactPersonApiResponse,
        EditContactPersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/contact-persons/${queryArg.subjectType}/${queryArg.subjectId}`,
          method: "PUT",
          body: queryArg.editContactPersonRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getExclusionGroundsTaxonomy: build.query<
        GetExclusionGroundsTaxonomyApiResponse,
        GetExclusionGroundsTaxonomyApiArg
      >({
        query: () => ({ url: `/api/buyer/espd/taxonomy` }),
        providesTags: ["Espd"],
      }),
      listSourcingEventsForBuyer: build.query<
        ListSourcingEventsForBuyerApiResponse,
        ListSourcingEventsForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createSourcingEvent: build.mutation<
        CreateSourcingEventApiResponse,
        CreateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events`,
          method: "POST",
          body: queryArg.createSourcingEventV2Request,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      evaluateBidsWithAi: build.mutation<
        EvaluateBidsWithAiApiResponse,
        EvaluateBidsWithAiApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/evaluate-with-ai`,
          method: "POST",
          body: queryArg.evaluateBidsWithAiRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      generateRequirementsWithAi: build.mutation<
        GenerateRequirementsWithAiApiResponse,
        GenerateRequirementsWithAiApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/generate-requirements-with-ai`,
          method: "POST",
          body: queryArg.generateRequirementsWithAiRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      deleteSourcingEvent: build.mutation<
        DeleteSourcingEventApiResponse,
        DeleteSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getSourcingEvent: build.query<
        GetSourcingEventApiResponse,
        GetSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      updateSourcingEvent: build.mutation<
        UpdateSourcingEventApiResponse,
        UpdateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}`,
          method: "PUT",
          body: queryArg.sourcingEventV2PatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSeV2AnnouncementAttachment: build.mutation<
        CreateUploadForSeV2AnnouncementAttachmentApiResponse,
        CreateUploadForSeV2AnnouncementAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/announcement-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getBuyerSeV2AttachmentUpload: build.query<
        GetBuyerSeV2AttachmentUploadApiResponse,
        GetBuyerSeV2AttachmentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/attachment-uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      awardSourcingEvent: build.mutation<
        AwardSourcingEventApiResponse,
        AwardSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award`,
          method: "POST",
          body: queryArg.awardSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      getAwardLetters: build.query<
        GetAwardLettersApiResponse,
        GetAwardLettersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      dispatchAwardLetters: build.mutation<
        DispatchAwardLettersApiResponse,
        DispatchAwardLettersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/dispatch`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateAwardLetter: build.mutation<
        UpdateAwardLetterApiResponse,
        UpdateAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/${queryArg.letterId}`,
          method: "PATCH",
          body: queryArg.awardLetterPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      approveAwardLetter: build.mutation<
        ApproveAwardLetterApiResponse,
        ApproveAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/${queryArg.letterId}/approve`,
          method: "POST",
          body: queryArg.awardLetterPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      reopenAwardLetter: build.mutation<
        ReopenAwardLetterApiResponse,
        ReopenAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/award-letters/${queryArg.letterId}/reopen`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      beginEvaluation: build.mutation<
        BeginEvaluationApiResponse,
        BeginEvaluationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/begin-evaluation`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      cancelSourcingEventV2: build.mutation<
        CancelSourcingEventV2ApiResponse,
        CancelSourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/cancellation`,
          method: "POST",
          body: queryArg.cancelSourcingEventV2Request,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createEventChange: build.mutation<
        CreateEventChangeApiResponse,
        CreateEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateEventChange: build.mutation<
        UpdateEventChangeApiResponse,
        UpdateEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes/${queryArg.revisionId}`,
          method: "PATCH",
          body: queryArg.eventRevisionPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      cancelEventChange: build.mutation<
        CancelEventChangeApiResponse,
        CancelEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes/${queryArg.revisionId}/cancel`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      submitEventChange: build.mutation<
        SubmitEventChangeApiResponse,
        SubmitEventChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/changes/${queryArg.revisionId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      startSeV2Clarification: build.mutation<
        StartSeV2ClarificationApiResponse,
        StartSeV2ClarificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/clarifications`,
          method: "POST",
          body: queryArg.createSeV2ClarificationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      closeSourcingEventV2: build.mutation<
        CloseSourcingEventV2ApiResponse,
        CloseSourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/closure`,
          method: "POST",
          body: queryArg.closeSourcingEventV2Request,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      completeSourcingEventV2: build.mutation<
        CompleteSourcingEventV2ApiResponse,
        CompleteSourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/completion`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      confirmAward: build.mutation<ConfirmAwardApiResponse, ConfirmAwardApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/confirm-award`,
            method: "POST",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["SourcingEvent"],
        },
      ),
      confirmSourcingEventClassification: build.mutation<
        ConfirmSourcingEventClassificationApiResponse,
        ConfirmSourcingEventClassificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/confirm-classification`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      copySourcingEventV2: build.mutation<
        CopySourcingEventV2ApiResponse,
        CopySourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/copies`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getDpsCompetitions: build.query<
        GetDpsCompetitionsApiResponse,
        GetDpsCompetitionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/dps/competitions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createDpsCompetition: build.mutation<
        CreateDpsCompetitionApiResponse,
        CreateDpsCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/dps/competitions`,
          method: "POST",
          body: queryArg.createDpsCompetitionRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addEmailInviteToPrivateSourcingEvent: build.mutation<
        AddEmailInviteToPrivateSourcingEventApiResponse,
        AddEmailInviteToPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/email-invites`,
          method: "POST",
          body: queryArg.addEmailInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeEmailInviteFromPrivateSourcingEvent: build.mutation<
        RemoveEmailInviteFromPrivateSourcingEventApiResponse,
        RemoveEmailInviteFromPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/email-invites/${queryArg.inviteId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createEmailInviteReminderForPrivateSourcingEvent: build.mutation<
        CreateEmailInviteReminderForPrivateSourcingEventApiResponse,
        CreateEmailInviteReminderForPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/email-invites/${queryArg.inviteId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getEvaluation: build.query<GetEvaluationApiResponse, GetEvaluationApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/evaluation`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
            params: {
              round: queryArg.round,
            },
          }),
          providesTags: ["SourcingEvent"],
        },
      ),
      upsertPriceOverride: build.mutation<
        UpsertPriceOverrideApiResponse,
        UpsertPriceOverrideApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/price`,
          method: "PUT",
          body: queryArg.upsertPriceOverrideRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      setCriterionRationale: build.mutation<
        SetCriterionRationaleApiResponse,
        SetCriterionRationaleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/rationale`,
          method: "PUT",
          body: queryArg.setRationaleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      upsertCriterionScore: build.mutation<
        UpsertCriterionScoreApiResponse,
        UpsertCriterionScoreApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/score`,
          method: "PUT",
          body: queryArg.upsertScoreRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      setEvaluationSelection: build.mutation<
        SetEvaluationSelectionApiResponse,
        SetEvaluationSelectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/evaluation/selection`,
          method: "PUT",
          body: queryArg.setEvaluationSelectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            round: queryArg.round,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateSourcingEventValue: build.mutation<
        UpdateSourcingEventValueApiResponse,
        UpdateSourcingEventValueApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/event-value`,
          method: "PUT",
          body: queryArg.updateSourcingEventValueRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      setHomeDepartment: build.mutation<
        SetHomeDepartmentApiResponse,
        SetHomeDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/home-department`,
          method: "PUT",
          body: queryArg.setHomeDepartmentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addInternalMessageToSeV2: build.mutation<
        AddInternalMessageToSeV2ApiResponse,
        AddInternalMessageToSeV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/internal-messages`,
          method: "POST",
          body: queryArg.addInternalMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      confirmInvitation: build.mutation<
        ConfirmInvitationApiResponse,
        ConfirmInvitationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/invitation`,
          method: "POST",
          body: queryArg.confirmInvitationRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      createOrganizationInviteEmailReminder: build.mutation<
        CreateOrganizationInviteEmailReminderApiResponse,
        CreateOrganizationInviteEmailReminderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/invites/${queryArg.inviteId}/email-invites/${queryArg.emailInviteId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      listNegotiationRoundsV2: build.query<
        ListNegotiationRoundsV2ApiResponse,
        ListNegotiationRoundsV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createNegotiationRoundV2: build.mutation<
        CreateNegotiationRoundV2ApiResponse,
        CreateNegotiationRoundV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds`,
          method: "POST",
          body: queryArg.createNegotiationRoundV2Request,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      patchNegotiationRoundV2: build.mutation<
        PatchNegotiationRoundV2ApiResponse,
        PatchNegotiationRoundV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}`,
          method: "PATCH",
          body: queryArg.negotiationRoundV2PatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      completeNegotiationRoundV2: build.mutation<
        CompleteNegotiationRoundV2ApiResponse,
        CompleteNegotiationRoundV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/completion`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addNegotiationRoundV2Invite: build.mutation<
        AddNegotiationRoundV2InviteApiResponse,
        AddNegotiationRoundV2InviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/invites`,
          method: "POST",
          body: queryArg.addNegotiationRoundV2InviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeNegotiationRoundV2Invite: build.mutation<
        RemoveNegotiationRoundV2InviteApiResponse,
        RemoveNegotiationRoundV2InviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/invites/${queryArg.pathOrganizationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      updateNegotiationRoundV2InviteMessage: build.mutation<
        UpdateNegotiationRoundV2InviteMessageApiResponse,
        UpdateNegotiationRoundV2InviteMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/invites/${queryArg.pathOrganizationId}`,
          method: "PUT",
          body: queryArg.updateNegotiationRoundV2InviteMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      selectNegotiationRoundV2ProductBids: build.mutation<
        SelectNegotiationRoundV2ProductBidsApiResponse,
        SelectNegotiationRoundV2ProductBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/product-bids`,
          method: "PUT",
          body: queryArg.selectProductBidsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishNegotiationRoundV2: build.mutation<
        PublishNegotiationRoundV2ApiResponse,
        PublishNegotiationRoundV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/publication`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      reopenNegotiationRoundV2: build.mutation<
        ReopenNegotiationRoundV2ApiResponse,
        ReopenNegotiationRoundV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/reopening`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForNegotiationRoundV2: build.mutation<
        CreateUploadForNegotiationRoundV2ApiResponse,
        CreateUploadForNegotiationRoundV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      completeNegotiationRoundEvaluation: build.mutation<
        CompleteNegotiationRoundEvaluationApiResponse,
        CompleteNegotiationRoundEvaluationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation/${queryArg.negotiationId}/complete`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      openNegotiationRound: build.mutation<
        OpenNegotiationRoundApiResponse,
        OpenNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation/${queryArg.negotiationId}/open`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishNegotiationRound: build.mutation<
        PublishNegotiationRoundApiResponse,
        PublishNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/negotiation/${queryArg.negotiationId}/publish`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      addOrganizationInviteToPrivateSourcingEvent: build.mutation<
        AddOrganizationInviteToPrivateSourcingEventApiResponse,
        AddOrganizationInviteToPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/organization-invites`,
          method: "POST",
          body: queryArg.addOrganizationInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      removeOrganizationInviteFromPrivateSourcingEvent: build.mutation<
        RemoveOrganizationInviteFromPrivateSourcingEventApiResponse,
        RemoveOrganizationInviteFromPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/organization-invites/${queryArg.pathOrganizationId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.headerOrganizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listParticipationRequestsForBuyer: build.query<
        ListParticipationRequestsForBuyerApiResponse,
        ListParticipationRequestsForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      getParticipationRequestForBuyer: build.query<
        GetParticipationRequestForBuyerApiResponse,
        GetParticipationRequestForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      extendDpsAssessmentWindow: build.mutation<
        ExtendDpsAssessmentWindowApiResponse,
        ExtendDpsAssessmentWindowApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/assessment-window`,
          method: "PATCH",
          body: queryArg.extendAssessmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateParticipationRequestReview: build.mutation<
        UpdateParticipationRequestReviewApiResponse,
        UpdateParticipationRequestReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/qualification-review`,
          method: "PATCH",
          body: queryArg.buyerQualificationReviewPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getParticipationRequestRejectionDocuments: build.query<
        GetParticipationRequestRejectionDocumentsApiResponse,
        GetParticipationRequestRejectionDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/rejection-documents`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createUploadForParticipationRequestRejection: build.mutation<
        CreateUploadForParticipationRequestRejectionApiResponse,
        CreateUploadForParticipationRequestRejectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/rejection-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "Upload"],
      }),
      removeFromDpsScheme: build.mutation<
        RemoveFromDpsSchemeApiResponse,
        RemoveFromDpsSchemeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/removal`,
          method: "POST",
          body: queryArg.removeFromSchemeRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateParticipationRequestNotes: build.mutation<
        UpdateParticipationRequestNotesApiResponse,
        UpdateParticipationRequestNotesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/review-notes`,
          method: "PATCH",
          body: queryArg.buyerReviewNotesPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateParticipationRequestSelectionDraft: build.mutation<
        UpdateParticipationRequestSelectionDraftApiResponse,
        UpdateParticipationRequestSelectionDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/selection-draft`,
          method: "PATCH",
          body: queryArg.selectionDraftPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      setQualificationVerdict: build.mutation<
        SetQualificationVerdictApiResponse,
        SetQualificationVerdictApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/participation-requests/${queryArg.requestId}/verdict`,
          method: "PUT",
          body: queryArg.setQualificationVerdictRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      selectSourcingEventProductBids: build.mutation<
        SelectSourcingEventProductBidsApiResponse,
        SelectSourcingEventProductBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/product-bid-selection`,
          method: "PUT",
          body: queryArg.selectProductBidsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getProtocolDraft: build.query<
        GetProtocolDraftApiResponse,
        GetProtocolDraftApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/draft`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      patchProtocolNarrative: build.mutation<
        PatchProtocolNarrativeApiResponse,
        PatchProtocolNarrativeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/draft`,
          method: "PATCH",
          body: queryArg.protocolDraftPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      finaliseProtocol: build.mutation<
        FinaliseProtocolApiResponse,
        FinaliseProtocolApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/finalise`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      listProtocolVersions: build.query<
        ListProtocolVersionsApiResponse,
        ListProtocolVersionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/versions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      downloadProtocolVersion: build.query<
        DownloadProtocolVersionApiResponse,
        DownloadProtocolVersionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/protocol/versions/${queryArg.versionId}/pdf`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listBidV2SForEvent: build.query<
        ListBidV2SForEventApiResponse,
        ListBidV2SForEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      getBidV2ForBuyer: build.query<
        GetBidV2ForBuyerApiResponse,
        GetBidV2ForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createContractFromBidV2: build.mutation<
        CreateContractFromBidV2ApiResponse,
        CreateContractFromBidV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/contract`,
          method: "POST",
          body: queryArg.createContractFromBidV2Request,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "Contract", "SourcingEvent"],
      }),
      updateBuyerMinimumRequirementReview: build.mutation<
        UpdateBuyerMinimumRequirementReviewApiResponse,
        UpdateBuyerMinimumRequirementReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/minimum-requirement-review`,
          method: "PATCH",
          body: queryArg.buyerMinimumRequirementReviewPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      setBidQualification: build.mutation<
        SetBidQualificationApiResponse,
        SetBidQualificationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/qualification`,
          method: "PUT",
          body: queryArg.setBidQualificationRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      updateBuyerQualificationReview: build.mutation<
        UpdateBuyerQualificationReviewApiResponse,
        UpdateBuyerQualificationReviewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/qualification-review`,
          method: "PATCH",
          body: queryArg.buyerQualificationReviewPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      rejectBidV2: build.mutation<RejectBidV2ApiResponse, RejectBidV2ApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/reject`,
          method: "POST",
          body: queryArg.rejectBidV2RequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      getBidV2RejectionDocuments: build.query<
        GetBidV2RejectionDocumentsApiResponse,
        GetBidV2RejectionDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/rejection-documents`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createUploadForBidV2Rejection: build.mutation<
        CreateUploadForBidV2RejectionApiResponse,
        CreateUploadForBidV2RejectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/rejection-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "Upload"],
      }),
      revokeBidRejection: build.mutation<
        RevokeBidRejectionApiResponse,
        RevokeBidRejectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/public-bids/${queryArg.bidId}/revoke-rejection`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      publishDpsCompetition: build.mutation<
        PublishDpsCompetitionApiResponse,
        PublishDpsCompetitionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/publish-dps-competition`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      publishPrivateSourcingEvent: build.mutation<
        PublishPrivateSourcingEventApiResponse,
        PublishPrivateSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/publish-private`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      downloadSeV2QaReport: build.query<
        DownloadSeV2QaReportApiResponse,
        DownloadSeV2QaReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/qa-report`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      getBuyerSeV2Questions: build.query<
        GetBuyerSeV2QuestionsApiResponse,
        GetBuyerSeV2QuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      answerSeV2Question: build.mutation<
        AnswerSeV2QuestionApiResponse,
        AnswerSeV2QuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions/${queryArg.questionId}`,
          method: "PATCH",
          body: queryArg.seV2QuestionPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSeV2AnswerAttachment: build.mutation<
        CreateUploadForSeV2AnswerAttachmentApiResponse,
        CreateUploadForSeV2AnswerAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions/${queryArg.questionId}/answer-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      sendSeV2ClarificationMessageAsBuyer: build.mutation<
        SendSeV2ClarificationMessageAsBuyerApiResponse,
        SendSeV2ClarificationMessageAsBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/questions/${queryArg.questionId}/messages`,
          method: "POST",
          body: queryArg.createSeV2QuestionMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getSourcingEventReadiness: build.query<
        GetSourcingEventReadinessApiResponse,
        GetSourcingEventReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/readiness`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      reopenCompletedSourcingEventV2: build.mutation<
        ReopenCompletedSourcingEventV2ApiResponse,
        ReopenCompletedSourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/reopening`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      setResponsiblePerson: build.mutation<
        SetResponsiblePersonApiResponse,
        SetResponsiblePersonApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/responsible-person`,
          method: "PUT",
          body: queryArg.setResponsiblePersonRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      revokeAward: build.mutation<RevokeAwardApiResponse, RevokeAwardApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/revoke-award`,
          method: "POST",
          body: queryArg.revokeAwardRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      getEventShares: build.query<
        GetEventSharesApiResponse,
        GetEventSharesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/shares`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      shareEvent: build.mutation<ShareEventApiResponse, ShareEventApiArg>({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/shares`,
          method: "POST",
          body: queryArg.shareEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      unshareEvent: build.mutation<UnshareEventApiResponse, UnshareEventApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/buyer/events/${queryArg.eventId}/shares/${queryArg.pathPersonId}`,
            method: "DELETE",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.headerPersonId,
            },
          }),
          invalidatesTags: ["SourcingEvent"],
        },
      ),
      getBuyerSupplierInformation: build.query<
        GetBuyerSupplierInformationApiResponse,
        GetBuyerSupplierInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/supplier-information`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      publishInformation: build.mutation<
        PublishInformationApiResponse,
        PublishInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/supplier-information`,
          method: "POST",
          body: queryArg.createInformationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForSourcingEventV2: build.mutation<
        CreateUploadForSourcingEventV2ApiResponse,
        CreateUploadForSourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/events/${queryArg.eventId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      editNegotiationRound: build.mutation<
        EditNegotiationRoundApiResponse,
        EditNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/negotiations/${queryArg.negotiationId}`,
          method: "PUT",
          body: queryArg.editNegotiationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createUploadForNegotiationRoundDescription: build.mutation<
        CreateUploadForNegotiationRoundDescriptionApiResponse,
        CreateUploadForNegotiationRoundDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/negotiations/${queryArg.negotiationRoundId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForNegotiationRound: build.mutation<
        CreateUploadForNegotiationRoundApiResponse,
        CreateUploadForNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/negotiations/${queryArg.negotiationRoundId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getProductGroupsForSourcingEvent: build.query<
        GetProductGroupsForSourcingEventApiResponse,
        GetProductGroupsForSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/products/sourcing/groups/${queryArg.sourcingEventId}`,
        }),
        providesTags: ["Product"],
      }),
      listCombinedEventsForBuyer: build.query<
        ListCombinedEventsForBuyerApiResponse,
        ListCombinedEventsForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/combined-events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            statuses: queryArg.statuses,
            projectIds: queryArg.projectIds,
            name: queryArg.name,
            responsiblePersons: queryArg.responsiblePersons,
            contractTypes: queryArg.contractTypes,
            deadlinePassed: queryArg.deadlinePassed,
            limit: queryArg.limit,
            skip: queryArg.skip,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listBuyerEventFilterOptions: build.query<
        ListBuyerEventFilterOptionsApiResponse,
        ListBuyerEventFilterOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/combined-events/filter-options`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      countCombinedEventsByStatus: build.query<
        CountCombinedEventsByStatusApiResponse,
        CountCombinedEventsByStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/combined-events/status-counts`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listEventsForBuyer: build.query<
        ListEventsForBuyerApiResponse,
        ListEventsForBuyerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/buyer/${queryArg.orgId}/events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            statuses: queryArg.statuses,
            projectIds: queryArg.projectIds,
            name: queryArg.name,
            responsiblePersons: queryArg.responsiblePersons,
            limit: queryArg.limit,
            skip: queryArg.skip,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listContractReports: build.query<
        ListContractReportsApiResponse,
        ListContractReportsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
            sortBy: queryArg.sortBy,
            sortDirection: queryArg.sortDirection,
            sortByCustomField: queryArg.sortByCustomField,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContractReportOptions: build.query<
        ListContractReportOptionsApiResponse,
        ListContractReportOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract-reports/options`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            q: queryArg.q,
            parameterName: queryArg.parameterName,
            optionValues: queryArg.optionValues,
            optionSearchTerm: queryArg.optionSearchTerm,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractFromSourcingEvent: build.mutation<
        CreateContractFromSourcingEventApiResponse,
        CreateContractFromSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/from-sourcing-event`,
          method: "POST",
          body: queryArg.createContractFromSourcingEventRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract", "SourcingEvent"],
      }),
      deleteCustomContractDataField: build.mutation<
        DeleteCustomContractDataFieldApiResponse,
        DeleteCustomContractDataFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/custom-field/${queryArg.orgId}`,
          method: "DELETE",
          body: queryArg.deleteCustomFieldDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract", "Organization"],
      }),
      upsertCustomContractDataField: build.mutation<
        UpsertCustomContractDataFieldApiResponse,
        UpsertCustomContractDataFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/custom-field/${queryArg.orgId}`,
          method: "PUT",
          body: queryArg.upsertCustomContractFieldDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      upsertContractDataFieldsSection: build.mutation<
        UpsertContractDataFieldsSectionApiResponse,
        UpsertContractDataFieldsSectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/organization/fields-section/${queryArg.orgId}`,
          method: "POST",
          body: queryArg.contractDataFieldSectionDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      contractReportQueryDummy: build.mutation<
        ContractReportQueryDummyApiResponse,
        ContractReportQueryDummyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/report-query-dummy`,
          method: "POST",
          body: queryArg.contractReportQueryDto,
        }),
        invalidatesTags: ["Contract"],
      }),
      signatureWebhook: build.mutation<
        SignatureWebhookApiResponse,
        SignatureWebhookApiArg
      >({
        query: () => ({
          url: `/api/contract/signature/events`,
          method: "POST",
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteContractTaskComment: build.mutation<
        DeleteContractTaskCommentApiResponse,
        DeleteContractTaskCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/task/comments/${queryArg.commentId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      updateContractTaskComment: build.mutation<
        UpdateContractTaskCommentApiResponse,
        UpdateContractTaskCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/task/comments/${queryArg.commentId}`,
          method: "PATCH",
          body: queryArg.updateContractTaskCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      deleteContractTask: build.mutation<
        DeleteContractTaskApiResponse,
        DeleteContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      updateContractTask: build.mutation<
        UpdateContractTaskApiResponse,
        UpdateContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}`,
          method: "PATCH",
          body: queryArg.updateTaskRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listChangesForContractTask: build.query<
        ListChangesForContractTaskApiResponse,
        ListChangesForContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}/changes`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      listCommentsForContractTask: build.query<
        ListCommentsForContractTaskApiResponse,
        ListCommentsForContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}/comments`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractTaskComment: build.mutation<
        CreateContractTaskCommentApiResponse,
        CreateContractTaskCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/tasks/${queryArg.taskId}/comments`,
          method: "POST",
          body: queryArg.createContractTaskCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createContractTextDocument: build.mutation<
        CreateContractTextDocumentApiResponse,
        CreateContractTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/text-documents`,
          method: "POST",
          body: queryArg.createContractTextDocumentRequest,
        }),
        invalidatesTags: ["Contract", "TextDocument"],
      }),
      listTextDocumentsForContract: build.query<
        ListTextDocumentsForContractApiResponse,
        ListTextDocumentsForContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contract/text-documents/${queryArg.contractId}`,
        }),
        providesTags: ["Contract", "TextDocument"],
      }),
      createFencyConversation: build.mutation<
        CreateFencyConversationApiResponse,
        CreateFencyConversationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/conversation`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createExploreMemoriesSession: build.mutation<
        CreateExploreMemoriesSessionApiResponse,
        CreateExploreMemoriesSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/explore-memories-session`,
          method: "POST",
          body: queryArg.createExploreMemoriesSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createFencyFileDownloadSession: build.mutation<
        CreateFencyFileDownloadSessionApiResponse,
        CreateFencyFileDownloadSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/file-download-session`,
          method: "POST",
          body: queryArg.createFencyFileDownloadSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      downloadMultiIfrsReport: build.query<
        DownloadMultiIfrsReportApiResponse,
        DownloadMultiIfrsReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/ifrs-report`,
          params: {
            contractIds: queryArg.contractIds,
          },
        }),
        providesTags: ["Contract"],
      }),
      createMemoryChatSession: build.mutation<
        CreateMemoryChatSessionApiResponse,
        CreateMemoryChatSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/memory-chat-session`,
          method: "POST",
          body: queryArg.createMemoryChatSessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createMemoryDownloadLink: build.mutation<
        CreateMemoryDownloadLinkApiResponse,
        CreateMemoryDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/memory-download-link`,
          method: "POST",
          body: queryArg.createMemoryDownloadLinkRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createContractSearchSession: build.mutation<
        CreateContractSearchSessionApiResponse,
        CreateContractSearchSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/memory-search-session`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContractStatistics: build.query<
        GetContractStatisticsApiResponse,
        GetContractStatisticsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/orgs/${queryArg.orgId}/statistics`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      getContractAutofillContext: build.query<
        GetContractAutofillContextApiResponse,
        GetContractAutofillContextApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/autofill-context`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      cancelSignedDocument: build.mutation<
        CancelSignedDocumentApiResponse,
        CancelSignedDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/cancel-signed-document`,
          method: "POST",
          body: queryArg.cancelSignedDocumentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createUploadForContractDescription: build.mutation<
        CreateUploadForContractDescriptionApiResponse,
        CreateUploadForContractDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      downloadIfrsReport: build.query<
        DownloadIfrsReportApiResponse,
        DownloadIfrsReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/ifrs-report`,
        }),
        providesTags: ["Contract"],
      }),
      getContractMessageAttachmentUpload: build.query<
        GetContractMessageAttachmentUploadApiResponse,
        GetContractMessageAttachmentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/message-attachment-uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      createUploadForContractMessageAttachment: build.mutation<
        CreateUploadForContractMessageAttachmentApiResponse,
        CreateUploadForContractMessageAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/message-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      listContractMessages: build.query<
        ListContractMessagesApiResponse,
        ListContractMessagesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractMessage: build.mutation<
        CreateContractMessageApiResponse,
        CreateContractMessageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages`,
          method: "POST",
          body: queryArg.createContractMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      markContractMessagesRead: build.mutation<
        MarkContractMessagesReadApiResponse,
        MarkContractMessagesReadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages/read`,
          method: "POST",
          body: queryArg.markMessagesReadRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      saveContractMessageAttachment: build.mutation<
        SaveContractMessageAttachmentApiResponse,
        SaveContractMessageAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/messages/save-attachment`,
          method: "POST",
          body: queryArg.saveMessageAttachmentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContractOriginCommunication: build.query<
        GetContractOriginCommunicationApiResponse,
        GetContractOriginCommunicationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/origin-communication`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      deleteContractParticipant: build.mutation<
        DeleteContractParticipantApiResponse,
        DeleteContractParticipantApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/participant`,
          method: "DELETE",
          body: queryArg.deleteContractParticipantRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listParticipantsForContracts: build.query<
        ListParticipantsForContractsApiResponse,
        ListParticipantsForContractsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/participants`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractParticipant: build.mutation<
        CreateContractParticipantApiResponse,
        CreateContractParticipantApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/participants`,
          method: "POST",
          body: queryArg.createContractParticipantRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createContractTask: build.mutation<
        CreateContractTaskApiResponse,
        CreateContractTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/tasks`,
          method: "POST",
          body: queryArg.createContractTaskRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createUploadForContract: build.mutation<
        CreateUploadForContractApiResponse,
        CreateUploadForContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contracts/${queryArg.contractId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getContributingEntityInvite: build.query<
        GetContributingEntityInviteApiResponse,
        GetContributingEntityInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contributing-entities/invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      acceptContributingEntityInvite: build.mutation<
        AcceptContributingEntityInviteApiResponse,
        AcceptContributingEntityInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contributing-entities/invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      declineContributingEntityInvite: build.mutation<
        DeclineContributingEntityInviteApiResponse,
        DeclineContributingEntityInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/contributing-entities/invites/${queryArg.inviteId}/decline`,
          method: "PUT",
          body: queryArg.declineContributingEntityInviteRequestDto,
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      getCpvCodes: build.query<GetCpvCodesApiResponse, GetCpvCodesApiArg>({
        query: () => ({ url: `/api/cpv/codes` }),
        providesTags: ["CPV"],
      }),
      listContractFilterOptions: build.query<
        ListContractFilterOptionsApiResponse,
        ListContractFilterOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/deps/${queryArg.orgId}/contract/filter-options`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContracts: build.query<ListContractsApiResponse, ListContractsApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/deps/${queryArg.orgId}/contracts`,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
            params: {
              title: queryArg.title,
              state: queryArg.state,
              statuses: queryArg.statuses,
              counterparties: queryArg.counterparties,
              owners: queryArg.owners,
              templates: queryArg.templates,
              internalparties: queryArg.internalparties,
              projects: queryArg.projects,
              limit: queryArg.limit,
              skip: queryArg.skip,
            },
          }),
          providesTags: ["Contract"],
        },
      ),
      forceDeliverBid: build.mutation<
        ForceDeliverBidApiResponse,
        ForceDeliverBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dev/bids/${queryArg.bidId}/force-deliver`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      forcePublishEvent: build.mutation<
        ForcePublishEventApiResponse,
        ForcePublishEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/dev/events/${queryArg.eventId}/force-publish`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      skipPastGate: build.mutation<SkipPastGateApiResponse, SkipPastGateApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/dev/events/${queryArg.eventId}/skip-past-gate`,
            method: "POST",
            body: queryArg.skipPastGateRequestDto,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["BidV2", "SourcingEvent"],
        },
      ),
      startDocumentChat: build.mutation<
        StartDocumentChatApiResponse,
        StartDocumentChatApiArg
      >({
        query: (queryArg) => ({
          url: `/api/docs/start-chat`,
          method: "POST",
          body: queryArg.startDocumentChatRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      updateDocumentMeta: build.mutation<
        UpdateDocumentMetaApiResponse,
        UpdateDocumentMetaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/docs/${queryArg.docId}`,
          method: "PUT",
          body: queryArg.updateDocumentMetaRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      getDownloadLink: build.query<
        GetDownloadLinkApiResponse,
        GetDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/docs/${queryArg.docId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Document"],
      }),
      listDocumentTemplates: build.query<
        ListDocumentTemplatesApiResponse,
        ListDocumentTemplatesApiArg
      >({
        query: () => ({ url: `/api/document-template/text-documents` }),
        providesTags: ["TextDocument"],
      }),
      createDocumentTemplate: build.mutation<
        CreateDocumentTemplateApiResponse,
        CreateDocumentTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-template/text-documents`,
          method: "POST",
          body: queryArg.createDocumentTemplateRequest,
        }),
        invalidatesTags: ["TextDocument"],
      }),
      createBulkFencySession: build.mutation<
        CreateBulkFencySessionApiResponse,
        CreateBulkFencySessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/documents/fency-sessions`,
          method: "POST",
          body: queryArg.createBulkFencySessionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      createFencyStreamSession: build.mutation<
        CreateFencyStreamSessionApiResponse,
        CreateFencyStreamSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/documents/stream-sessions`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      createFencyDocumentSession: build.mutation<
        CreateFencyDocumentSessionApiResponse,
        CreateFencyDocumentSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/documents/${queryArg.id}/fency-session`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      fencySyncDocument: build.mutation<
        FencySyncDocumentApiResponse,
        FencySyncDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/documents/${queryArg.id}/trigger-fency-memory-sync`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      submitDoffinNotice: build.mutation<
        SubmitDoffinNoticeApiResponse,
        SubmitDoffinNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin", "SourcingEvent"],
      }),
      validateDoffinNotice: build.mutation<
        ValidateDoffinNoticeApiResponse,
        ValidateDoffinNoticeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/doffin/${queryArg.sourcingEventId}/validate`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Doffin"],
      }),
      downloadTextDocument: build.mutation<
        DownloadTextDocumentApiResponse,
        DownloadTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/download/text-documents`,
          method: "POST",
          body: queryArg.downloadTextDocumentRequest,
        }),
        invalidatesTags: ["TextDocument"],
      }),
      updateEmailStatus: build.mutation<
        UpdateEmailStatusApiResponse,
        UpdateEmailStatusApiArg
      >({
        query: () => ({ url: `/api/email/status/events`, method: "POST" }),
        invalidatesTags: ["Misc"],
      }),
      getSeV2AttachmentDownloadLink: build.query<
        GetSeV2AttachmentDownloadLinkApiResponse,
        GetSeV2AttachmentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/events/${queryArg.eventId}/qa-attachments/${queryArg.documentId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      confirmFencyEvent: build.mutation<
        ConfirmFencyEventApiResponse,
        ConfirmFencyEventApiArg
      >({
        query: () => ({ url: `/api/fency/events`, method: "POST" }),
        invalidatesTags: ["Document"],
      }),
      markUploadFailed: build.mutation<
        MarkUploadFailedApiResponse,
        MarkUploadFailedApiArg
      >({
        query: () => ({
          url: `/api/file-uploads/failed-upload-webhook`,
          method: "POST",
        }),
        invalidatesTags: ["Upload"],
      }),
      confirmUpload: build.mutation<
        ConfirmUploadApiResponse,
        ConfirmUploadApiArg
      >({
        query: () => ({
          url: `/api/file-uploads/successful-upload-webhook`,
          method: "POST",
        }),
        invalidatesTags: ["Upload"],
      }),
      searchIndustries: build.query<
        SearchIndustriesApiResponse,
        SearchIndustriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/industries`,
          params: {
            name: queryArg.name,
          },
        }),
        providesTags: ["Industry"],
      }),
      listLibraryElements: build.query<
        ListLibraryElementsApiResponse,
        ListLibraryElementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["LibraryElement"],
      }),
      createLibraryElement: build.mutation<
        CreateLibraryElementApiResponse,
        CreateLibraryElementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element`,
          method: "POST",
          body: queryArg.createLibraryElementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["LibraryElement"],
      }),
      updateLibraryElement: build.mutation<
        UpdateLibraryElementApiResponse,
        UpdateLibraryElementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element`,
          method: "PUT",
          body: queryArg.updateLibraryElementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["LibraryElement"],
      }),
      deleteLibraryElement: build.mutation<
        DeleteLibraryElementApiResponse,
        DeleteLibraryElementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/library-element/${queryArg.id}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["LibraryElement"],
      }),
      listMyNotifications: build.query<
        ListMyNotificationsApiResponse,
        ListMyNotificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/notifications`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            unseen: queryArg.unseen,
            unread: queryArg.unread,
          },
        }),
        providesTags: ["Notification"],
      }),
      listOrganizationUsers: build.query<
        ListOrganizationUsersApiResponse,
        ListOrganizationUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/organization-users`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            name: queryArg.name,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Organization"],
      }),
      listOrganizationsForMe: build.query<
        ListOrganizationsForMeApiResponse,
        ListOrganizationsForMeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/orgs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      createOrganizationForMe: build.mutation<
        CreateOrganizationForMeApiResponse,
        CreateOrganizationForMeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/orgs`,
          method: "POST",
          body: queryArg.createOrgRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      markNotificationsAsPeeked: build.mutation<
        MarkNotificationsAsPeekedApiResponse,
        MarkNotificationsAsPeekedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/peek/notifications`,
          method: "POST",
          body: queryArg.markNotificationsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Notification"],
      }),
      recordRecentlyViewed: build.mutation<
        RecordRecentlyViewedApiResponse,
        RecordRecentlyViewedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/recently-viewed`,
          method: "POST",
          body: queryArg.recordRecentlyViewedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Home"],
      }),
      listMyRecentlyViewedContracts: build.query<
        ListMyRecentlyViewedContractsApiResponse,
        ListMyRecentlyViewedContractsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/recently-viewed/contracts`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Home"],
      }),
      listMyRecentlyViewedSourcingEvents: build.query<
        ListMyRecentlyViewedSourcingEventsApiResponse,
        ListMyRecentlyViewedSourcingEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/recently-viewed/sourcing-events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Home"],
      }),
      listMyUpcomingDeadlines: build.query<
        ListMyUpcomingDeadlinesApiResponse,
        ListMyUpcomingDeadlinesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/upcoming-deadlines`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            withinDays: queryArg.withinDays,
            overdueDays: queryArg.overdueDays,
            upcomingLimit: queryArg.upcomingLimit,
            overdueLimit: queryArg.overdueLimit,
          },
        }),
        providesTags: ["Home"],
      }),
      markNotificationsAsViewed: build.mutation<
        MarkNotificationsAsViewedApiResponse,
        MarkNotificationsAsViewedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/me/view/notifications`,
          method: "POST",
          body: queryArg.markNotificationsRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Notification"],
      }),
      createNeed: build.mutation<CreateNeedApiResponse, CreateNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need`,
          method: "POST",
          body: queryArg.createNeedRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      createNeedTextDocument: build.mutation<
        CreateNeedTextDocumentApiResponse,
        CreateNeedTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/text-documents`,
          method: "POST",
          body: queryArg.createNeedTextDocumentRequest,
        }),
        invalidatesTags: ["Need", "TextDocument"],
      }),
      listTextDocumentsForNeed: build.query<
        ListTextDocumentsForNeedApiResponse,
        ListTextDocumentsForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/text-documents/${queryArg.needId}`,
        }),
        providesTags: ["Need", "TextDocument"],
      }),
      getNeed: build.query<GetNeedApiResponse, GetNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Need"],
      }),
      updateNeed: build.mutation<UpdateNeedApiResponse, UpdateNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}`,
          method: "PATCH",
          body: queryArg.needPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      createProcurementForNeed: build.mutation<
        CreateProcurementForNeedApiResponse,
        CreateProcurementForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}/create-procurement`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      submitNeed: build.mutation<SubmitNeedApiResponse, SubmitNeedApiArg>({
        query: (queryArg) => ({
          url: `/api/need/${queryArg.needId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Need"],
      }),
      listNeeds: build.query<ListNeedsApiResponse, ListNeedsApiArg>({
        query: (queryArg) => ({
          url: `/api/needs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            status: queryArg.status,
          },
        }),
        providesTags: ["Need"],
      }),
      createUploadForNeed: build.mutation<
        CreateUploadForNeedApiResponse,
        CreateUploadForNeedApiArg
      >({
        query: (queryArg) => ({
          url: `/api/needs/${queryArg.needId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createNegotiationTextDocument: build.mutation<
        CreateNegotiationTextDocumentApiResponse,
        CreateNegotiationTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/negotiation/text-documents`,
          method: "POST",
          body: queryArg.createNegotiationTextDocumentRequest,
        }),
        invalidatesTags: ["SourcingEvent", "TextDocument"],
      }),
      listTextDocumentsForNegotiationRound: build.query<
        ListTextDocumentsForNegotiationRoundApiResponse,
        ListTextDocumentsForNegotiationRoundApiArg
      >({
        query: (queryArg) => ({
          url: `/api/negotiation/text-documents/${queryArg.negotiationRoundId}`,
        }),
        providesTags: ["TextDocument"],
      }),
      getAccessToken: build.mutation<
        GetAccessTokenApiResponse,
        GetAccessTokenApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/access-token`,
          method: "POST",
          body: queryArg.getAccessTokenRequest,
        }),
        invalidatesTags: ["Organization"],
      }),
      searchBrregOrgsByName: build.query<
        SearchBrregOrgsByNameApiResponse,
        SearchBrregOrgsByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/brreg/search`,
          params: {
            query: queryArg.query,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["Organization"],
      }),
      lookupBrregOrg: build.query<
        LookupBrregOrgApiResponse,
        LookupBrregOrgApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/brreg/${queryArg.organizationNumber}`,
        }),
        providesTags: ["Organization"],
      }),
      listContractsForOrg: build.query<
        ListContractsForOrgApiResponse,
        ListContractsForOrgApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/contracts`,
          params: {
            title: queryArg.title,
            state: queryArg.state,
            statuses: queryArg.statuses,
            counterparties: queryArg.counterparties,
            owners: queryArg.owners,
            templates: queryArg.templates,
            internalparties: queryArg.internalparties,
            projects: queryArg.projects,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Contract"],
      }),
      createApiClient: build.mutation<
        CreateApiClientApiResponse,
        CreateApiClientApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/create-api-client`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      createOrganizationEntry: build.mutation<
        CreateOrganizationEntryApiResponse,
        CreateOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries`,
          method: "POST",
          body: queryArg.createOrganizationEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getOrganizationEntry: build.query<
        GetOrganizationEntryApiResponse,
        GetOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries/${queryArg.entryId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      updateOrganizationEntry: build.mutation<
        UpdateOrganizationEntryApiResponse,
        UpdateOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries/${queryArg.entryId}`,
          method: "PUT",
          body: queryArg.updateOrganizationEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      linkOrganizationEntry: build.mutation<
        LinkOrganizationEntryApiResponse,
        LinkOrganizationEntryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/entries/${queryArg.entryId}/link`,
          method: "PUT",
          body: queryArg.linkOrganizationEntryRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getSupplierEmailInvite: build.query<
        GetSupplierEmailInviteApiResponse,
        GetSupplierEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/supplier-invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      getOrgUserEmailInvite: build.query<
        GetOrgUserEmailInviteApiResponse,
        GetOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/user-invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      acceptOrgUserEmailInvite: build.mutation<
        AcceptOrgUserEmailInviteApiResponse,
        AcceptOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/org/user-invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      listAssessmentTemplates: build.query<
        ListAssessmentTemplatesApiResponse,
        ListAssessmentTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/assessment-templates`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Assessment"],
      }),
      updateAssessment: build.mutation<
        UpdateAssessmentApiResponse,
        UpdateAssessmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/assessments/${queryArg.id}`,
          method: "PUT",
          body: queryArg.updateAssessmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Assessment"],
      }),
      listAssessments: build.query<
        ListAssessmentsApiResponse,
        ListAssessmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/assessments/${queryArg.orgId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Assessment"],
      }),
      listOrgsByNumber: build.query<
        ListOrgsByNumberApiResponse,
        ListOrgsByNumberApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/by-number`,
          params: {
            country: queryArg.country,
            number: queryArg["number"],
          },
        }),
        providesTags: ["Organization"],
      }),
      updateOrganization: build.mutation<
        UpdateOrganizationApiResponse,
        UpdateOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}`,
          method: "PATCH",
          body: queryArg.editOrganizationRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listAccessGrants: build.query<
        ListAccessGrantsApiResponse,
        ListAccessGrantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/access-grants`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.headerPersonId,
          },
          params: {
            personId: queryArg.queryPersonId,
            departmentId: queryArg.departmentId,
          },
        }),
        providesTags: ["Organization"],
      }),
      listDepartments: build.query<
        ListDepartmentsApiResponse,
        ListDepartmentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      createDepartment: build.mutation<
        CreateDepartmentApiResponse,
        CreateDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments`,
          method: "POST",
          body: queryArg.departmentNameRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      renameDepartment: build.mutation<
        RenameDepartmentApiResponse,
        RenameDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}`,
          method: "PATCH",
          body: queryArg.departmentNameRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      activateDepartment: build.mutation<
        ActivateDepartmentApiResponse,
        ActivateDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/activate`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      deactivateDepartment: build.mutation<
        DeactivateDepartmentApiResponse,
        DeactivateDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/deactivate`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      assignDepartmentRole: build.mutation<
        AssignDepartmentRoleApiResponse,
        AssignDepartmentRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/roles`,
          method: "POST",
          body: queryArg.departmentRoleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      revokeDepartmentRole: build.mutation<
        RevokeDepartmentRoleApiResponse,
        RevokeDepartmentRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/departments/${queryArg.departmentId}/roles/revoke`,
          method: "POST",
          body: queryArg.departmentRoleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listEntraConnections: build.query<
        ListEntraConnectionsApiResponse,
        ListEntraConnectionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      createEntraConnection: build.mutation<
        CreateEntraConnectionApiResponse,
        CreateEntraConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections`,
          method: "POST",
          body: queryArg.createEntraConnectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      deleteEntraConnection: build.mutation<
        DeleteEntraConnectionApiResponse,
        DeleteEntraConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      updateEntraConnection: build.mutation<
        UpdateEntraConnectionApiResponse,
        UpdateEntraConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}`,
          method: "PUT",
          body: queryArg.updateEntraConnectionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      saveEntraGroupMapping: build.mutation<
        SaveEntraGroupMappingApiResponse,
        SaveEntraGroupMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}/mappings`,
          method: "PUT",
          body: queryArg.saveEntraGroupMappingRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      deleteEntraGroupMapping: build.mutation<
        DeleteEntraGroupMappingApiResponse,
        DeleteEntraGroupMappingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/entra/connections/${queryArg.connectionId}/mappings/${queryArg.mappingId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      getOrganization: build.query<
        GetOrganizationApiResponse,
        GetOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/public-profile`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Organization"],
      }),
      listSupplierEmailInvites: build.query<
        ListSupplierEmailInvitesApiResponse,
        ListSupplierEmailInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      createSupplierEmailInvite: build.mutation<
        CreateSupplierEmailInviteApiResponse,
        CreateSupplierEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites`,
          method: "POST",
          body: queryArg.createEmailInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deleteSupplierEmailInvite: build.mutation<
        DeleteSupplierEmailInviteApiResponse,
        DeleteSupplierEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites/${queryArg.inviteId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      createSupplierEmailInviteReminder: build.mutation<
        CreateSupplierEmailInviteReminderApiResponse,
        CreateSupplierEmailInviteReminderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/supplier-invites/${queryArg.inviteId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      updateOrganizationTenant: build.mutation<
        UpdateOrganizationTenantApiResponse,
        UpdateOrganizationTenantApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/tenant`,
          method: "PUT",
          body: queryArg.updateOrgTenantRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listOrgUserEmailInvites: build.query<
        ListOrgUserEmailInvitesApiResponse,
        ListOrgUserEmailInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/user-invites`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      createOrgUserEmailInvite: build.mutation<
        CreateOrgUserEmailInviteApiResponse,
        CreateOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/user-invites`,
          method: "POST",
          body: queryArg.createOrgUserEmailInviteRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deleteOrgUserEmailInvite: build.mutation<
        DeleteOrgUserEmailInviteApiResponse,
        DeleteOrgUserEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/user-invites/${queryArg.inviteId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deleteOrgUser: build.mutation<
        DeleteOrgUserApiResponse,
        DeleteOrgUserApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/users/${queryArg.userId}`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      updateOrgUserRole: build.mutation<
        UpdateOrgUserRoleApiResponse,
        UpdateOrgUserRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/orgs/${queryArg.orgId}/users/${queryArg.userId}/role`,
          method: "PUT",
          body: queryArg.updateOrgUserRoleRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Organization"],
      }),
      listContractTasksForOrganization: build.query<
        ListContractTasksForOrganizationApiResponse,
        ListContractTasksForOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/tasks`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            limit: queryArg.limit,
            statuses: queryArg.statuses,
            personIds: queryArg.personIds,
            contractIds: queryArg.contractIds,
            sortBy: queryArg.sortBy,
          },
        }),
        providesTags: ["Contract"],
      }),
      listContractTemplates: build.query<
        ListContractTemplatesApiResponse,
        ListContractTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/templates`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            contractId: queryArg.contractId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContractTemplate: build.mutation<
        CreateContractTemplateApiResponse,
        CreateContractTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/orgs/${queryArg.orgId}/templates`,
          method: "POST",
          body: queryArg.upsertContractTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getTask: build.query<GetTaskApiResponse, GetTaskApiArg>({
        query: (queryArg) => ({
          url: `/api/owner/contract/tasks/${queryArg.taskId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      updateContractTemplate: build.mutation<
        UpdateContractTemplateApiResponse,
        UpdateContractTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contract/templates/${queryArg.templateId}`,
          method: "PATCH",
          body: queryArg.upsertContractTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      getContract: build.query<GetContractApiResponse, GetContractApiArg>({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      updateContract: build.mutation<
        UpdateContractApiResponse,
        UpdateContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}`,
          method: "POST",
          body: queryArg.updateContractRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      copyContract: build.mutation<CopyContractApiResponse, CopyContractApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/owner/contracts/${queryArg.contractId}/copy`,
            method: "POST",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["Contract"],
        },
      ),
      publishContract: build.mutation<
        PublishContractApiResponse,
        PublishContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/publishing`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createSignedDocument: build.mutation<
        CreateSignedDocumentApiResponse,
        CreateSignedDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/signed-documents`,
          method: "POST",
          body: queryArg.createSignedDocumentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      createSignedTextDocument: build.mutation<
        CreateSignedTextDocumentApiResponse,
        CreateSignedTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/signed-text-documents`,
          method: "POST",
          body: queryArg.createSignedTextDocumentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listContractTasks: build.query<
        ListContractTasksApiResponse,
        ListContractTasksApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/contracts/${queryArg.contractId}/tasks`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Contract"],
      }),
      createContract: build.mutation<
        CreateContractApiResponse,
        CreateContractApiArg
      >({
        query: (queryArg) => ({
          url: `/api/owner/deps/${queryArg.depId}/contracts`,
          method: "POST",
          body: queryArg.createContractRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Contract"],
      }),
      listPersons: build.query<ListPersonsApiResponse, ListPersonsApiArg>({
        query: (queryArg) => ({
          url: `/api/persons`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            orgIds: queryArg.orgIds,
            name: queryArg.name,
            roles: queryArg.roles,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Organization"],
      }),
      getPersonsByIds: build.query<
        GetPersonsByIdsApiResponse,
        GetPersonsByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/persons-by-ids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            personIds: queryArg.personIds,
          },
        }),
        providesTags: ["Organization"],
      }),
      getMe: build.query<GetMeApiResponse, GetMeApiArg>({
        query: (queryArg) => ({
          url: `/api/persons/me`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Me"],
      }),
      updateMe: build.mutation<UpdateMeApiResponse, UpdateMeApiArg>({
        query: (queryArg) => ({
          url: `/api/persons/me`,
          method: "PATCH",
          body: queryArg.editMeRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Me"],
      }),
      getBidV2: build.query<GetBidV2ApiResponse, GetBidV2ApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      updateBidV2: build.mutation<UpdateBidV2ApiResponse, UpdateBidV2ApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}`,
          method: "PUT",
          body: queryArg.bidV2PatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      listContributingEntities: build.query<
        ListContributingEntitiesApiResponse,
        ListContributingEntitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      addContributingEntity: build.mutation<
        AddContributingEntityApiResponse,
        AddContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities`,
          method: "POST",
          body: queryArg.addContributingEntityRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      removeContributingEntity: build.mutation<
        RemoveContributingEntityApiResponse,
        RemoveContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      getContributingEntityResponse: build.query<
        GetContributingEntityResponseApiResponse,
        GetContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      updateContributingEntity: build.mutation<
        UpdateContributingEntityApiResponse,
        UpdateContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}`,
          method: "PUT",
          body: queryArg.updateContributingEntityRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      resendContributingEntityInvitation: build.mutation<
        ResendContributingEntityInvitationApiResponse,
        ResendContributingEntityInvitationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}/reminders`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      reopenContributingEntityResponse: build.mutation<
        ReopenContributingEntityResponseApiResponse,
        ReopenContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/contributing-entities/${queryArg.entityId}/reopen`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      previewBidV2Report: build.query<
        PreviewBidV2ReportApiResponse,
        PreviewBidV2ReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/report`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      startBidV2Signing: build.mutation<
        StartBidV2SigningApiResponse,
        StartBidV2SigningApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/signing`,
          method: "POST",
          body: queryArg.startBidV2SigningRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      cancelBidV2Signing: build.mutation<
        CancelBidV2SigningApiResponse,
        CancelBidV2SigningApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/signing/cancel`,
          method: "POST",
          body: queryArg.cancelBidV2SigningRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getBidV2SigningPreflight: build.query<
        GetBidV2SigningPreflightApiResponse,
        GetBidV2SigningPreflightApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/signing/preflight`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      acceptBidTerms: build.mutation<
        AcceptBidTermsApiResponse,
        AcceptBidTermsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/terms`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      createUploadForBidV2: build.mutation<
        CreateUploadForBidV2ApiResponse,
        CreateUploadForBidV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      withdrawBidV2: build.mutation<
        WithdrawBidV2ApiResponse,
        WithdrawBidV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/bids/${queryArg.bidId}/withdraw`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getContributingEntity: build.query<
        GetContributingEntityApiResponse,
        GetContributingEntityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      updateContributingEntityResponse: build.mutation<
        UpdateContributingEntityResponseApiResponse,
        UpdateContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}`,
          method: "PUT",
          body: queryArg.updateContributingEntityResponseRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      updateContributingEntityCommitment: build.mutation<
        UpdateContributingEntityCommitmentApiResponse,
        UpdateContributingEntityCommitmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}/commitment`,
          method: "PUT",
          body: queryArg.updateContributingEntityCommitmentRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      updateContributingEntityQualificationResponses: build.mutation<
        UpdateContributingEntityQualificationResponsesApiResponse,
        UpdateContributingEntityQualificationResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}/qualification-responses`,
          method: "PUT",
          body: queryArg.updateContributingEntityQualificationResponsesRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      submitContributingEntityResponse: build.mutation<
        SubmitContributingEntityResponseApiResponse,
        SubmitContributingEntityResponseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/contributing-entities/${queryArg.entityId}/response`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["ContributingEntity"],
      }),
      getPortalSourcingEvents: build.query<
        GetPortalSourcingEventsApiResponse,
        GetPortalSourcingEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events`,
          params: {
            cursor: queryArg.cursor,
            limit: queryArg.limit,
            q: queryArg.q,
            lifecycle: queryArg.lifecycle,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalSourcingEvent: build.query<
        GetPortalSourcingEventApiResponse,
        GetPortalSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalSeV2AttachmentUpload: build.query<
        GetPortalSeV2AttachmentUploadApiResponse,
        GetPortalSeV2AttachmentUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/attachment-uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      getPortalAwardLetter: build.query<
        GetPortalAwardLetterApiResponse,
        GetPortalAwardLetterApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/award-letter`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createBidV2: build.mutation<CreateBidV2ApiResponse, CreateBidV2ApiArg>({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/bids`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getPortalDocumentDownloadLink: build.query<
        GetPortalDocumentDownloadLinkApiResponse,
        GetPortalDocumentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/documents/${queryArg.documentId}/link`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalMyBidDocuments: build.query<
        GetPortalMyBidDocumentsApiResponse,
        GetPortalMyBidDocumentsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/my-bid-documents`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createParticipationRequest: build.mutation<
        CreateParticipationRequestApiResponse,
        CreateParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/participation-requests`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      getMyParticipation: build.query<
        GetMyParticipationApiResponse,
        GetMyParticipationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/participation-requests/mine`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      createUploadForSeV2QuestionAttachment: build.mutation<
        CreateUploadForSeV2QuestionAttachmentApiResponse,
        CreateUploadForSeV2QuestionAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/question-attachment-uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getPortalSeV2Questions: build.query<
        GetPortalSeV2QuestionsApiResponse,
        GetPortalSeV2QuestionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/questions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      askSeV2Question: build.mutation<
        AskSeV2QuestionApiResponse,
        AskSeV2QuestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/questions`,
          method: "POST",
          body: queryArg.createSeV2QuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      sendSeV2ClarificationMessageAsSupplier: build.mutation<
        SendSeV2ClarificationMessageAsSupplierApiResponse,
        SendSeV2ClarificationMessageAsSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/questions/${queryArg.questionId}/messages`,
          method: "POST",
          body: queryArg.createSeV2QuestionMessageRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      registerPortalInterest: build.mutation<
        RegisterPortalInterestApiResponse,
        RegisterPortalInterestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/register-interest`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPortalRegistrationStatus: build.query<
        GetPortalRegistrationStatusApiResponse,
        GetPortalRegistrationStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/registration-status`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getPortalSupplierInformation: build.query<
        GetPortalSupplierInformationApiResponse,
        GetPortalSupplierInformationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/events/${queryArg.eventId}/supplier-information`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getAuthenticatedPortalSourcingEvents: build.query<
        GetAuthenticatedPortalSourcingEventsApiResponse,
        GetAuthenticatedPortalSourcingEventsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            cursor: queryArg.cursor,
            limit: queryArg.limit,
            q: queryArg.q,
            context: queryArg.context,
            scope: queryArg.scope,
            lifecycle: queryArg.lifecycle,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getAuthenticatedPortalSourcingEvent: build.query<
        GetAuthenticatedPortalSourcingEventApiResponse,
        GetAuthenticatedPortalSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      acceptPortalInvite: build.mutation<
        AcceptPortalInviteApiResponse,
        AcceptPortalInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/accept-invite`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createPortalInitialBid: build.mutation<
        CreatePortalInitialBidApiResponse,
        CreatePortalInitialBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/bids`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      submitPortalPrivateBid: build.mutation<
        SubmitPortalPrivateBidApiResponse,
        SubmitPortalPrivateBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/bids/${queryArg.bidId}/submission`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      withdrawPortalPrivateBid: build.mutation<
        WithdrawPortalPrivateBidApiResponse,
        WithdrawPortalPrivateBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/bids/${queryArg.bidId}/withdrawal`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2", "SourcingEvent"],
      }),
      declinePortalInvite: build.mutation<
        DeclinePortalInviteApiResponse,
        DeclinePortalInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/decline-invite`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPortalNegotiationRounds: build.query<
        GetPortalNegotiationRoundsApiResponse,
        GetPortalNegotiationRoundsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createPortalRoundBid: build.mutation<
        CreatePortalRoundBidApiResponse,
        CreatePortalRoundBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/me/events/${queryArg.eventId}/negotiation-rounds/${queryArg.roundId}/bids`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      getPortalMyBids: build.query<
        GetPortalMyBidsApiResponse,
        GetPortalMyBidsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/my-bids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      listMyContributions: build.query<
        ListMyContributionsApiResponse,
        ListMyContributionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/my-contributions`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["ContributingEntity"],
      }),
      listMyParticipationRequests: build.query<
        ListMyParticipationRequestsApiResponse,
        ListMyParticipationRequestsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      getParticipationRequest: build.query<
        GetParticipationRequestApiResponse,
        GetParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["BidV2"],
      }),
      updateParticipationRequest: build.mutation<
        UpdateParticipationRequestApiResponse,
        UpdateParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}`,
          method: "PUT",
          body: queryArg.participationRequestPatchDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      submitParticipationRequest: build.mutation<
        SubmitParticipationRequestApiResponse,
        SubmitParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}/submit`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      withdrawParticipationRequest: build.mutation<
        WithdrawParticipationRequestApiResponse,
        WithdrawParticipationRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/participation-requests/${queryArg.requestId}/withdraw`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["BidV2"],
      }),
      editProductGroup: build.mutation<
        EditProductGroupApiResponse,
        EditProductGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/group`,
          method: "PATCH",
          body: queryArg.editProductGroupDto,
        }),
        invalidatesTags: ["Product", "SourcingEvent"],
      }),
      createProductGroup: build.mutation<
        CreateProductGroupApiResponse,
        CreateProductGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/group`,
          method: "POST",
          body: queryArg.createProductGroupDto,
        }),
        invalidatesTags: ["Product", "SourcingEvent"],
      }),
      deleteProductGroup: build.mutation<
        DeleteProductGroupApiResponse,
        DeleteProductGroupApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/group/${queryArg.productGroupId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Product", "SourcingEvent"],
      }),
      getProductGroupsForProject: build.query<
        GetProductGroupsForProjectApiResponse,
        GetProductGroupsForProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/products/project/groups/${queryArg.projectId}`,
        }),
        providesTags: ["Product", "Project"],
      }),
      getProductTemplates: build.query<
        GetProductTemplatesApiResponse,
        GetProductTemplatesApiArg
      >({
        query: () => ({ url: `/api/products/templates` }),
        providesTags: ["Product"],
      }),
      createProject: build.mutation<
        CreateProjectApiResponse,
        CreateProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project`,
          method: "POST",
          body: queryArg.createProjectRequest,
        }),
        invalidatesTags: ["Project"],
      }),
      createProjectTextDocument: build.mutation<
        CreateProjectTextDocumentApiResponse,
        CreateProjectTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project/text-document`,
          method: "POST",
          body: queryArg.createProjectTextDocumentRequest,
        }),
        invalidatesTags: ["Project", "TextDocument"],
      }),
      listTextDocumentsForProject: build.query<
        ListTextDocumentsForProjectApiResponse,
        ListTextDocumentsForProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project/text-documents/${queryArg.projectId}`,
        }),
        providesTags: ["Project", "TextDocument"],
      }),
      getProject: build.query<GetProjectApiResponse, GetProjectApiArg>({
        query: (queryArg) => ({ url: `/api/project/${queryArg.projectId}` }),
        providesTags: ["Project"],
      }),
      updateProject: build.mutation<
        UpdateProjectApiResponse,
        UpdateProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/project/${queryArg.projectId}`,
          method: "PATCH",
          body: queryArg.projectPatchDto,
        }),
        invalidatesTags: ["Project"],
      }),
      getProjects: build.query<GetProjectsApiResponse, GetProjectsApiArg>({
        query: (queryArg) => ({
          url: `/api/projects`,
          params: {
            name: queryArg.name,
            status: queryArg.status,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["Project"],
      }),
      getProjectsByIds: build.query<
        GetProjectsByIdsApiResponse,
        GetProjectsByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects-by-ids`,
          params: {
            projectIds: queryArg.projectIds,
          },
        }),
        providesTags: ["Project"],
      }),
      createUploadForProjectDescription: build.mutation<
        CreateUploadForProjectDescriptionApiResponse,
        CreateUploadForProjectDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${queryArg.projectId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForProject: build.mutation<
        CreateUploadForProjectApiResponse,
        CreateUploadForProjectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${queryArg.projectId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getGroups: build.query<GetGroupsApiResponse, GetGroupsApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups`,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      createGroup: build.mutation<CreateGroupApiResponse, CreateGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups`,
          method: "POST",
          body: queryArg.createGroupDto,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      deleteGroup: build.mutation<DeleteGroupApiResponse, DeleteGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups/${queryArg.groupId}`,
          method: "DELETE",
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      getGroup: build.query<GetGroupApiResponse, GetGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups/${queryArg.groupId}`,
          headers: {
            authorization: queryArg.authorization,
          },
          params: {
            count: queryArg.count,
            startIndex: queryArg.startIndex,
          },
        }),
        providesTags: ["Scim"],
      }),
      updateGroup: build.mutation<UpdateGroupApiResponse, UpdateGroupApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Groups/${queryArg.groupId}`,
          method: "PATCH",
          body: queryArg.updateGroupRequest,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      getSchemas: build.query<GetSchemasApiResponse, GetSchemasApiArg>({
        query: () => ({ url: `/api/scim/Schemas` }),
        providesTags: ["Scim"],
      }),
      getToken: build.query<GetTokenApiResponse, GetTokenApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Token`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      getTokenForConnection: build.query<
        GetTokenForConnectionApiResponse,
        GetTokenForConnectionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/scim/Token/${queryArg.connectionId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users`,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      createUser: build.mutation<CreateUserApiResponse, CreateUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users`,
          method: "POST",
          body: queryArg.createUserDto,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users/${queryArg.userId}`,
          method: "DELETE",
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      getUser: build.query<GetUserApiResponse, GetUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users/${queryArg.userId}`,
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        providesTags: ["Scim"],
      }),
      updateUser: build.mutation<UpdateUserApiResponse, UpdateUserApiArg>({
        query: (queryArg) => ({
          url: `/api/scim/Users/${queryArg.userId}`,
          method: "PATCH",
          headers: {
            authorization: queryArg.authorization,
          },
        }),
        invalidatesTags: ["Scim"],
      }),
      searchOrganizationsAndEntries: build.query<
        SearchOrganizationsAndEntriesApiResponse,
        SearchOrganizationsAndEntriesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/search/orgs`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            name: queryArg.name,
            organizationNumber: queryArg.organizationNumber,
            limit: queryArg.limit,
            skip: queryArg.skip,
            type: queryArg["type"],
            excludeLinkedEntries: queryArg.excludeLinkedEntries,
          },
        }),
        providesTags: ["Organization", "Search"],
      }),
      updateSignedDocumentMeta: build.mutation<
        UpdateSignedDocumentMetaApiResponse,
        UpdateSignedDocumentMetaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.docId}`,
          method: "PUT",
          body: queryArg.updateSignedDocumentMetaRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      getSignedDocumentDownloadLink: build.query<
        GetSignedDocumentDownloadLinkApiResponse,
        GetSignedDocumentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.docId}/link`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Document"],
      }),
      getSignedAttachmentDownloadLink: build.query<
        GetSignedAttachmentDownloadLinkApiResponse,
        GetSignedAttachmentDownloadLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.docId}/link/${queryArg.attachmentId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Document"],
      }),
      createFencySignedDocumentSession: build.mutation<
        CreateFencySignedDocumentSessionApiResponse,
        CreateFencySignedDocumentSessionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.id}/fency-session`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      fencySyncSignedDocument: build.mutation<
        FencySyncSignedDocumentApiResponse,
        FencySyncSignedDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/signed/docs/${queryArg.id}/trigger-fency-memory-sync`,
          method: "POST",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Document"],
      }),
      listSourcingEventTemplates: build.query<
        ListSourcingEventTemplatesApiResponse,
        ListSourcingEventTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEventTemplate"],
      }),
      createSourcingEventTemplate: build.mutation<
        CreateSourcingEventTemplateApiResponse,
        CreateSourcingEventTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template`,
          method: "POST",
          body: queryArg.createSourcingEventTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEventTemplate"],
      }),
      updateSourcingEventTemplate: build.mutation<
        UpdateSourcingEventTemplateApiResponse,
        UpdateSourcingEventTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template`,
          method: "PUT",
          body: queryArg.updateSourcingEventTemplateRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEventTemplate"],
      }),
      deleteSourcingEventTemplate: build.mutation<
        DeleteSourcingEventTemplateApiResponse,
        DeleteSourcingEventTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-template/${queryArg.id}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEventTemplate"],
      }),
      createSourcingEventV2TextDocument: build.mutation<
        CreateSourcingEventV2TextDocumentApiResponse,
        CreateSourcingEventV2TextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-v2/text-documents`,
          method: "POST",
          body: queryArg.createSourcingEventV2TextDocumentRequest,
        }),
        invalidatesTags: ["SourcingEvent", "TextDocument"],
      }),
      listTextDocumentsForSourcingEventV2: build.query<
        ListTextDocumentsForSourcingEventV2ApiResponse,
        ListTextDocumentsForSourcingEventV2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event-v2/text-documents/${queryArg.eventId}`,
        }),
        providesTags: ["SourcingEvent", "TextDocument"],
      }),
      createSourcingEventTextDocument: build.mutation<
        CreateSourcingEventTextDocumentApiResponse,
        CreateSourcingEventTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event/text-documents`,
          method: "POST",
          body: queryArg.createSourcingEventTextDocumentRequest,
        }),
        invalidatesTags: ["SourcingEvent", "TextDocument"],
      }),
      listTextDocumentsForSourcingEvent: build.query<
        ListTextDocumentsForSourcingEventApiResponse,
        ListTextDocumentsForSourcingEventApiArg
      >({
        query: (queryArg) => ({
          url: `/api/sourcing-event/text-documents/${queryArg.eventId}`,
        }),
        providesTags: ["TextDocument"],
      }),
      getBseBid: build.query<GetBseBidApiResponse, GetBseBidApiArg>({
        query: (queryArg) => ({
          url: `/api/supplier/basic/bids/${queryArg.bidId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Bid"],
      }),
      updateBseBid: build.mutation<UpdateBseBidApiResponse, UpdateBseBidApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/supplier/basic/bids/${queryArg.bidId}`,
            method: "PATCH",
            body: queryArg.editBidRequest,
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["Bid"],
        },
      ),
      createUploadForBseBidDescription: build.mutation<
        CreateUploadForBseBidDescriptionApiResponse,
        CreateUploadForBseBidDescriptionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/bids/${queryArg.bidId}/description/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForBseBid: build.mutation<
        CreateUploadForBseBidApiResponse,
        CreateUploadForBseBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/bids/${queryArg.bidId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      getBseSupplierView: build.query<
        GetBseSupplierViewApiResponse,
        GetBseSupplierViewApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      createBseAnnouncement: build.mutation<
        CreateBseAnnouncementApiResponse,
        CreateBseAnnouncementApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/announcements`,
          method: "POST",
          body: queryArg.createBseAnnouncementRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      unDeliverBseBid: build.mutation<
        UnDeliverBseBidApiResponse,
        UnDeliverBseBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/bids/${queryArg.bidId}/delivery`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Bid"],
      }),
      acceptInvitationToBid: build.mutation<
        AcceptInvitationToBidApiResponse,
        AcceptInvitationToBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/invites`,
          method: "PATCH",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      declineInvitationToBid: build.mutation<
        DeclineInvitationToBidApiResponse,
        DeclineInvitationToBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/invites/decline`,
          method: "PATCH",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      downloadPublicProcurementProtocolPartOne: build.mutation<
        DownloadPublicProcurementProtocolPartOneApiResponse,
        DownloadPublicProcurementProtocolPartOneApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/public-procurement-protocol-part-one`,
          method: "POST",
          body: queryArg.getProcurementProtocolRequest,
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      downloadQaReport: build.query<
        DownloadQaReportApiResponse,
        DownloadQaReportApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/qa-report`,
        }),
        providesTags: ["SourcingEvent"],
      }),
      createBseQuestionAsSupplier: build.mutation<
        CreateBseQuestionAsSupplierApiResponse,
        CreateBseQuestionAsSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/questions`,
          method: "POST",
          body: queryArg.createBseQuestionRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      createBseQuestionCommentAsSupplier: build.mutation<
        CreateBseQuestionCommentAsSupplierApiResponse,
        CreateBseQuestionCommentAsSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/basic/events/${queryArg.eventId}/questions/${queryArg.questionId}/comments`,
          method: "POST",
          body: queryArg.createBseQuestionCommentRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["SourcingEvent"],
      }),
      markAsViewed: build.mutation<MarkAsViewedApiResponse, MarkAsViewedApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/supplier/basic/events/${queryArg.eventId}/viewing`,
            method: "PUT",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
            params: {
              negotiationRoundId: queryArg.negotiationRoundId,
            },
          }),
          invalidatesTags: ["SourcingEvent"],
        },
      ),
      createDraftBid: build.mutation<
        CreateDraftBidApiResponse,
        CreateDraftBidApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/bids`,
          method: "POST",
          body: queryArg.createDraftBidRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Bid"],
      }),
      deleteBid: build.mutation<DeleteBidApiResponse, DeleteBidApiArg>({
        query: (queryArg) => ({
          url: `/api/supplier/bids/${queryArg.bidId}`,
          method: "DELETE",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Bid"],
      }),
      listBidsCreatedByDepartment: build.query<
        ListBidsCreatedByDepartmentApiResponse,
        ListBidsCreatedByDepartmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/deps/${queryArg.depId}/bids`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Bid"],
      }),
      getSeEmailInvite: build.query<
        GetSeEmailInviteApiResponse,
        GetSeEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/event/invites/${queryArg.inviteId}`,
          params: {
            secret: queryArg.secret,
          },
        }),
        providesTags: ["EmailInvite"],
      }),
      acceptSeEmailInvite: build.mutation<
        AcceptSeEmailInviteApiResponse,
        AcceptSeEmailInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/event/invites/${queryArg.inviteId}/acceptance`,
          method: "PUT",
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            secret: queryArg.secret,
          },
        }),
        invalidatesTags: ["EmailInvite"],
      }),
      deliverBid: build.mutation<DeliverBidApiResponse, DeliverBidApiArg>({
        query: (queryArg) => ({
          url: `/api/supplier/events/bids/delivery`,
          method: "PUT",
          body: queryArg.deliverBidRequest,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Bid"],
      }),
      listSeSupplierViews: build.query<
        ListSeSupplierViewsApiResponse,
        ListSeSupplierViewsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/orgs/${queryArg.orgId}/events`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
          params: {
            statuses: queryArg.statuses,
          },
        }),
        providesTags: ["SourcingEvent"],
      }),
      getProductGroupsAsSupplier: build.query<
        GetProductGroupsAsSupplierApiResponse,
        GetProductGroupsAsSupplierApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/products/sourcing/groups/${queryArg.sourcingEventId}`,
        }),
        providesTags: ["Product", "SourcingEvent"],
      }),
      createUploadForBidV2AwardCriterionAttachment: build.mutation<
        CreateUploadForBidV2AwardCriterionAttachmentApiResponse,
        CreateUploadForBidV2AwardCriterionAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/public/bids/${queryArg.bidId}/award-criterion-attachments/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createBidV2AwardCriterionAttachmentUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForBidV2MinimumRequirementAttachment: build.mutation<
        CreateUploadForBidV2MinimumRequirementAttachmentApiResponse,
        CreateUploadForBidV2MinimumRequirementAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/public/bids/${queryArg.bidId}/minimum-requirement-attachments/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createBidV2MinimumRequirementAttachmentUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      createUploadForBidV2QualificationEvidence: build.mutation<
        CreateUploadForBidV2QualificationEvidenceApiResponse,
        CreateUploadForBidV2QualificationEvidenceApiArg
      >({
        query: (queryArg) => ({
          url: `/api/supplier/public/bids/${queryArg.bidId}/qualification-evidence/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createBidV2QualificationEvidenceUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      updateTextDocument: build.mutation<
        UpdateTextDocumentApiResponse,
        UpdateTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents`,
          method: "PUT",
          body: queryArg.updateTextDocumentRequest,
        }),
        invalidatesTags: ["TextDocument"],
      }),
      deleteTextDocument: build.mutation<
        DeleteTextDocumentApiResponse,
        DeleteTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TextDocument"],
      }),
      getTextDocumentUploadStatus: build.query<
        GetTextDocumentUploadStatusApiResponse,
        GetTextDocumentUploadStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents/${queryArg.textDocumentId}/uploads/${queryArg.uploadId}`,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        providesTags: ["Upload"],
      }),
      createUploadForTextDocument: build.mutation<
        CreateUploadForTextDocumentApiResponse,
        CreateUploadForTextDocumentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/text-documents/${queryArg.textDocumentId}/uploads/${queryArg.uploadId}`,
          method: "POST",
          body: queryArg.createUploadRequestDto,
          headers: {
            cookie: queryArg.cookie,
            organizationId: queryArg.organizationId,
            personId: queryArg.personId,
          },
        }),
        invalidatesTags: ["Upload"],
      }),
      deleteUpload: build.mutation<DeleteUploadApiResponse, DeleteUploadApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/uploads/${queryArg.uploadId}`,
            method: "DELETE",
            headers: {
              cookie: queryArg.cookie,
              organizationId: queryArg.organizationId,
              personId: queryArg.personId,
            },
          }),
          invalidatesTags: ["Upload"],
        },
      ),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bffApi };
export type AdminListAllEntitiesApiResponse = /** status 200 OK */ String;
export type AdminListAllEntitiesApiArg = {
  entityType: AdminEntityType;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AdminMigrateFencyDocumentsApiResponse =
  /** status 200 OK */ AdminMigrateFencyResponse;
export type AdminMigrateFencyDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  adminMigrateFencyRequest: AdminMigrateFencyRequest;
};
export type AdminRestampFencyAccessApiResponse =
  /** status 200 OK */ AdminMigrateFencyResponse;
export type AdminRestampFencyAccessApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  adminRestampFencyAccessRequest: AdminRestampFencyAccessRequest;
};
export type AdminMigrateFencyContractMetadataApiResponse =
  /** status 200 OK */ AdminMigrateFencyResponse;
export type AdminMigrateFencyContractMetadataApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  adminMigrateFencyContractMetadataRequest: AdminMigrateFencyContractMetadataRequest;
};
export type AdminGetFencyMigrationStatsApiResponse =
  /** status 200 OK */ AdminFencyMigrationStatsResponse;
export type AdminGetFencyMigrationStatsApiArg = {
  targetOrganizationId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AdminListOrganizationsApiResponse =
  /** status 200 OK */ AdminListOrganizationsResponse;
export type AdminListOrganizationsApiArg = {
  skip?: number;
  limit?: number;
  name?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type AdminUpdateOrganizationApiResponse = /** status 200 OK */ OrgDto;
export type AdminUpdateOrganizationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  adminUpdateOrganizationRequest: AdminUpdateOrganizationRequest;
};
export type AdminChangeOrganizationOwnerApiResponse =
  /** status 200 OK */ OrgDto;
export type AdminChangeOrganizationOwnerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  adminChangeOrganizationOwnerRequest: AdminChangeOrganizationOwnerRequest;
};
export type SendAiChatMessageApiResponse = /** status 200 OK */ AiChatResponse;
export type SendAiChatMessageApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  aiChatRequest: AiChatRequest;
};
export type CreateAiCompletionApiResponse =
  /** status 200 OK */ AiCompletionDto;
export type CreateAiCompletionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAiCompletionRequest: CreateAiCompletionRequest;
};
export type CreateAssessmentTemplateApiResponse =
  /** status 201 Created */ AssessmentTemplateDto;
export type CreateAssessmentTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAssessmentTemplateRequestDto: CreateAssessmentTemplateRequestDto;
};
export type GetAssessmentTemplateApiResponse =
  /** status 200 OK */ AssessmentTemplateDto;
export type GetAssessmentTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type CreateAssessmentApiResponse =
  /** status 201 Created */ AssessmentDto;
export type CreateAssessmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAssessmentRequestDto: CreateAssessmentRequestDto;
};
export type GetAssessmentApiResponse = /** status 200 OK */ AssessmentDto;
export type GetAssessmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type GetBaseDataApiResponse = /** status 200 OK */ BaseDataDto;
export type GetBaseDataApiArg = void;
export type GetTypesApiResponse = /** status 200 OK */ AllTypes;
export type GetTypesApiArg = void;
export type RecordAgentAuditEntryApiResponse = unknown;
export type RecordAgentAuditEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  agentAuditEntryDto: AgentAuditEntryDto;
};
export type ListAgentConversationsApiResponse =
  /** status 200 OK */ ListAgentConversationsResponse;
export type ListAgentConversationsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateAgentConversationApiResponse =
  /** status 201 Created */ AgentConversationDto;
export type CreateAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAgentConversationRequest: CreateAgentConversationRequest;
};
export type DeleteAgentConversationApiResponse = unknown;
export type DeleteAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  conversationId: string;
};
export type GetAgentConversationApiResponse =
  /** status 200 OK */ AgentConversationDto;
export type GetAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  conversationId: string;
};
export type UpdateAgentConversationApiResponse =
  /** status 200 OK */ AgentConversationDto;
export type UpdateAgentConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  conversationId: string;
  updateAgentConversationRequest: UpdateAgentConversationRequest;
};
export type CreateAgentDocumentSearchSessionApiResponse =
  /** status 200 OK */ AgentDocumentSearchSessionDto;
export type CreateAgentDocumentSearchSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createAgentDocumentSearchSessionRequest: CreateAgentDocumentSearchSessionRequest;
};
export type ResolveAgentDocumentSourcesApiResponse =
  /** status 200 OK */ AgentDocumentSourcesDto;
export type ResolveAgentDocumentSourcesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  resolveAgentDocumentSourcesRequest: ResolveAgentDocumentSourcesRequest;
};
export type GetAgentModelsApiResponse = /** status 200 OK */ AgentModelsDto;
export type GetAgentModelsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type PlanAgentTurnApiResponse =
  /** status 200 OK */ AgentPlanResponseDto;
export type PlanAgentTurnApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  agentPlanRequestDto: AgentPlanRequestDto;
};
export type CreateBasicSourcingEventApiResponse = /** status 200 OK */ BseDto;
export type CreateBasicSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  depId: string;
  createSourcingEventRequest: CreateSourcingEventRequest;
};
export type GetNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type GetNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  negotiationId: string;
};
export type GetBasicSourcingEventApiResponse = /** status 200 OK */ BseDto;
export type GetBasicSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateBasicSourcingEventApiResponse = /** status 200 OK */ BseDto;
export type UpdateBasicSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  editSourcingEventRequest: EditSourcingEventRequest;
};
export type AwardToBidApiResponse = /** status 200 OK */ BseDto;
export type AwardToBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  awardToBidRequest: AwardToBidRequest;
};
export type ListReceivedBidsApiResponse =
  /** status 200 OK */ ListReceivedBidsResponse;
export type ListReceivedBidsApiArg = {
  negotiationRound?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetReceivedBseBidApiResponse =
  /** status 200 OK */ ReceivedBseBidDto;
export type GetReceivedBseBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type CancelSourcingEventApiResponse = /** status 200 OK */ BseDto;
export type CancelSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  cancelSourcingEventRequest: CancelSourcingEventRequest;
};
export type CloseSourcingEventApiResponse = /** status 200 OK */ BseDto;
export type CloseSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  closeSourcingEventRequest: CloseSourcingEventRequest;
};
export type CompleteEvaluationApiResponse = /** status 200 OK */ BseDto;
export type CompleteEvaluationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateSourcingEventCopyApiResponse = /** status 200 OK */ BseDto;
export type CreateSourcingEventCopyApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateUploadForSourcingEventDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSourcingEventDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type CreateEmailInviteReminderApiResponse = unknown;
export type CreateEmailInviteReminderApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  inviteId: string;
};
export type CreateNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type CreateNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createNegotiationRoundRequest: CreateNegotiationRoundRequest;
};
export type OpenCompletedEventApiResponse = /** status 200 OK */ BseDto;
export type OpenCompletedEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PublishBasicSourcingEventApiResponse = /** status 200 OK */ BseDto;
export type PublishBasicSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateBseQuestionAsBuyerApiResponse = /** status 200 OK */ BseDto;
export type CreateBseQuestionAsBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createBseQuestionRequest: CreateBseQuestionRequest;
};
export type UpdateBseQuestionApiResponse = /** status 200 OK */ BseDto;
export type UpdateBseQuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  updateBseQuestionRequest: UpdateBseQuestionRequest;
};
export type CreateBseQuestionCommentAsBuyerApiResponse =
  /** status 200 OK */ BseDto;
export type CreateBseQuestionCommentAsBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  createBseQuestionCommentRequest: CreateBseQuestionCommentRequest;
};
export type CreateUploadForBseApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForBseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type EvaluateSingleBidWithAiApiResponse =
  /** status 200 OK */ AiChatResponse;
export type EvaluateSingleBidWithAiApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  evaluateSingleBidWithAiRequest: EvaluateSingleBidWithAiRequest;
};
export type RemoveContactPersonApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type RemoveContactPersonApiArg = {
  email: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
};
export type ListContactPersonsApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type ListContactPersonsApiArg = {
  name?: string;
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
};
export type AddContactPersonApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type AddContactPersonApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
  addContactPersonRequest: AddContactPersonRequest;
};
export type EditContactPersonApiResponse =
  /** status 200 OK */ ListContactPersonsResponse;
export type EditContactPersonApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  subjectType: ContactSubjectType;
  subjectId: string;
  editContactPersonRequest: EditContactPersonRequest;
};
export type GetExclusionGroundsTaxonomyApiResponse =
  /** status 200 OK */ ExclusionGroundsTaxonomyResponse;
export type GetExclusionGroundsTaxonomyApiArg = void;
export type ListSourcingEventsForBuyerApiResponse =
  /** status 200 OK */ ListSourcingEventsResponse;
export type ListSourcingEventsForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateSourcingEventApiResponse =
  /** status 201 Created */ SourcingEventV2Dto;
export type CreateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createSourcingEventV2Request: CreateSourcingEventV2Request;
};
export type EvaluateBidsWithAiApiResponse = /** status 200 OK */ AiChatResponse;
export type EvaluateBidsWithAiApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  evaluateBidsWithAiRequest: EvaluateBidsWithAiRequest;
};
export type GenerateRequirementsWithAiApiResponse =
  /** status 200 OK */ AiChatResponse;
export type GenerateRequirementsWithAiApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  generateRequirementsWithAiRequest: GenerateRequirementsWithAiRequest;
};
export type DeleteSourcingEventApiResponse = unknown;
export type DeleteSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type GetSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type UpdateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  sourcingEventV2PatchDto: SourcingEventV2PatchDto;
};
export type CreateUploadForSeV2AnnouncementAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSeV2AnnouncementAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetBuyerSeV2AttachmentUploadApiResponse =
  /** status 200 OK */ SeV2AttachmentUploadDto;
export type GetBuyerSeV2AttachmentUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
};
export type AwardSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type AwardSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  awardSourcingEventRequest: AwardSourcingEventRequest;
};
export type GetAwardLettersApiResponse = /** status 200 OK */ AwardLettersDto;
export type GetAwardLettersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DispatchAwardLettersApiResponse =
  /** status 200 OK */ AwardLettersDto;
export type DispatchAwardLettersApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateAwardLetterApiResponse = /** status 200 OK */ AwardLetterDto;
export type UpdateAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  letterId: string;
  awardLetterPatchDto: AwardLetterPatchDto;
};
export type ApproveAwardLetterApiResponse =
  /** status 200 OK */ AwardLettersDto;
export type ApproveAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  letterId: string;
  awardLetterPatchDto: AwardLetterPatchDto;
};
export type ReopenAwardLetterApiResponse = /** status 200 OK */ AwardLettersDto;
export type ReopenAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  letterId: string;
};
export type BeginEvaluationApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type BeginEvaluationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CancelSourcingEventV2ApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type CancelSourcingEventV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  cancelSourcingEventV2Request: CancelSourcingEventV2Request;
};
export type CreateEventChangeApiResponse =
  /** status 201 Created */ EventRevisionDto;
export type CreateEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpdateEventChangeApiResponse =
  /** status 200 OK */ EventRevisionDto;
export type UpdateEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revisionId: string;
  eventRevisionPatchDto: EventRevisionPatchDto;
};
export type CancelEventChangeApiResponse =
  /** status 200 OK */ EventRevisionDto;
export type CancelEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revisionId: string;
};
export type SubmitEventChangeApiResponse =
  /** status 200 OK */ EventRevisionDto;
export type SubmitEventChangeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revisionId: string;
};
export type StartSeV2ClarificationApiResponse =
  /** status 201 Created */ SeV2QuestionDto;
export type StartSeV2ClarificationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createSeV2ClarificationRequest: CreateSeV2ClarificationRequest;
};
export type CloseSourcingEventV2ApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type CloseSourcingEventV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  closeSourcingEventV2Request: CloseSourcingEventV2Request;
};
export type CompleteSourcingEventV2ApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type CompleteSourcingEventV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ConfirmAwardApiResponse = /** status 200 OK */ SourcingEventV2Dto;
export type ConfirmAwardApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ConfirmSourcingEventClassificationApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type ConfirmSourcingEventClassificationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CopySourcingEventV2ApiResponse =
  /** status 201 Created */ CopiedSourcingEventDto;
export type CopySourcingEventV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetDpsCompetitionsApiResponse =
  /** status 200 OK */ DpsCompetitionsDto;
export type GetDpsCompetitionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateDpsCompetitionApiResponse =
  /** status 201 Created */ SourcingEventV2Dto;
export type CreateDpsCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createDpsCompetitionRequestDto: CreateDpsCompetitionRequestDto;
};
export type AddEmailInviteToPrivateSourcingEventApiResponse =
  /** status 201 Created */ SourcingEventV2Dto;
export type AddEmailInviteToPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  addEmailInviteRequest: AddEmailInviteRequest;
};
export type RemoveEmailInviteFromPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type RemoveEmailInviteFromPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  inviteId: string;
};
export type CreateEmailInviteReminderForPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type CreateEmailInviteReminderForPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  inviteId: string;
};
export type GetEvaluationApiResponse = /** status 200 OK */ EvaluationDto;
export type GetEvaluationApiArg = {
  round?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type UpsertPriceOverrideApiResponse = /** status 200 OK */ EvaluationDto;
export type UpsertPriceOverrideApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  upsertPriceOverrideRequest: UpsertPriceOverrideRequest;
};
export type SetCriterionRationaleApiResponse =
  /** status 200 OK */ EvaluationDto;
export type SetCriterionRationaleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setRationaleRequest: SetRationaleRequest;
};
export type UpsertCriterionScoreApiResponse =
  /** status 200 OK */ EvaluationDto;
export type UpsertCriterionScoreApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  upsertScoreRequest: UpsertScoreRequest;
};
export type SetEvaluationSelectionApiResponse =
  /** status 200 OK */ EvaluationDto;
export type SetEvaluationSelectionApiArg = {
  round?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setEvaluationSelectionRequest: SetEvaluationSelectionRequest;
};
export type UpdateSourcingEventValueApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type UpdateSourcingEventValueApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  updateSourcingEventValueRequest: UpdateSourcingEventValueRequest;
};
export type SetHomeDepartmentApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type SetHomeDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setHomeDepartmentRequest: SetHomeDepartmentRequest;
};
export type AddInternalMessageToSeV2ApiResponse =
  /** status 201 Created */ SourcingEventV2Dto;
export type AddInternalMessageToSeV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  addInternalMessageRequest: AddInternalMessageRequest;
};
export type ConfirmInvitationApiResponse =
  /** status 200 OK */ InvitationResultDto;
export type ConfirmInvitationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  confirmInvitationRequestDto: ConfirmInvitationRequestDto;
};
export type CreateOrganizationInviteEmailReminderApiResponse = unknown;
export type CreateOrganizationInviteEmailReminderApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  inviteId: string;
  emailInviteId: string;
};
export type ListNegotiationRoundsV2ApiResponse =
  /** status 200 OK */ ListNegotiationRoundsV2Response;
export type ListNegotiationRoundsV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateNegotiationRoundV2ApiResponse =
  /** status 201 Created */ NegotiationRoundV2Dto;
export type CreateNegotiationRoundV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createNegotiationRoundV2Request: CreateNegotiationRoundV2Request;
};
export type PatchNegotiationRoundV2ApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type PatchNegotiationRoundV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  negotiationRoundV2PatchDto: NegotiationRoundV2PatchDto;
};
export type CompleteNegotiationRoundV2ApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type CompleteNegotiationRoundV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type AddNegotiationRoundV2InviteApiResponse =
  /** status 201 Created */ NegotiationRoundV2Dto;
export type AddNegotiationRoundV2InviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  addNegotiationRoundV2InviteRequest: AddNegotiationRoundV2InviteRequest;
};
export type RemoveNegotiationRoundV2InviteApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type RemoveNegotiationRoundV2InviteApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  pathOrganizationId: string;
};
export type UpdateNegotiationRoundV2InviteMessageApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type UpdateNegotiationRoundV2InviteMessageApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  pathOrganizationId: string;
  updateNegotiationRoundV2InviteMessageRequest: UpdateNegotiationRoundV2InviteMessageRequest;
};
export type SelectNegotiationRoundV2ProductBidsApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type SelectNegotiationRoundV2ProductBidsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  selectProductBidsRequest: SelectProductBidsRequest;
};
export type PublishNegotiationRoundV2ApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type PublishNegotiationRoundV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type ReopenNegotiationRoundV2ApiResponse =
  /** status 200 OK */ NegotiationRoundV2Dto;
export type ReopenNegotiationRoundV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type CreateUploadForNegotiationRoundV2ApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForNegotiationRoundV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type CompleteNegotiationRoundEvaluationApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type CompleteNegotiationRoundEvaluationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  negotiationId: string;
};
export type OpenNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type OpenNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  negotiationId: string;
};
export type PublishNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type PublishNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  negotiationId: string;
};
export type AddOrganizationInviteToPrivateSourcingEventApiResponse =
  /** status 201 Created */ SourcingEventV2Dto;
export type AddOrganizationInviteToPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  addOrganizationInviteRequest: AddOrganizationInviteRequest;
};
export type RemoveOrganizationInviteFromPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type RemoveOrganizationInviteFromPrivateSourcingEventApiArg = {
  cookie?: string;
  headerOrganizationId?: string;
  personId?: string;
  eventId: string;
  pathOrganizationId: string;
};
export type ListParticipationRequestsForBuyerApiResponse =
  /** status 200 OK */ BuyerParticipationRequestsDto;
export type ListParticipationRequestsForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetParticipationRequestForBuyerApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDetailDto;
export type GetParticipationRequestForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
};
export type ExtendDpsAssessmentWindowApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type ExtendDpsAssessmentWindowApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  extendAssessmentRequestDto: ExtendAssessmentRequestDto;
};
export type UpdateParticipationRequestReviewApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDetailDto;
export type UpdateParticipationRequestReviewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  buyerQualificationReviewPatchDto: BuyerQualificationReviewPatchDto;
};
export type GetParticipationRequestRejectionDocumentsApiResponse =
  /** status 200 OK */ ParticipationRequestRejectionDocumentsDto;
export type GetParticipationRequestRejectionDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
};
export type CreateUploadForParticipationRequestRejectionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForParticipationRequestRejectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type RemoveFromDpsSchemeApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type RemoveFromDpsSchemeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  removeFromSchemeRequestDto: RemoveFromSchemeRequestDto;
};
export type UpdateParticipationRequestNotesApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDetailDto;
export type UpdateParticipationRequestNotesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  buyerReviewNotesPatchDto: BuyerReviewNotesPatchDto;
};
export type UpdateParticipationRequestSelectionDraftApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type UpdateParticipationRequestSelectionDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  selectionDraftPatchDto: SelectionDraftPatchDto;
};
export type SetQualificationVerdictApiResponse =
  /** status 200 OK */ BuyerParticipationRequestDto;
export type SetQualificationVerdictApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  requestId: string;
  setQualificationVerdictRequestDto: SetQualificationVerdictRequestDto;
};
export type SelectSourcingEventProductBidsApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type SelectSourcingEventProductBidsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  selectProductBidsRequest: SelectProductBidsRequest;
};
export type GetProtocolDraftApiResponse =
  /** status 200 OK */ ProtocolDocumentDto;
export type GetProtocolDraftApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PatchProtocolNarrativeApiResponse =
  /** status 200 OK */ ProtocolDocumentDto;
export type PatchProtocolNarrativeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  protocolDraftPatchDto: ProtocolDraftPatchDto;
};
export type FinaliseProtocolApiResponse =
  /** status 200 OK */ ProtocolVersionDto;
export type FinaliseProtocolApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ListProtocolVersionsApiResponse =
  /** status 200 OK */ ProtocolVersionListDto;
export type ListProtocolVersionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DownloadProtocolVersionApiResponse = unknown;
export type DownloadProtocolVersionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  versionId: string;
};
export type ListBidV2SForEventApiResponse =
  /** status 200 OK */ ListBidV2SResponse;
export type ListBidV2SForEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetBidV2ForBuyerApiResponse =
  /** status 200 OK */ BuyerBidV2DetailDto;
export type GetBidV2ForBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type CreateContractFromBidV2ApiResponse =
  /** status 200 OK */ ContractDto;
export type CreateContractFromBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  createContractFromBidV2Request: CreateContractFromBidV2Request;
};
export type UpdateBuyerMinimumRequirementReviewApiResponse =
  /** status 200 OK */ BuyerBidV2DetailDto;
export type UpdateBuyerMinimumRequirementReviewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  buyerMinimumRequirementReviewPatchDto: BuyerMinimumRequirementReviewPatchDto;
};
export type SetBidQualificationApiResponse =
  /** status 200 OK */ BuyerBidV2DetailDto;
export type SetBidQualificationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  setBidQualificationRequestDto: SetBidQualificationRequestDto;
};
export type UpdateBuyerQualificationReviewApiResponse =
  /** status 200 OK */ BuyerBidV2DetailDto;
export type UpdateBuyerQualificationReviewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  buyerQualificationReviewPatchDto: BuyerQualificationReviewPatchDto;
};
export type RejectBidV2ApiResponse = /** status 200 OK */ BuyerBidV2DetailDto;
export type RejectBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  rejectBidV2RequestDto: RejectBidV2RequestDto;
};
export type GetBidV2RejectionDocumentsApiResponse =
  /** status 200 OK */ BidV2RejectionDocumentsDto;
export type GetBidV2RejectionDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type CreateUploadForBidV2RejectionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidV2RejectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type RevokeBidRejectionApiResponse =
  /** status 200 OK */ BuyerBidV2DetailDto;
export type RevokeBidRejectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type PublishDpsCompetitionApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type PublishDpsCompetitionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PublishPrivateSourcingEventApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type PublishPrivateSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DownloadSeV2QaReportApiResponse = unknown;
export type DownloadSeV2QaReportApiArg = {
  eventId: string;
};
export type GetBuyerSeV2QuestionsApiResponse =
  /** status 200 OK */ ListSeV2QuestionsResponse;
export type GetBuyerSeV2QuestionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AnswerSeV2QuestionApiResponse =
  /** status 200 OK */ SeV2QuestionDto;
export type AnswerSeV2QuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  seV2QuestionPatchDto: SeV2QuestionPatchDto;
};
export type CreateUploadForSeV2AnswerAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSeV2AnswerAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type SendSeV2ClarificationMessageAsBuyerApiResponse =
  /** status 201 Created */ SeV2QuestionDto;
export type SendSeV2ClarificationMessageAsBuyerApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  createSeV2QuestionMessageRequest: CreateSeV2QuestionMessageRequest;
};
export type GetSourcingEventReadinessApiResponse =
  /** status 200 OK */ ValidationReadinessDto;
export type GetSourcingEventReadinessApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ReopenCompletedSourcingEventV2ApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type ReopenCompletedSourcingEventV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SetResponsiblePersonApiResponse =
  /** status 200 OK */ SourcingEventV2Dto;
export type SetResponsiblePersonApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  setResponsiblePersonRequest: SetResponsiblePersonRequest;
};
export type RevokeAwardApiResponse = /** status 200 OK */ SourcingEventV2Dto;
export type RevokeAwardApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  revokeAwardRequest: RevokeAwardRequest;
};
export type GetEventSharesApiResponse = /** status 200 OK */ EventSharesDto;
export type GetEventSharesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type ShareEventApiResponse = /** status 200 OK */ EventShareDto;
export type ShareEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  shareEventRequest: ShareEventRequest;
};
export type UnshareEventApiResponse = unknown;
export type UnshareEventApiArg = {
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  eventId: string;
  pathPersonId: string;
};
export type GetBuyerSupplierInformationApiResponse =
  /** status 200 OK */ ListSupplierInformationResponse;
export type GetBuyerSupplierInformationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type PublishInformationApiResponse =
  /** status 201 Created */ SupplierInformationDto;
export type PublishInformationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createInformationRequest: CreateInformationRequest;
};
export type CreateUploadForSourcingEventV2ApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSourcingEventV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type EditNegotiationRoundApiResponse =
  /** status 200 OK */ NegotiationRoundDto;
export type EditNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  negotiationId: string;
  editNegotiationRequest: EditNegotiationRequest;
};
export type CreateUploadForNegotiationRoundDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForNegotiationRoundDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  negotiationRoundId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type CreateUploadForNegotiationRoundApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForNegotiationRoundApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  negotiationRoundId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetProductGroupsForSourcingEventApiResponse =
  /** status 200 OK */ ProductGroupsDto;
export type GetProductGroupsForSourcingEventApiArg = {
  sourcingEventId: string;
};
export type ListCombinedEventsForBuyerApiResponse =
  /** status 200 OK */ ListCombinedEventsResponse;
export type ListCombinedEventsForBuyerApiArg = {
  /** Filtrer på status. PascalCase-verdier gjelder eldre (V1) anskaffelser, SCREAMING_SNAKE gjelder V2 — ta med begge varianter for å dekke begge (f.eks. Published og PUBLISHED). */
  statuses?: (
    | "Draft"
    | "Published"
    | "Completed"
    | "Awarded"
    | "Cancelled"
    | "Closed"
    | "DRAFT"
    | "PUBLICATION_PENDING"
    | "PUBLISHED"
    | "PUBLICATION_FAILED"
    | "EVALUATION"
    | "EVALUATED"
    | "AWARD_DECISION"
    | "AWARDED"
    | "CANCELLED"
    | "CLOSED"
    | "COMPLETED"
  )[];
  /** Filtrer på tilknyttet prosjekt. Gjelder både eldre (V1) og V2-anskaffelser. */
  projectIds?: string[];
  /** Filtrer på navn (delstreng) */
  name?: string;
  responsiblePersons?: string[];
  /** Filtrer på kontraktstype (kun V2-anskaffelser har denne). */
  contractTypes?: ("WORKS" | "SUPPLIES" | "SERVICES" | "COMBINED")[];
  /** Bare anskaffelser der fristen allerede har gått ut. */
  deadlinePassed?: boolean;
  limit?: number;
  skip?: number;
  sortBy?: SourcingEventSortField;
  sortDirection?: SortDirection;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListBuyerEventFilterOptionsApiResponse =
  /** status 200 OK */ BuyerEventFilterOptionsResponse;
export type ListBuyerEventFilterOptionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CountCombinedEventsByStatusApiResponse =
  /** status 200 OK */ CombinedEventStatusCountsResponse;
export type CountCombinedEventsByStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListEventsForBuyerApiResponse =
  /** status 200 OK */ ListSeDtosResponse;
export type ListEventsForBuyerApiArg = {
  statuses?: string[];
  projectIds?: string[];
  name?: string;
  responsiblePersons?: string[];
  limit?: number;
  skip?: number;
  sortBy?: SourcingEventSortField;
  sortDirection?: SortDirection;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListContractReportsApiResponse =
  /** status 200 OK */ ListContractReportsResponseDto;
export type ListContractReportsApiArg = {
  q: string;
  sortBy?: ContractReportSortColumn;
  sortDirection?: string;
  sortByCustomField?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListContractReportOptionsApiResponse =
  /** status 200 OK */ ListContractReportOptionsResponseDto;
export type ListContractReportOptionsApiArg = {
  q: string;
  parameterName: ContractReportOptionParameter;
  optionValues?: string[];
  optionSearchTerm?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateContractFromSourcingEventApiResponse =
  /** status 200 OK */ ContractDto;
export type CreateContractFromSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createContractFromSourcingEventRequest: CreateContractFromSourcingEventRequest;
};
export type DeleteCustomContractDataFieldApiResponse = unknown;
export type DeleteCustomContractDataFieldApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  deleteCustomFieldDto: DeleteCustomFieldDto;
};
export type UpsertCustomContractDataFieldApiResponse = unknown;
export type UpsertCustomContractDataFieldApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  upsertCustomContractFieldDto: UpsertCustomContractFieldDto;
};
export type UpsertContractDataFieldsSectionApiResponse = unknown;
export type UpsertContractDataFieldsSectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  contractDataFieldSectionDto: ContractDataFieldSectionDto;
};
export type ContractReportQueryDummyApiResponse = unknown;
export type ContractReportQueryDummyApiArg = {
  contractReportQueryDto: ContractReportQueryDto;
};
export type SignatureWebhookApiResponse = unknown;
export type SignatureWebhookApiArg = void;
export type DeleteContractTaskCommentApiResponse =
  /** status 200 OK */ ContractTaskCommentDto;
export type DeleteContractTaskCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  commentId: string;
};
export type UpdateContractTaskCommentApiResponse =
  /** status 200 OK */ ContractTaskCommentDto;
export type UpdateContractTaskCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  commentId: string;
  updateContractTaskCommentRequest: UpdateContractTaskCommentRequest;
};
export type DeleteContractTaskApiResponse = /** status 200 OK */ ContractDto;
export type DeleteContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type UpdateContractTaskApiResponse =
  /** status 200 OK */ ContractTaskDto;
export type UpdateContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
  updateTaskRequest: UpdateTaskRequest;
};
export type ListChangesForContractTaskApiResponse =
  /** status 200 OK */ ListChangesForContractTaskResponse;
export type ListChangesForContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type ListCommentsForContractTaskApiResponse =
  /** status 200 OK */ ListCommentsForContractTaskResponse;
export type ListCommentsForContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type CreateContractTaskCommentApiResponse =
  /** status 200 OK */ ContractTaskCommentDto;
export type CreateContractTaskCommentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
  createContractTaskCommentRequest: CreateContractTaskCommentRequest;
};
export type CreateContractTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateContractTextDocumentApiArg = {
  createContractTextDocumentRequest: CreateContractTextDocumentRequest;
};
export type ListTextDocumentsForContractApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForContractApiArg = {
  contractId: string;
};
export type CreateFencyConversationApiResponse =
  /** status 200 OK */ FencyConversationResponse;
export type CreateFencyConversationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateExploreMemoriesSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateExploreMemoriesSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createExploreMemoriesSessionRequest: CreateExploreMemoriesSessionRequest;
};
export type CreateFencyFileDownloadSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateFencyFileDownloadSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createFencyFileDownloadSessionRequest: CreateFencyFileDownloadSessionRequest;
};
export type DownloadMultiIfrsReportApiResponse = unknown;
export type DownloadMultiIfrsReportApiArg = {
  contractIds: string;
};
export type CreateMemoryChatSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateMemoryChatSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createMemoryChatSessionRequest: CreateMemoryChatSessionRequest;
};
export type CreateMemoryDownloadLinkApiResponse =
  /** status 200 OK */ FencyDownloadLinkResponse;
export type CreateMemoryDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createMemoryDownloadLinkRequest: CreateMemoryDownloadLinkRequest;
};
export type CreateContractSearchSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateContractSearchSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetContractStatisticsApiResponse =
  /** status 200 OK */ ContractStatisticsDto;
export type GetContractStatisticsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetContractAutofillContextApiResponse =
  /** status 200 OK */ ContractAutofillContextDto;
export type GetContractAutofillContextApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CancelSignedDocumentApiResponse = unknown;
export type CancelSignedDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  cancelSignedDocumentRequest: CancelSignedDocumentRequest;
};
export type CreateUploadForContractDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForContractDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type DownloadIfrsReportApiResponse = unknown;
export type DownloadIfrsReportApiArg = {
  contractId: string;
};
export type GetContractMessageAttachmentUploadApiResponse =
  /** status 200 OK */ ContractMessageAttachmentUploadDto;
export type GetContractMessageAttachmentUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
};
export type CreateUploadForContractMessageAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForContractMessageAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type ListContractMessagesApiResponse =
  /** status 200 OK */ ListContractMessagesResponse;
export type ListContractMessagesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractMessageApiResponse =
  /** status 200 OK */ ContractMessageDto;
export type CreateContractMessageApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createContractMessageRequest: CreateContractMessageRequest;
};
export type MarkContractMessagesReadApiResponse = unknown;
export type MarkContractMessagesReadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  markMessagesReadRequest: MarkMessagesReadRequest;
};
export type SaveContractMessageAttachmentApiResponse =
  /** status 200 OK */ SaveMessageAttachmentResponse;
export type SaveContractMessageAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  saveMessageAttachmentRequest: SaveMessageAttachmentRequest;
};
export type GetContractOriginCommunicationApiResponse =
  /** status 200 OK */ ContractOriginCommunicationDto;
export type GetContractOriginCommunicationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type DeleteContractParticipantApiResponse = unknown;
export type DeleteContractParticipantApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  deleteContractParticipantRequest: DeleteContractParticipantRequest;
};
export type ListParticipantsForContractsApiResponse =
  /** status 200 OK */ ListParticipantsForContractResponse;
export type ListParticipantsForContractsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractParticipantApiResponse =
  /** status 200 OK */ ContractDto;
export type CreateContractParticipantApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createContractParticipantRequest: CreateContractParticipantRequest;
};
export type CreateContractTaskApiResponse = /** status 200 OK */ ContractDto;
export type CreateContractTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createContractTaskRequest: CreateContractTaskRequest;
};
export type CreateUploadForContractApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetContributingEntityInviteApiResponse =
  /** status 200 OK */ ContributingEntityInviteDto;
export type GetContributingEntityInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type AcceptContributingEntityInviteApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type AcceptContributingEntityInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type DeclineContributingEntityInviteApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type DeclineContributingEntityInviteApiArg = {
  secret: string;
  inviteId: string;
  declineContributingEntityInviteRequestDto: DeclineContributingEntityInviteRequestDto;
};
export type GetCpvCodesApiResponse = /** status 200 OK */ GetCpvCodesResponse;
export type GetCpvCodesApiArg = void;
export type ListContractFilterOptionsApiResponse =
  /** status 200 OK */ ContractFilterOptionsDto;
export type ListContractFilterOptionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListContractsApiResponse =
  /** status 200 OK */ ListContractsResponseDto;
export type ListContractsApiArg = {
  title?: string;
  state?: ContractStateDto;
  statuses?: string;
  counterparties?: string;
  owners?: string;
  templates?: string;
  internalparties?: string;
  projects?: string;
  limit: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ForceDeliverBidApiResponse =
  /** status 200 OK */ ForceDeliverBidResponseDto;
export type ForceDeliverBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type ForcePublishEventApiResponse =
  /** status 200 OK */ ForcePublishResponseDto;
export type ForcePublishEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SkipPastGateApiResponse =
  /** status 200 OK */ SkipPastGateResponseDto;
export type SkipPastGateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  skipPastGateRequestDto: SkipPastGateRequestDto;
};
export type StartDocumentChatApiResponse = /** status 200 OK */ AiChatResponse;
export type StartDocumentChatApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  startDocumentChatRequest: StartDocumentChatRequest;
};
export type UpdateDocumentMetaApiResponse =
  /** status 200 OK */ ViewDocumentAsOwnerDto;
export type UpdateDocumentMetaApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
  updateDocumentMetaRequest: UpdateDocumentMetaRequest;
};
export type GetDownloadLinkApiResponse =
  /** status 200 OK */ GetDownloadLinkResponse;
export type GetDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
};
export type ListDocumentTemplatesApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListDocumentTemplatesApiArg = void;
export type CreateDocumentTemplateApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateDocumentTemplateApiArg = {
  createDocumentTemplateRequest: CreateDocumentTemplateRequest;
};
export type CreateBulkFencySessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateBulkFencySessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createBulkFencySessionRequest: CreateBulkFencySessionRequest;
};
export type CreateFencyStreamSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateFencyStreamSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateFencyDocumentSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateFencyDocumentSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type FencySyncDocumentApiResponse = unknown;
export type FencySyncDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type SubmitDoffinNoticeApiResponse =
  /** status 201 Created */ DoffinSubmissionResponseDto;
export type SubmitDoffinNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type ValidateDoffinNoticeApiResponse = unknown;
export type ValidateDoffinNoticeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  sourcingEventId: string;
};
export type DownloadTextDocumentApiResponse = unknown;
export type DownloadTextDocumentApiArg = {
  downloadTextDocumentRequest: DownloadTextDocumentRequest;
};
export type UpdateEmailStatusApiResponse = unknown;
export type UpdateEmailStatusApiArg = void;
export type GetSeV2AttachmentDownloadLinkApiResponse =
  /** status 200 OK */ SeV2AttachmentDownloadLinkResponse;
export type GetSeV2AttachmentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  documentId: string;
};
export type ConfirmFencyEventApiResponse = unknown;
export type ConfirmFencyEventApiArg = void;
export type MarkUploadFailedApiResponse = unknown;
export type MarkUploadFailedApiArg = void;
export type ConfirmUploadApiResponse = unknown;
export type ConfirmUploadApiArg = void;
export type SearchIndustriesApiResponse =
  /** status 200 OK */ SearchIndustriesResponse;
export type SearchIndustriesApiArg = {
  name?: string;
};
export type ListLibraryElementsApiResponse =
  /** status 200 OK */ LibraryElementsDto;
export type ListLibraryElementsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateLibraryElementApiResponse =
  /** status 201 Created */ LibraryElementDto;
export type CreateLibraryElementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createLibraryElementRequest: CreateLibraryElementRequest;
};
export type UpdateLibraryElementApiResponse =
  /** status 200 OK */ LibraryElementDto;
export type UpdateLibraryElementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  updateLibraryElementRequest: UpdateLibraryElementRequest;
};
export type DeleteLibraryElementApiResponse = unknown;
export type DeleteLibraryElementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type ListMyNotificationsApiResponse =
  /** status 200 OK */ ListNotificationsResponse;
export type ListMyNotificationsApiArg = {
  limit?: number;
  offset?: number;
  unseen?: boolean;
  /** Bare uleste varsler. I motsetning til unseen tømmes ikke dette av å åpne varsellisten. */
  unread?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListOrganizationUsersApiResponse =
  /** status 200 OK */ ListOrganizationUsersResponse;
export type ListOrganizationUsersApiArg = {
  name?: string;
  limit: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListOrganizationsForMeApiResponse =
  /** status 200 OK */ ListOrganizationsForMeResponse;
export type ListOrganizationsForMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateOrganizationForMeApiResponse = /** status 200 OK */ OrgDto;
export type CreateOrganizationForMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createOrgRequest: CreateOrgRequest;
};
export type MarkNotificationsAsPeekedApiResponse = unknown;
export type MarkNotificationsAsPeekedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  markNotificationsRequest: MarkNotificationsRequest;
};
export type RecordRecentlyViewedApiResponse = unknown;
export type RecordRecentlyViewedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  recordRecentlyViewedRequest: RecordRecentlyViewedRequest;
};
export type ListMyRecentlyViewedContractsApiResponse =
  /** status 200 OK */ ListRecentlyViewedContractsResponse;
export type ListMyRecentlyViewedContractsApiArg = {
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyRecentlyViewedSourcingEventsApiResponse =
  /** status 200 OK */ ListRecentlyViewedEventsResponse;
export type ListMyRecentlyViewedSourcingEventsApiArg = {
  limit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyUpcomingDeadlinesApiResponse =
  /** status 200 OK */ ListUpcomingDeadlinesResponse;
export type ListMyUpcomingDeadlinesApiArg = {
  withinDays?: number;
  overdueDays?: number;
  upcomingLimit?: number;
  overdueLimit?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type MarkNotificationsAsViewedApiResponse = unknown;
export type MarkNotificationsAsViewedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  markNotificationsRequest: MarkNotificationsRequest;
};
export type CreateNeedApiResponse = /** status 201 Created */ NeedDto;
export type CreateNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createNeedRequest: CreateNeedRequest;
};
export type CreateNeedTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateNeedTextDocumentApiArg = {
  createNeedTextDocumentRequest: CreateNeedTextDocumentRequest;
};
export type ListTextDocumentsForNeedApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForNeedApiArg = {
  needId: string;
};
export type GetNeedApiResponse = /** status 200 OK */ NeedDto;
export type GetNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type UpdateNeedApiResponse = /** status 200 OK */ NeedDto;
export type UpdateNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  needPatchDto: NeedPatchDto;
};
export type CreateProcurementForNeedApiResponse = /** status 200 OK */ NeedDto;
export type CreateProcurementForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type SubmitNeedApiResponse = /** status 200 OK */ NeedDto;
export type SubmitNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
};
export type ListNeedsApiResponse = /** status 200 OK */ ListNeedsResponse;
export type ListNeedsApiArg = {
  status?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateUploadForNeedApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForNeedApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  needId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type CreateNegotiationTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateNegotiationTextDocumentApiArg = {
  createNegotiationTextDocumentRequest: CreateNegotiationTextDocumentRequest;
};
export type ListTextDocumentsForNegotiationRoundApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForNegotiationRoundApiArg = {
  negotiationRoundId: string;
};
export type GetAccessTokenApiResponse = /** status 200 OK */ AccessTokenDto;
export type GetAccessTokenApiArg = {
  getAccessTokenRequest: GetAccessTokenRequest;
};
export type SearchBrregOrgsByNameApiResponse =
  /** status 200 OK */ SearchBrregOrgsByNameResponse;
export type SearchBrregOrgsByNameApiArg = {
  query: string;
  limit?: number;
};
export type LookupBrregOrgApiResponse = /** status 200 OK */ BrregOrgDto;
export type LookupBrregOrgApiArg = {
  organizationNumber: string;
};
export type ListContractsForOrgApiResponse =
  /** status 200 OK */ ListContractsResponseDto;
export type ListContractsForOrgApiArg = {
  title?: string;
  state?: ContractStateDto;
  statuses?: string;
  counterparties?: string;
  owners?: string;
  templates?: string;
  internalparties?: string;
  projects?: string;
  limit: number;
  skip?: number;
};
export type CreateApiClientApiResponse =
  /** status 200 OK */ CreateApiClientResponse;
export type CreateApiClientApiArg = {
  cookie?: string;
};
export type CreateOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type CreateOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createOrganizationEntryRequest: CreateOrganizationEntryRequest;
};
export type GetOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type GetOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entryId: string;
};
export type UpdateOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type UpdateOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entryId: string;
  updateOrganizationEntryRequest: UpdateOrganizationEntryRequest;
};
export type LinkOrganizationEntryApiResponse =
  /** status 200 OK */ OrganizationEntryDto;
export type LinkOrganizationEntryApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entryId: string;
  linkOrganizationEntryRequest: LinkOrganizationEntryRequest;
};
export type GetSupplierEmailInviteApiResponse =
  /** status 200 OK */ SupplierEmailInviteDto;
export type GetSupplierEmailInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type GetOrgUserEmailInviteApiResponse =
  /** status 200 OK */ OrgUserEmailInviteDto;
export type GetOrgUserEmailInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type AcceptOrgUserEmailInviteApiResponse = /** status 200 OK */ OrgDto;
export type AcceptOrgUserEmailInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type ListAssessmentTemplatesApiResponse =
  /** status 200 OK */ AssessmentTemplatesDto;
export type ListAssessmentTemplatesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type UpdateAssessmentApiResponse =
  /** status 200 Updated assessment */ AssessmentDto;
export type UpdateAssessmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
  updateAssessmentRequestDto: UpdateAssessmentRequestDto;
};
export type ListAssessmentsApiResponse = /** status 200 OK */ AssessmentsDto;
export type ListAssessmentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListOrgsByNumberApiResponse =
  /** status 200 OK */ ListOrgsByNumberResponse;
export type ListOrgsByNumberApiArg = {
  country: string;
  number: string;
};
export type UpdateOrganizationApiResponse = /** status 200 OK */ OrgDto;
export type UpdateOrganizationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  editOrganizationRequest: EditOrganizationRequest;
};
export type ListAccessGrantsApiResponse =
  /** status 200 OK */ ListAccessGrantsResponse;
export type ListAccessGrantsApiArg = {
  queryPersonId?: string;
  departmentId?: string;
  cookie?: string;
  organizationId?: string;
  headerPersonId?: string;
  orgId: string;
};
export type ListDepartmentsApiResponse =
  /** status 200 OK */ ListDepartmentsResponse;
export type ListDepartmentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateDepartmentApiResponse =
  /** status 201 Created */ DepartmentDto;
export type CreateDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentNameRequest: DepartmentNameRequest;
};
export type RenameDepartmentApiResponse = /** status 200 OK */ DepartmentDto;
export type RenameDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
  departmentNameRequest: DepartmentNameRequest;
};
export type ActivateDepartmentApiResponse = /** status 200 OK */ DepartmentDto;
export type ActivateDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
};
export type DeactivateDepartmentApiResponse =
  /** status 200 OK */ DepartmentDto;
export type DeactivateDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
};
export type AssignDepartmentRoleApiResponse = unknown;
export type AssignDepartmentRoleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
  departmentRoleRequest: DepartmentRoleRequest;
};
export type RevokeDepartmentRoleApiResponse = unknown;
export type RevokeDepartmentRoleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  departmentId: string;
  departmentRoleRequest: DepartmentRoleRequest;
};
export type ListEntraConnectionsApiResponse =
  /** status 200 OK */ EntraConnectionsDto;
export type ListEntraConnectionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateEntraConnectionApiResponse =
  /** status 200 OK */ EntraConnectionDto;
export type CreateEntraConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  createEntraConnectionRequest: CreateEntraConnectionRequest;
};
export type DeleteEntraConnectionApiResponse = unknown;
export type DeleteEntraConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
};
export type UpdateEntraConnectionApiResponse =
  /** status 200 OK */ EntraConnectionDto;
export type UpdateEntraConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
  updateEntraConnectionRequest: UpdateEntraConnectionRequest;
};
export type SaveEntraGroupMappingApiResponse =
  /** status 200 OK */ EntraGroupMappingDto;
export type SaveEntraGroupMappingApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
  saveEntraGroupMappingRequest: SaveEntraGroupMappingRequest;
};
export type DeleteEntraGroupMappingApiResponse = unknown;
export type DeleteEntraGroupMappingApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  connectionId: string;
  mappingId: string;
};
export type GetOrganizationApiResponse =
  /** status 200 OK */ OrgPublicProfileDto;
export type GetOrganizationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListSupplierEmailInvitesApiResponse =
  /** status 200 OK */ ListOrganizationInvitesResponse;
export type ListSupplierEmailInvitesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateSupplierEmailInviteApiResponse =
  /** status 200 OK */ SupplierEmailInviteDto;
export type CreateSupplierEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  createEmailInviteRequest: CreateEmailInviteRequest;
};
export type DeleteSupplierEmailInviteApiResponse = unknown;
export type DeleteSupplierEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  inviteId: string;
};
export type CreateSupplierEmailInviteReminderApiResponse = unknown;
export type CreateSupplierEmailInviteReminderApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  inviteId: string;
};
export type UpdateOrganizationTenantApiResponse = /** status 200 OK */ OrgDto;
export type UpdateOrganizationTenantApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  updateOrgTenantRequest: UpdateOrgTenantRequest;
};
export type ListOrgUserEmailInvitesApiResponse =
  /** status 200 OK */ ListOrgUserEmailInvitesResponse;
export type ListOrgUserEmailInvitesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateOrgUserEmailInviteApiResponse =
  /** status 200 OK */ SupplierEmailInviteDto;
export type CreateOrgUserEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  createOrgUserEmailInviteRequest: CreateOrgUserEmailInviteRequest;
};
export type DeleteOrgUserEmailInviteApiResponse = unknown;
export type DeleteOrgUserEmailInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  inviteId: string;
};
export type DeleteOrgUserApiResponse = /** status 200 OK */ OrgDto;
export type DeleteOrgUserApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  userId: string;
};
export type UpdateOrgUserRoleApiResponse = /** status 200 OK */ OrgDto;
export type UpdateOrgUserRoleApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  userId: string;
  updateOrgUserRoleRequest: UpdateOrgUserRoleRequest;
};
export type ListContractTasksForOrganizationApiResponse =
  /** status 200 OK */ ListContractTasksResponseDto;
export type ListContractTasksForOrganizationApiArg = {
  limit?: number;
  statuses?: string;
  personIds?: string;
  contractIds?: string;
  /** Which tasks a limit keeps: the next due (default) or the most recently changed. */
  sortBy?: ContractTaskSortDto;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type ListContractTemplatesApiResponse =
  /** status 200 OK */ ListContractTemplatesResponseDto;
export type ListContractTemplatesApiArg = {
  contractId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type CreateContractTemplateApiResponse =
  /** status 200 OK */ ContractTemplateDto;
export type CreateContractTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
  upsertContractTemplateRequest: UpsertContractTemplateRequest;
};
export type GetTaskApiResponse = /** status 200 OK */ ContractTaskDto;
export type GetTaskApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  taskId: string;
};
export type UpdateContractTemplateApiResponse =
  /** status 200 OK */ ContractTemplateDto;
export type UpdateContractTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  templateId: string;
  upsertContractTemplateRequest: UpsertContractTemplateRequest;
};
export type GetContractApiResponse = /** status 200 OK */ ContractDto;
export type GetContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type UpdateContractApiResponse = /** status 200 OK */ ContractDto;
export type UpdateContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  updateContractRequest: UpdateContractRequest;
};
export type CopyContractApiResponse = /** status 200 OK */ ContractDto;
export type CopyContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type PublishContractApiResponse = /** status 200 OK */ ContractDto;
export type PublishContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateSignedDocumentApiResponse = /** status 200 OK */ ContractDto;
export type CreateSignedDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createSignedDocumentRequest: CreateSignedDocumentRequest;
};
export type CreateSignedTextDocumentApiResponse =
  /** status 200 OK */ ContractDto;
export type CreateSignedTextDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
  createSignedTextDocumentRequest: CreateSignedTextDocumentRequest;
};
export type ListContractTasksApiResponse =
  /** status 200 OK */ ListContractTasksResponseDto;
export type ListContractTasksApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  contractId: string;
};
export type CreateContractApiResponse = /** status 200 OK */ ContractDto;
export type CreateContractApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  depId: string;
  createContractRequest: CreateContractRequest;
};
export type ListPersonsApiResponse = /** status 200 OK */ ListPersonsResponse;
export type ListPersonsApiArg = {
  orgIds: string[];
  name?: string;
  roles?: (
    | "Owner"
    | "Admin"
    | "SourcingCreator"
    | "SourcingViewer"
    | "ContractCreator"
    | "ContractViewer"
    | "ProjectViewer"
    | "ProjectCreator"
  )[];
  limit: number;
  skip?: number;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetPersonsByIdsApiResponse =
  /** status 200 OK */ ListPersonsByIdsResponse;
export type GetPersonsByIdsApiArg = {
  personIds: string[];
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetMeApiResponse = /** status 200 OK */ MeDto;
export type GetMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type UpdateMeApiResponse = /** status 200 OK */ MeDto;
export type UpdateMeApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  editMeRequest: EditMeRequest;
};
export type GetBidV2ApiResponse = /** status 200 OK */ BidV2Dto;
export type GetBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type UpdateBidV2ApiResponse = /** status 200 OK */ BidV2Dto;
export type UpdateBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  bidV2PatchDto: BidV2PatchDto;
};
export type ListContributingEntitiesApiResponse =
  /** status 200 OK */ ContributingEntityListDto;
export type ListContributingEntitiesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type AddContributingEntityApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type AddContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  addContributingEntityRequestDto: AddContributingEntityRequestDto;
};
export type RemoveContributingEntityApiResponse = unknown;
export type RemoveContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type GetContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type GetContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type UpdateContributingEntityApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type UpdateContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
  updateContributingEntityRequestDto: UpdateContributingEntityRequestDto;
};
export type ResendContributingEntityInvitationApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type ResendContributingEntityInvitationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type ReopenContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDto;
export type ReopenContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  entityId: string;
};
export type PreviewBidV2ReportApiResponse = unknown;
export type PreviewBidV2ReportApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type StartBidV2SigningApiResponse =
  /** status 200 OK */ StartBidV2SigningResponseDto;
export type StartBidV2SigningApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  startBidV2SigningRequestDto: StartBidV2SigningRequestDto;
};
export type CancelBidV2SigningApiResponse =
  /** status 200 OK */ CancelBidV2SigningResponseDto;
export type CancelBidV2SigningApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  cancelBidV2SigningRequestDto: CancelBidV2SigningRequestDto;
};
export type GetBidV2SigningPreflightApiResponse =
  /** status 200 OK */ BidV2PreflightDto;
export type GetBidV2SigningPreflightApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type AcceptBidTermsApiResponse = /** status 200 OK */ BidV2Dto;
export type AcceptBidTermsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type CreateUploadForBidV2ApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type WithdrawBidV2ApiResponse = /** status 200 OK */ BidV2Dto;
export type WithdrawBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type GetContributingEntityApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type GetContributingEntityApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
};
export type UpdateContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type UpdateContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
  updateContributingEntityResponseRequestDto: UpdateContributingEntityResponseRequestDto;
};
export type UpdateContributingEntityCommitmentApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type UpdateContributingEntityCommitmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
  updateContributingEntityCommitmentRequestDto: UpdateContributingEntityCommitmentRequestDto;
};
export type UpdateContributingEntityQualificationResponsesApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type UpdateContributingEntityQualificationResponsesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
  updateContributingEntityQualificationResponsesRequestDto: UpdateContributingEntityQualificationResponsesRequestDto;
};
export type SubmitContributingEntityResponseApiResponse =
  /** status 200 OK */ ContributingEntityDetailDto;
export type SubmitContributingEntityResponseApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  entityId: string;
};
export type GetPortalSourcingEventsApiResponse =
  /** status 200 OK */ PortalSourcingEventsResponse;
export type GetPortalSourcingEventsApiArg = {
  cursor?: string;
  limit?: number;
  q?: string;
  lifecycle?: (
    | "OPEN"
    | "DEADLINE_PASSED"
    | "UNDER_EVALUATION"
    | "AWARDED"
    | "CANCELLED"
    | "CONCLUDED"
  )[];
};
export type GetPortalSourcingEventApiResponse =
  /** status 200 OK */ PortalSourcingEventDetailDto;
export type GetPortalSourcingEventApiArg = {
  eventId: string;
};
export type GetPortalSeV2AttachmentUploadApiResponse =
  /** status 200 OK */ SeV2AttachmentUploadDto;
export type GetPortalSeV2AttachmentUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
};
export type GetPortalAwardLetterApiResponse =
  /** status 200 OK */ PortalAwardLetterDto;
export type GetPortalAwardLetterApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateBidV2ApiResponse = /** status 201 Created */ BidV2Dto;
export type CreateBidV2ApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalDocumentDownloadLinkApiResponse =
  /** status 200 OK */ PortalDocumentDownloadLinkResponse;
export type GetPortalDocumentDownloadLinkApiArg = {
  eventId: string;
  documentId: string;
};
export type GetPortalMyBidDocumentsApiResponse =
  /** status 200 OK */ PortalBidDocumentsResponse;
export type GetPortalMyBidDocumentsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateParticipationRequestApiResponse =
  /** status 201 Created */ ParticipationRequestDto;
export type CreateParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetMyParticipationApiResponse =
  /** status 200 OK */ MyParticipationDto;
export type GetMyParticipationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateUploadForSeV2QuestionAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForSeV2QuestionAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetPortalSeV2QuestionsApiResponse =
  /** status 200 OK */ ListSeV2QuestionsResponse;
export type GetPortalSeV2QuestionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AskSeV2QuestionApiResponse =
  /** status 201 Created */ SeV2QuestionDto;
export type AskSeV2QuestionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createSeV2QuestionRequest: CreateSeV2QuestionRequest;
};
export type SendSeV2ClarificationMessageAsSupplierApiResponse =
  /** status 201 Created */ SeV2QuestionDto;
export type SendSeV2ClarificationMessageAsSupplierApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  createSeV2QuestionMessageRequest: CreateSeV2QuestionMessageRequest;
};
export type RegisterPortalInterestApiResponse =
  /** status 200 OK */ PortalRegisterInterestResponse;
export type RegisterPortalInterestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalRegistrationStatusApiResponse =
  /** status 200 OK */ PortalRegistrationStatusResponse;
export type GetPortalRegistrationStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalSupplierInformationApiResponse =
  /** status 200 OK */ ListSupplierInformationResponse;
export type GetPortalSupplierInformationApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetAuthenticatedPortalSourcingEventsApiResponse =
  /** status 200 OK */ PortalSourcingEventsResponse;
export type GetAuthenticatedPortalSourcingEventsApiArg = {
  cursor?: string;
  limit?: number;
  q?: string;
  context?: PortalEventContextType;
  scope?: PortalEventScope;
  lifecycle?: (
    | "OPEN"
    | "DEADLINE_PASSED"
    | "UNDER_EVALUATION"
    | "AWARDED"
    | "CANCELLED"
    | "CONCLUDED"
  )[];
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetAuthenticatedPortalSourcingEventApiResponse =
  /** status 200 OK */ PortalSourcingEventDetailDto;
export type GetAuthenticatedPortalSourcingEventApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type AcceptPortalInviteApiResponse =
  /** status 200 OK */ AcceptPortalInviteResponse;
export type AcceptPortalInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreatePortalInitialBidApiResponse =
  /** status 201 Created */ PortalRoundBidCreatedDto;
export type CreatePortalInitialBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type SubmitPortalPrivateBidApiResponse =
  /** status 200 OK */ PortalRoundBidCreatedDto;
export type SubmitPortalPrivateBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type WithdrawPortalPrivateBidApiResponse =
  /** status 200 OK */ PortalRoundBidCreatedDto;
export type WithdrawPortalPrivateBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type DeclinePortalInviteApiResponse =
  /** status 200 OK */ DeclinePortalInviteResponse;
export type DeclinePortalInviteApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type GetPortalNegotiationRoundsApiResponse =
  /** status 200 OK */ ListPortalNegotiationRoundsResponse;
export type GetPortalNegotiationRoundsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreatePortalRoundBidApiResponse =
  /** status 201 Created */ PortalRoundBidCreatedDto;
export type CreatePortalRoundBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  roundId: string;
};
export type GetPortalMyBidsApiResponse =
  /** status 200 OK */ PortalMyBidsResponse;
export type GetPortalMyBidsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyContributionsApiResponse =
  /** status 200 OK */ ContributingEntityDetailListDto;
export type ListMyContributionsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type ListMyParticipationRequestsApiResponse =
  /** status 200 OK */ MyParticipationRequestsDto;
export type ListMyParticipationRequestsApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type GetParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type GetParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
};
export type UpdateParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type UpdateParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
  participationRequestPatchDto: ParticipationRequestPatchDto;
};
export type SubmitParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type SubmitParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
};
export type WithdrawParticipationRequestApiResponse =
  /** status 200 OK */ ParticipationRequestDto;
export type WithdrawParticipationRequestApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  requestId: string;
};
export type EditProductGroupApiResponse = /** status 200 OK */ ProductGroupDto;
export type EditProductGroupApiArg = {
  editProductGroupDto: EditProductGroupDto;
};
export type CreateProductGroupApiResponse =
  /** status 201 Created */ ProductGroupDto;
export type CreateProductGroupApiArg = {
  createProductGroupDto: CreateProductGroupDto;
};
export type DeleteProductGroupApiResponse = unknown;
export type DeleteProductGroupApiArg = {
  productGroupId: string;
};
export type GetProductGroupsForProjectApiResponse =
  /** status 200 OK */ ProductGroupsDto;
export type GetProductGroupsForProjectApiArg = {
  projectId: string;
};
export type GetProductTemplatesApiResponse =
  /** status 200 OK */ ProductTemplatesDto;
export type GetProductTemplatesApiArg = void;
export type CreateProjectApiResponse = /** status 201 Created */ ProjectDto;
export type CreateProjectApiArg = {
  createProjectRequest: CreateProjectRequest;
};
export type CreateProjectTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateProjectTextDocumentApiArg = {
  createProjectTextDocumentRequest: CreateProjectTextDocumentRequest;
};
export type ListTextDocumentsForProjectApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForProjectApiArg = {
  projectId: string;
};
export type GetProjectApiResponse = /** status 200 OK */ ProjectDto;
export type GetProjectApiArg = {
  projectId: string;
};
export type UpdateProjectApiResponse = /** status 200 OK */ ProjectDto;
export type UpdateProjectApiArg = {
  projectId: string;
  projectPatchDto: ProjectPatchDto;
};
export type GetProjectsApiResponse = /** status 200 OK */ ProjectsDto;
export type GetProjectsApiArg = {
  name?: string;
  status?: string;
  limit?: number;
  skip?: number;
};
export type GetProjectsByIdsApiResponse = /** status 200 OK */ ProjectsDto;
export type GetProjectsByIdsApiArg = {
  projectIds: string[];
};
export type CreateUploadForProjectDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForProjectDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  projectId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type CreateUploadForProjectApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForProjectApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  projectId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetGroupsApiResponse = /** status 200 OK */ GroupsDto;
export type GetGroupsApiArg = {
  authorization?: string;
};
export type CreateGroupApiResponse = /** status 200 OK */ GroupDto;
export type CreateGroupApiArg = {
  authorization?: string;
  createGroupDto: CreateGroupDto;
};
export type DeleteGroupApiResponse = unknown;
export type DeleteGroupApiArg = {
  authorization?: string;
  groupId: string;
};
export type GetGroupApiResponse = /** status 200 OK */ GroupDto;
export type GetGroupApiArg = {
  count?: number;
  startIndex?: number;
  authorization?: string;
  groupId: string;
};
export type UpdateGroupApiResponse = /** status 200 OK */ GroupDto;
export type UpdateGroupApiArg = {
  authorization?: string;
  groupId: string;
  updateGroupRequest: UpdateGroupRequest;
};
export type GetSchemasApiResponse = /** status 200 OK */ SchemasDto;
export type GetSchemasApiArg = void;
export type GetTokenApiResponse = /** status 200 OK */ TokenResponse;
export type GetTokenApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  authorization?: string;
};
export type GetTokenForConnectionApiResponse =
  /** status 200 OK */ TokenResponse;
export type GetTokenForConnectionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  authorization?: string;
  connectionId: string;
};
export type GetUsersApiResponse = /** status 200 OK */ UsersDto;
export type GetUsersApiArg = {
  authorization?: string;
};
export type CreateUserApiResponse = /** status 200 OK */ UserDto;
export type CreateUserApiArg = {
  authorization?: string;
  createUserDto: CreateUserDto;
};
export type DeleteUserApiResponse = unknown;
export type DeleteUserApiArg = {
  authorization?: string;
  userId: string;
};
export type GetUserApiResponse = /** status 200 OK */ UserDto;
export type GetUserApiArg = {
  authorization?: string;
  userId: string;
};
export type UpdateUserApiResponse = /** status 200 OK */ UserDto;
export type UpdateUserApiArg = {
  authorization?: string;
  userId: string;
};
export type SearchOrganizationsAndEntriesApiResponse =
  /** status 200 OK */ SearchOrganizationsAndEntriesResponse;
export type SearchOrganizationsAndEntriesApiArg = {
  name?: string;
  organizationNumber?: string;
  limit: number;
  skip?: number;
  type?: OrganizationType;
  excludeLinkedEntries?: boolean;
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type UpdateSignedDocumentMetaApiResponse =
  /** status 200 OK */ SignedDocumentDto;
export type UpdateSignedDocumentMetaApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
  updateSignedDocumentMetaRequest: UpdateSignedDocumentMetaRequest;
};
export type GetSignedDocumentDownloadLinkApiResponse =
  /** status 200 OK */ GetDownloadLinkResponse;
export type GetSignedDocumentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
};
export type GetSignedAttachmentDownloadLinkApiResponse =
  /** status 200 OK */ GetDownloadLinkResponse;
export type GetSignedAttachmentDownloadLinkApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  docId: string;
  attachmentId: string;
};
export type CreateFencySignedDocumentSessionApiResponse =
  /** status 200 OK */ FencySessionResponse;
export type CreateFencySignedDocumentSessionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type FencySyncSignedDocumentApiResponse = unknown;
export type FencySyncSignedDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type ListSourcingEventTemplatesApiResponse =
  /** status 200 OK */ SourcingEventTemplatesDto;
export type ListSourcingEventTemplatesApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
};
export type CreateSourcingEventTemplateApiResponse =
  /** status 201 Created */ SourcingEventTemplateDto;
export type CreateSourcingEventTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createSourcingEventTemplateRequest: CreateSourcingEventTemplateRequest;
};
export type UpdateSourcingEventTemplateApiResponse =
  /** status 200 OK */ SourcingEventTemplateDto;
export type UpdateSourcingEventTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  updateSourcingEventTemplateRequest: UpdateSourcingEventTemplateRequest;
};
export type DeleteSourcingEventTemplateApiResponse = unknown;
export type DeleteSourcingEventTemplateApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  id: string;
};
export type CreateSourcingEventV2TextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateSourcingEventV2TextDocumentApiArg = {
  createSourcingEventV2TextDocumentRequest: CreateSourcingEventV2TextDocumentRequest;
};
export type ListTextDocumentsForSourcingEventV2ApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForSourcingEventV2ApiArg = {
  eventId: string;
};
export type CreateSourcingEventTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type CreateSourcingEventTextDocumentApiArg = {
  createSourcingEventTextDocumentRequest: CreateSourcingEventTextDocumentRequest;
};
export type ListTextDocumentsForSourcingEventApiResponse =
  /** status 200 OK */ TextDocumentsDto;
export type ListTextDocumentsForSourcingEventApiArg = {
  eventId: string;
};
export type GetBseBidApiResponse = /** status 200 OK */ BidViewForSupplierDto;
export type GetBseBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type UpdateBseBidApiResponse =
  /** status 200 OK */ BidViewForSupplierDto;
export type UpdateBseBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  editBidRequest: EditBidRequest;
};
export type CreateUploadForBseBidDescriptionApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBseBidDescriptionApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type CreateUploadForBseBidApiResponse = /** status 200 OK */ UploadDto;
export type CreateUploadForBseBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type GetBseSupplierViewApiResponse =
  /** status 200 OK */ SourcingEventSupplierView;
export type GetBseSupplierViewApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateBseAnnouncementApiResponse = /** status 200 OK */ BseDto;
export type CreateBseAnnouncementApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createBseAnnouncementRequest: CreateBseAnnouncementRequest;
};
export type UnDeliverBseBidApiResponse =
  /** status 200 OK */ BidViewForSupplierDto;
export type UnDeliverBseBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  bidId: string;
};
export type AcceptInvitationToBidApiResponse =
  /** status 200 OK */ SourcingEventSupplierView;
export type AcceptInvitationToBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DeclineInvitationToBidApiResponse =
  /** status 200 OK */ SourcingEventSupplierView;
export type DeclineInvitationToBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type DownloadPublicProcurementProtocolPartOneApiResponse = unknown;
export type DownloadPublicProcurementProtocolPartOneApiArg = {
  eventId: string;
  getProcurementProtocolRequest: GetProcurementProtocolRequest;
};
export type DownloadQaReportApiResponse = unknown;
export type DownloadQaReportApiArg = {
  eventId: string;
};
export type CreateBseQuestionAsSupplierApiResponse =
  /** status 200 OK */ SourcingEventSupplierView;
export type CreateBseQuestionAsSupplierApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  createBseQuestionRequest: CreateBseQuestionRequest;
};
export type CreateBseQuestionCommentAsSupplierApiResponse =
  /** status 200 OK */ SourcingEventSupplierView;
export type CreateBseQuestionCommentAsSupplierApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
  questionId: string;
  createBseQuestionCommentRequest: CreateBseQuestionCommentRequest;
};
export type MarkAsViewedApiResponse =
  /** status 200 OK */ SourcingEventSupplierView;
export type MarkAsViewedApiArg = {
  negotiationRoundId?: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  eventId: string;
};
export type CreateDraftBidApiResponse =
  /** status 200 OK */ BidViewForSupplierDto;
export type CreateDraftBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  createDraftBidRequest: CreateDraftBidRequest;
};
export type DeleteBidApiResponse = unknown;
export type DeleteBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
};
export type ListBidsCreatedByDepartmentApiResponse =
  /** status 200 OK */ ListBidsResponse;
export type ListBidsCreatedByDepartmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  depId: string;
};
export type GetSeEmailInviteApiResponse = /** status 200 OK */ SeEmailInviteDto;
export type GetSeEmailInviteApiArg = {
  secret: string;
  inviteId: string;
};
export type AcceptSeEmailInviteApiResponse = unknown;
export type AcceptSeEmailInviteApiArg = {
  secret: string;
  cookie?: string;
  organizationId?: string;
  personId?: string;
  inviteId: string;
};
export type DeliverBidApiResponse = /** status 200 OK */ BidViewForSupplierDto;
export type DeliverBidApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  deliverBidRequest: DeliverBidRequest;
};
export type ListSeSupplierViewsApiResponse =
  /** status 200 OK */ ListSeSupplierViewsResponse;
export type ListSeSupplierViewsApiArg = {
  statuses?: string[];
  cookie?: string;
  organizationId?: string;
  personId?: string;
  orgId: string;
};
export type GetProductGroupsAsSupplierApiResponse =
  /** status 200 OK */ SupplierProductGroupsDto;
export type GetProductGroupsAsSupplierApiArg = {
  sourcingEventId: string;
};
export type CreateUploadForBidV2AwardCriterionAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidV2AwardCriterionAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createBidV2AwardCriterionAttachmentUploadRequestDto: CreateBidV2AwardCriterionAttachmentUploadRequestDto;
};
export type CreateUploadForBidV2MinimumRequirementAttachmentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidV2MinimumRequirementAttachmentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createBidV2MinimumRequirementAttachmentUploadRequestDto: CreateBidV2MinimumRequirementAttachmentUploadRequestDto;
};
export type CreateUploadForBidV2QualificationEvidenceApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForBidV2QualificationEvidenceApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  bidId: string;
  uploadId: string;
  createBidV2QualificationEvidenceUploadRequestDto: CreateBidV2QualificationEvidenceUploadRequestDto;
};
export type UpdateTextDocumentApiResponse =
  /** status 201 Created */ TextDocumentDto;
export type UpdateTextDocumentApiArg = {
  updateTextDocumentRequest: UpdateTextDocumentRequest;
};
export type DeleteTextDocumentApiResponse = unknown;
export type DeleteTextDocumentApiArg = {
  id: string;
};
export type GetTextDocumentUploadStatusApiResponse =
  /** status 200 OK */ UploadStatusDto;
export type GetTextDocumentUploadStatusApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  textDocumentId: string;
  uploadId: string;
};
export type CreateUploadForTextDocumentApiResponse =
  /** status 200 OK */ UploadDto;
export type CreateUploadForTextDocumentApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  textDocumentId: string;
  uploadId: string;
  createUploadRequestDto: CreateUploadRequestDto;
};
export type DeleteUploadApiResponse = /** status 200 OK */ UploadDto;
export type DeleteUploadApiArg = {
  cookie?: string;
  organizationId?: string;
  personId?: string;
  uploadId: string;
};
export type String = string;
export type AdminMigrateFencyResponse = {
  successCount: number;
  failureCount: number;
};
export type AdminMigrateFencyRequest = {
  organizationId: string;
  documentType: MigrationDocumentType;
  limit: number;
};
export type AdminRestampFencyAccessRequest = {
  organizationId?: string | null;
  limit: number;
};
export type AdminMigrateFencyContractMetadataRequest = {
  organizationId: string;
  limit: number;
};
export type AdminFencyMigrationDocumentKindStats = {
  totalDocuments: number;
  missingFencyConfigCount: number;
  synchronizationErrorCount: number;
  missingAccessCount: number;
};
export type AdminFencyMigrationContractStats = {
  totalContracts: number;
  missingMemoryCount: number;
  synchronizationErrorCount: number;
  missingAccessCount: number;
};
export type AdminFencyMigrationStatsResponse = {
  regularDocuments: AdminFencyMigrationDocumentKindStats;
  signedDocuments: AdminFencyMigrationDocumentKindStats;
  contractMetadata: AdminFencyMigrationContractStats;
};
export type CallingCodeDto = {
  countryAlpha3Code: string;
  countryName: string;
  value: string;
};
export type PhoneNumberDto = {
  callingCode: CallingCodeDto;
  number: string;
};
export type PersonDto = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  corporateTitle?: string | null;
  phoneNumber?: PhoneNumberDto | null;
};
export type CountryDto = {
  id: string;
  alpha3Code: string;
  name: string;
};
export type IndustryDto = {
  id: string;
  name: string;
};
export type SubscriptionDto = {
  hasBuyerAccess: boolean;
  hasContractAccess: boolean;
  hasSignatureAccess: boolean;
  hasBankIdAccess: boolean;
  hasProductAccess: boolean;
  hasProjectAccess: boolean;
  hasNegotiationAccess: boolean;
  hasAiAccess: boolean;
  hasDocumentTemplateAccess: boolean;
  hasIFRSAccess: boolean;
  hasOrganizationAssessmentAccess: boolean;
  hasFencyContractSearchAccess: boolean;
  hasAssistantAccess: boolean;
  hasNeedsAccess: boolean;
  fencySyncEnabled: boolean;
};
export type AvailabilityReasonDto = {
  code: AvailabilityReasonCodeDto;
  kind: ReasonKindDto;
};
export type OperationAvailabilityDto = {
  operation: string;
  allowed: boolean;
  reason?: AvailabilityReasonDto | null;
};
export type DepartmentDto = {
  id: string;
  name: string;
  isDefault: boolean;
  active: boolean;
  operations?: OperationAvailabilityDto[];
};
export type AdminOrgDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  industries: IndustryDto[];
  aboutUs?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  size?: OrganizationSize | null;
  subscription: SubscriptionDto;
  departments: DepartmentDto[];
  azureTenantId?: string | null;
  azureUsersDefaultRole: OrgUserInviteRole;
  canSeeDeliveredBidsBeforeDeadline: boolean;
  buyerLegalType?: BuyerLegalType | null;
};
export type AdminListOrganizationsResponse = {
  orgs: AdminOrgDto[];
  count: number;
};
export type CustomAmountFieldDto = {
  type: "CustomAmount";
  id: string;
  name: string;
  isInternal: boolean;
  amount?: number | null;
  currency?: string | null;
};
export type CustomBooleanFieldDto = {
  type: "CustomBoolean";
  id: string;
  name: string;
  isInternal: boolean;
  isChecked?: boolean | null;
};
export type CustomDateFieldDto = {
  type: "CustomDate";
  id: string;
  name: string;
  isInternal: boolean;
  date?: string | null;
};
export type CustomEmailFieldDto = {
  type: "CustomEmail";
  id: string;
  name: string;
  isInternal: boolean;
  email?: string | null;
};
export type CustomEnumFieldDto = {
  type: "CustomEnum";
  id: string;
  name: string;
  isInternal: boolean;
  options?: string[] | null;
  value?: string | null;
};
export type CustomMultiEnumFieldDto = {
  type: "CustomMultiEnum";
  id: string;
  name: string;
  isInternal: boolean;
  options?: string[] | null;
  values?: string[] | null;
};
export type CustomNumberFieldDto = {
  type: "CustomNumber";
  id: string;
  name: string;
  isInternal: boolean;
  value?: number | null;
};
export type CustomPercentageFieldDto = {
  type: "CustomPercentage";
  id: string;
  name: string;
  isInternal: boolean;
  value?: number | null;
};
export type CustomPersonFieldDto = {
  type: "CustomPerson";
  id: string;
  name: string;
  isInternal: boolean;
  person?: PersonDto | null;
};
export type CustomPhoneFieldDto = {
  type: "CustomPhone";
  id: string;
  name: string;
  isInternal: boolean;
  number?: string | null;
  callingCode?: string | null;
};
export type CustomRichTextFieldDto = {
  type: "CustomRichText";
  id: string;
  name: string;
  isInternal: boolean;
  text?: string | null;
};
export type CustomTagFieldDto = {
  type: "CustomTag";
  id: string;
  name: string;
  isInternal: boolean;
  tag?: string | null;
};
export type CustomTextFieldDto = {
  type: "CustomText";
  id: string;
  name: string;
  isInternal: boolean;
  text?: string | null;
};
export type CustomUrlFieldDto = {
  type: "CustomUrl";
  id: string;
  name: string;
  isInternal: boolean;
  url?: string | null;
};
export type CustomContractDataFieldDto =
  | CustomAmountFieldDto
  | CustomBooleanFieldDto
  | CustomDateFieldDto
  | CustomEmailFieldDto
  | CustomEnumFieldDto
  | CustomMultiEnumFieldDto
  | CustomNumberFieldDto
  | CustomPercentageFieldDto
  | CustomPersonFieldDto
  | CustomPhoneFieldDto
  | CustomRichTextFieldDto
  | CustomTagFieldDto
  | CustomTextFieldDto
  | CustomUrlFieldDto;
export type ContractDataFieldSectionDto = {
  id: string;
  name: string;
  fields: CustomContractDataFieldDto[];
};
export type LeadTimeDto = {
  unit: LeadTimeUnit;
  amount: number;
};
export type ContractNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
  contractRoles: ContractRole[];
};
export type ContractDateReminderDto = {
  leadTime: LeadTimeDto;
  receivers: ContractNotificationReceiversDto;
};
export type ReminderIntervalDto = {
  unit: IntervalUnit;
  amount: number;
};
export type RecurringContractReminderDto = {
  interval: ReminderIntervalDto;
  receivers: ContractNotificationReceiversDto;
};
export type ContractNotificationSettingsDto = {
  startDateNotifications: ContractDateReminderDto[];
  endDateNotifications: ContractDateReminderDto[];
  warrantyExpirationNotifications: ContractDateReminderDto[];
  renewalDateNotifications: ContractDateReminderDto[];
  terminationDateNotifications: ContractDateReminderDto[];
  noticePeriodNotifications: ContractDateReminderDto[];
  optionExecutionDeadlineNotifications: ContractDateReminderDto[];
  optionStartDateNotifications: ContractDateReminderDto[];
  noEndDateNotifications: RecurringContractReminderDto[];
};
export type ContractTaskNotificationReceiversDto = {
  contractTaskRoles: ContractTaskRole[];
};
export type ContractTaskDateReminderDto = {
  leadTime: LeadTimeDto;
  receivers: ContractTaskNotificationReceiversDto;
};
export type ContractTaskNotificationSettingsDto = {
  dueDateNotifications: ContractTaskDateReminderDto[];
};
export type SourcingEventNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
  sourcingEventRoles: SourcingEventRole[];
};
export type SourcingEventDateReminderDto = {
  leadTime: LeadTimeDto;
  receivers: SourcingEventNotificationReceiversDto;
};
export type SourcingEventNotificationSettingsDto = {
  bidDeliveryDeadlineNotifications: SourcingEventDateReminderDto[];
};
export type SupplierNotificationReceiversDto = {
  persons: PersonDto[];
  organizationRoles: OrganizationRoleType[];
};
export type SupplierNotificationSettingsDto = {
  inviteReceivers: SupplierNotificationReceiversDto;
  messageReceivers: SupplierNotificationReceiversDto;
};
export type DefaultNotificationSettingsDto = {
  contractNotificationSettings: ContractNotificationSettingsDto;
  contractTaskNotificationSettings: ContractTaskNotificationSettingsDto;
  sourcingEventNotificationSettings: SourcingEventNotificationSettingsDto;
  supplierNotificationSettings?: SupplierNotificationSettingsDto | null;
};
export type MinimalOrgDto = {
  type: OrganizationType;
  id: string;
  name: string;
  organizationNumber?: string | null;
  country: CountryDto;
};
export type ScimGroupDto = {
  id: string;
  displayName: string;
  memberCount: number;
};
export type OrgDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  organizationNumber?: string | null;
  industries: IndustryDto[];
  aboutUs?: string | null;
  standardTerms?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
  contactEmail?: string | null;
  contactPhone?: PhoneNumberDto | null;
  buyerLegalType?: BuyerLegalType | null;
  defaultRegulation?: Regulation | null;
  size?: OrganizationSize | null;
  subscription: SubscriptionDto;
  departments: DepartmentDto[];
  azureTenantId?: string | null;
  allowScimUsersOnly?: boolean | null;
  enforceEntraIDAuthentication?: boolean | null;
  azureUsersDefaultRole: OrgUserInviteRole;
  canEdit: boolean;
  canLinkOrganizationEntry: boolean;
  canManageSupplierInvites: boolean;
  canManageUsers: boolean;
  canCreateEvent: boolean;
  canCreateContract: boolean;
  canCreateProject: boolean;
  canReportNeed: boolean;
  hasProductAccess: boolean;
  hasProjectAccess: boolean;
  hasAiAccess: boolean;
  hasFencyContractSearchAccess: boolean;
  fencySyncEnabled: boolean;
  hasDocumentTemplateAccess: boolean;
  hasIFRSAccess: boolean;
  roles: OrganizationRoleType[];
  canOnlySeeCreatedEvents: boolean;
  canOnlySeeCreatedContracts: boolean;
  canSeeDeliveredBidsBeforeDeadline: boolean;
  customContractSections?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  defaultNotificationSettings?: DefaultNotificationSettingsDto | null;
  internalParties?: MinimalOrgDto[] | null;
  scimGroups?: ScimGroupDto[] | null;
  contactPersons?: PersonDto[] | null;
};
export type EditBuyerLegalType = {
  value?: BuyerLegalType | null;
};
export type AdminUpdateOrganizationRequest = {
  name?: string | null;
  hasContractAccess?: boolean | null;
  hasBuyerAccess?: boolean | null;
  hasSignatureAccess?: boolean | null;
  hasBankIdAccess?: boolean | null;
  hasProductAccess?: boolean | null;
  hasProjectAccess?: boolean | null;
  hasAiAccess?: boolean | null;
  hasDocumentTemplateAccess?: boolean | null;
  hasIFRSAccess?: boolean | null;
  hasOrganizationAssessmentAccess?: boolean | null;
  hasNegotiationAccess?: boolean | null;
  canSeeDeliveredBidsBeforeDeadline?: boolean | null;
  buyerLegalType?: EditBuyerLegalType | null;
  hasFencyContractSearchAccess?: boolean | null;
  hasAssistantAccess?: boolean | null;
  hasNeedsAccess?: boolean | null;
  fencySyncEnabled?: boolean | null;
};
export type AdminChangeOrganizationOwnerRequest = {
  newOwnerPersonId: string;
};
export type GptMessage = {
  role: GPTRole;
  content: string;
};
export type AiChatResponse = {
  messages: GptMessage[];
};
export type JsonSchemaDto = {
  name: string;
  schema: string;
};
export type AiChatRequest = {
  model: AiModelDto;
  messages: GptMessage[];
  reasoningEffort: string;
  responseFormat?: JsonSchemaDto | null;
};
export type AiCompletionDto = {
  content: string;
};
export type AiCompletionMessageDto = {
  role: string;
  content: string;
};
export type CreateAiCompletionRequest = {
  feature: string;
  messages: AiCompletionMessageDto[];
  jsonSchema?: string | null;
};
export type ScoreRangeDto = {
  minValue: number;
  maxValue?: number | null;
  description?: string | null;
};
export type AssessmentCriterionDto = {
  id: string;
  name: string;
  description?: string | null;
  scoreRange: ScoreRangeDto;
  order: number;
};
export type AssessmentDimensionDto = {
  id: string;
  name: string;
  description?: string | null;
  weight: number;
  criteria: AssessmentCriterionDto[];
  order: number;
};
export type AssessmentTemplateDto = {
  id: string;
  templateId: string;
  name: string;
  description?: string | null;
  owner: string;
  dimensions: AssessmentDimensionDto[];
  isActive: boolean;
  templateVersion: number;
  createdAt: string;
  modifiedAt: string;
};
export type CreateAssessmentCriterionDto = {
  name: string;
  description?: string | null;
  scoreRange: ScoreRangeDto;
  order?: number;
};
export type CreateAssessmentDimensionDto = {
  name: string;
  description?: string | null;
  weight?: number;
  criteria?: CreateAssessmentCriterionDto[];
  order?: number;
};
export type CreateAssessmentTemplateRequestDto = {
  name: string;
  description?: string | null;
  dimensions?: CreateAssessmentDimensionDto[];
  templateFamilyId?: string | null;
};
export type AssessedEntityDto = {
  organizationId?: string | null;
  organizationEntryId?: string | null;
};
export type CriterionScoreDto = {
  criterionId: string;
  criterionName: string;
  score?: number | null;
  scoreRange: ScoreRangeDto;
  comment?: string | null;
  lastUpdated: string;
};
export type DimensionScoreDto = {
  dimensionId: string;
  dimensionName: string;
  criterionScores: CriterionScoreDto[];
  directScore?: number | null;
  scoreRange?: ScoreRangeDto | null;
  comment?: string | null;
  lastUpdated: string;
};
export type AssessmentDto = {
  id: string;
  name: string;
  description?: string | null;
  assessedEntity: AssessedEntityDto;
  owner: MinimalOrgDto;
  template: AssessmentTemplateDto;
  assessor: PersonDto;
  dimensionScores: DimensionScoreDto[];
  status: string;
  completedAt?: string | null;
  createdAt: string;
  modifiedAt: string;
};
export type CreateCriterionScoreDto = {
  criterionId: string;
  score?: number | null;
  comment?: string | null;
};
export type CreateDimensionScoreDto = {
  dimensionId: string;
  directScore?: number | null;
  scoreRange?: ScoreRangeDto | null;
  comment?: string | null;
  criterionScores?: CreateCriterionScoreDto[] | null;
};
export type CreateAssessmentRequestDto = {
  name: string;
  description?: string | null;
  assessedEntity: AssessedEntityDto;
  templateId: string;
  dimensionScores?: CreateDimensionScoreDto[];
};
export type ContractDataFieldDto = {
  type: ContractDataFieldType;
  name: ContractDataFieldNameDto;
};
export type BaseDataDto = {
  callingCodes: CallingCodeDto[];
  countries: CountryDto[];
  contractDataFields: ContractDataFieldDto[];
};
export type DocumentAddedClientEvent = {
  documentId: string;
};
export type FieldErrorDto = {
  field: string;
  code: string;
  params?: {
    [key: string]: string;
  };
};
export type ApiErrorDto = {
  errorCode: string;
  fieldErrors?: FieldErrorDto[] | null;
};
export type AllTypes = {
  documentAddedClientEvent: DocumentAddedClientEvent;
  apiError: ApiErrorDto;
  apiErrorCodes: string[];
};
export type AgentAuditEntryDto = {
  conversationId: string;
  turnId: string;
  eventId?: string | null;
  toolName: string;
  riskTier: string;
  outcome: AgentAuditOutcome;
  proposedArgs: string;
  deviationCode?: string | null;
  userInstruction: string;
};
export type AgentConversationSummaryDto = {
  id: string;
  title: string;
  modifiedAt: string;
};
export type ListAgentConversationsResponse = {
  conversations: AgentConversationSummaryDto[];
};
export type PlanToolCallDto = {
  id: string;
  name: string;
  arguments: string;
};
export type PlanMessageDto = {
  role: string;
  content?: string | null;
  toolCalls?: PlanToolCallDto[] | null;
  toolCallId?: string | null;
};
export type AgentConversationDto = {
  id: string;
  title: string;
  messages: PlanMessageDto[];
  clientState: string;
  modifiedAt: string;
};
export type CreateAgentConversationRequest = {
  title: string;
};
export type UpdateAgentConversationRequest = {
  title: string;
  messages: PlanMessageDto[];
  clientState: string;
};
export type AgentDocumentSearchSessionDto = {
  clientToken?: string | null;
  indexedDocumentCount?: number | null;
  pendingDocumentCount?: number | null;
};
export type AgentDocumentSearchScopeDto = {
  entityType: AgentDocumentScopeTypeDto;
  entityId: string;
};
export type CreateAgentDocumentSearchSessionRequest = {
  scope?: AgentDocumentSearchScopeDto | null;
};
export type AgentDocumentOwnerDto = {
  entityType: AgentDocumentScopeTypeDto;
  entityId: string;
  entityTitle: string;
};
export type AgentDocumentSourceDto = {
  memoryId: string;
  documentName: string;
  downloadUrl: string;
  owner?: AgentDocumentOwnerDto | null;
};
export type AgentDocumentSourcesDto = {
  sources: AgentDocumentSourceDto[];
};
export type ResolveAgentDocumentSourcesRequest = {
  memoryIds: string[];
};
export type AgentSelectableModelDto = {
  id: string;
  label: string;
};
export type AgentModelsDto = {
  models: AgentSelectableModelDto[];
  defaultModelId: string;
};
export type AgentPlanResponseDto = {
  content?: string | null;
  toolCalls?: PlanToolCallDto[];
  finishReason: string;
};
export type PlanToolDto = {
  name: string;
  description: string;
  parameters: string;
};
export type AgentPlanRequestDto = {
  messages: PlanMessageDto[];
  tools: PlanToolDto[];
};
export type OrgPitchDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  aboutUs?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  size?: OrganizationSize | null;
};
export type OrganizationEmailInviteDto = {
  id: string;
  email: string;
  language: EmailInviteLanguage;
  status: EmailInviteStatusDto;
};
export type OrganizationInviteDto = {
  id: string;
  organizationId: string;
  organizationName: string;
  persons: PersonDto[];
  status: OrganizationInviteStatus;
  bidId?: string | null;
  emailInvites: OrganizationEmailInviteDto[];
  createdAt: string;
};
export type ContactPersonDto = {
  email: string;
  name: string;
  language: EmailInviteLanguage;
  title?: string | null;
  phoneNumber?: PhoneNumberDto | null;
};
export type LinkDto = {
  linkedBy: PersonDto;
  linkedAt: string;
  organizationId: string;
  organizationName: string;
};
export type OrganizationEntryDto = {
  id: string;
  name: string;
  country: CountryDto;
  organizationNumber: string;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
  contactPersons?: ContactPersonDto[] | null;
  link?: LinkDto | null;
};
export type EmailInviteDto = {
  id: string;
  email: string;
  language: EmailInviteLanguage;
  lastReminderSentAt?: string | null;
  status: EmailInviteStatusDto;
  openedAt?: string | null;
  organizationEntry?: OrganizationEntryDto | null;
};
export type ViewDocumentAsOwnerDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  uploadedBy: PersonDto;
  s3Key: string;
  fromUploadId: string;
  tags: string[];
  fencyContentStatus?: FencyContentStatus | null;
  category?: DocumentCategory | null;
};
export type UploadDto = {
  id: string;
  fileName: string;
  mimeType: string;
  fileExtension: string;
  url: string;
  renamedXAmzDate: string;
  renamedXAmzSignature: string;
  renamedXAmzAlgorithm: string;
  renamedXAmzCredential: string;
  policy: string;
  key: string;
};
export type DraftFieldsDto = {
  description?: string | null;
  deadline?: string | null;
  uploads: UploadDto[];
};
export type WinningProductBidsDto = {
  productId: string;
  bids: string[];
};
export type WinningProductGroupBidsDto = {
  productGroupId: string;
  bids: WinningProductBidsDto[];
};
export type PublishedFieldsDto = {
  description: string;
  deadline: string;
  uploads: UploadDto[];
  bidIds: string[];
  publishedAt: string;
  publishedBy: PersonDto;
  selectedProductGroupBids?: WinningProductGroupBidsDto[] | null;
};
export type EventValueDto = {
  value?: number | null;
  currency: Currency;
};
export type AwardedFieldsDto = {
  description: string;
  deadline: string;
  bidIds: string[];
  publishedAt: string;
  publishedBy: PersonDto;
  awardedAt: string;
  awardedBy: PersonDto;
  winningBidIds: string[];
  winningProductBids?: WinningProductGroupBidsDto[] | null;
  eventValue?: EventValueDto | null;
  messageToWinners?: string | null;
  messageToLosers?: string | null;
};
export type BseQuestionCommentDto = {
  id: string;
  createdAt: string;
  content: string;
  commenter: PersonDto;
};
export type BseQuestionDto = {
  id: string;
  status: BseQuestionStatus;
  askedByPerson: PersonDto;
  askedByOrgName: string;
  askedToOrganization: string;
  askedAt: string;
  subject: string;
  content: string;
  comments: BseQuestionCommentDto[];
  announcementId?: string | null;
};
export type BseAnnouncementDto = {
  id: string;
  createdByPerson: PersonDto;
  createdAt: string;
  title: string;
  content: string;
};
export type InternalMessageDto = {
  id: string;
  value: string;
  createdBy?: PersonDto | null;
  createdAt: string;
};
export type ParentProjectDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  externalId?: string | null;
  name: string;
  startDate?: string | null;
  endDate?: string | null;
};
export type ChildProjectDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  externalId?: string | null;
  name: string;
  startDate?: string | null;
  endDate?: string | null;
};
export type ProjectTypeDto = {
  id: string;
  name: ProjectTypeName;
};
export type ProjectDocumentDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  uploadedBy: PersonDto;
  s3Key: string;
  fromUploadId: string;
  tags: string[];
};
export type ProjectDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  status: ProjectStatus;
  homeDepartment?: DepartmentDto | null;
  externalId?: string | null;
  name: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  parentId?: string | null;
  parent?: ParentProjectDto | null;
  children?: ChildProjectDto[] | null;
  projectResponsibleId?: string | null;
  projectResponsible?: PersonDto | null;
  sourcingResponsibleId?: string | null;
  sourcingResponsible?: PersonDto | null;
  projectTypeId?: string | null;
  projectType?: ProjectTypeDto | null;
  documents?: ProjectDocumentDto[] | null;
  canEdit?: boolean;
  uploads?: UploadDto[] | null;
  descriptionDocuments?: ProjectDocumentDto[] | null;
};
export type NegotiationInviteDto = {
  id: string;
  organizationId: string;
  organizationName: string;
  persons: PersonDto[];
  emailInvites: OrganizationEmailInviteDto[];
  message?: string | null;
  status: OrganizationInviteStatus;
  bidId?: string | null;
};
export type NegotiationRoundDto = {
  id: string;
  stateName: NegotiationStateName;
  status: NegotiationRoundStatusDto;
  roundNumber: number;
  deadline: string;
  invites: NegotiationInviteDto[];
  description?: string | null;
  documents: ViewDocumentAsOwnerDto[];
  descriptionDocuments: ViewDocumentAsOwnerDto[];
  uploads: UploadDto[];
  isFinalRound?: boolean | null;
  createdAt: string;
  modifiedAt: string;
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
  questions: BseQuestionDto[];
};
export type NegotiationContextDto = {
  rounds: NegotiationRoundDto[];
};
export type BseDto = {
  id: string;
  status: BseStatusDto;
  stateName: BseStateNameDto;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  owningOrganization: OrgPitchDto;
  organizationInvites: OrganizationInviteDto[];
  emailInvites: EmailInviteDto[];
  title: string;
  industries: IndustryDto[];
  documents: ViewDocumentAsOwnerDto[];
  descriptionDocuments: ViewDocumentAsOwnerDto[];
  timezone: string;
  referenceId?: string | null;
  draftFields?: DraftFieldsDto | null;
  publishedFields?: PublishedFieldsDto | null;
  awardedFields?: AwardedFieldsDto | null;
  questions?: BseQuestionDto[] | null;
  announcements: BseAnnouncementDto[];
  canEdit: boolean;
  internalConversation: InternalMessageDto[];
  projects?: ProjectDto[] | null;
  negotiationContext?: NegotiationContextDto | null;
};
export type CreateSourcingEventRequest = {
  title: string;
  timezone: string;
  projectId?: string | null;
  deadline?: string | null;
};
export type EditDescription = {
  value?: string | null;
};
export type EditDeadline = {
  value: string;
};
export type EditTimezone = {
  value: string;
};
export type EditReferenceId = {
  value?: string | null;
};
export type OrganizationEmailInviteInputDto = {
  email: string;
  language: EmailInviteLanguage;
};
export type OrganizationInviteInput = {
  organizationId: string;
  personIds: string[];
  emailInvites: OrganizationEmailInviteInputDto[];
};
export type AddOrganizationEntryEmailInviteRequest = {
  email: string;
  language: EmailInviteLanguage;
  organizationEntryId: string;
};
export type AddOrganizationEmailInviteRequest = {
  email: string;
  language: EmailInviteLanguage;
  organizationId: string;
};
export type EditEventValue = {
  value: EventValueDto;
};
export type EditSourcingEventRequest = {
  title?: string | null;
  description?: EditDescription | null;
  deadline?: EditDeadline | null;
  timezone?: EditTimezone | null;
  industryIds?: string[] | null;
  editReferenceId?: EditReferenceId | null;
  removeDocument?: string | null;
  removeDescriptionDocument?: string | null;
  organizationToInviteInput?: OrganizationInviteInput | null;
  organizationInviteIdToRemove?: string | null;
  orgEntryEmailInvitesToAdd?: AddOrganizationEntryEmailInviteRequest[] | null;
  orgEmailInvitesToAdd?: AddOrganizationEmailInviteRequest[] | null;
  emailInviteIdToRemove?: string | null;
  eventValue?: EditEventValue | null;
  emailInviteSecretOverride?: string | null;
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
  addInternalMessage?: string | null;
  editProjects?: string[] | null;
};
export type AwardToBidRequest = {
  bidIds: string[];
  messageToWinners?: string | null;
  messageToLosers?: string | null;
  eventValue?: EventValueDto | null;
};
export type NumberFieldDto = {
  type: "Number";
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
  value?: number | null;
};
export type BooleanFieldDto = {
  type: "Boolean";
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
  value?: boolean | null;
};
export type TextFieldDto = {
  type: "Text";
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
  value?: string | null;
};
export type ProductFieldDto = BooleanFieldDto | NumberFieldDto | TextFieldDto;
export type ProductBidDto = {
  productId: string;
  unitPrice: NumberFieldDto;
  productFields: ProductFieldDto[];
};
export type ProductGroupBidDto = {
  productGroupId: string;
  productBids: ProductBidDto[];
};
export type ViewSharedDocumentDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  fromUploadId: string;
};
export type ReceivedBseBidDto = {
  id: string;
  owningOrganization: OrgPitchDto;
  forSourcingEventId: string;
  forNegotiationRound?: string | null;
  comment: string;
  products?: ProductGroupBidDto[] | null;
  documents: ViewSharedDocumentDto[];
  commentDocuments: ViewSharedDocumentDto[];
  uniqueForViewDeliveredBasicBidAsBuyerDto?: boolean;
  contractId?: string | null;
};
export type ListReceivedBidsResponse = {
  bids: ReceivedBseBidDto[];
};
export type CancelSourcingEventRequest = {
  reason?: string | null;
};
export type CloseSourcingEventRequest = {
  reason?: string | null;
};
export type CreateUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
};
export type CreateNegotiationRoundRequest = {
  deadline: string;
  isFinalRound?: boolean | null;
};
export type CreateBseQuestionRequest = {
  subject: string;
  content: string;
  announcementId?: string | null;
  askedToOrganizationId?: string | null;
  negotiationRoundId?: string | null;
};
export type UpdateBseQuestionRequest = {
  status: BseQuestionStatus;
  negotiationRoundId?: string | null;
};
export type CreateBseQuestionCommentRequest = {
  content: string;
  negotiationRoundId?: string | null;
};
export type EvaluateSingleBidWithAiRequest = {
  bidId: string;
  prompt: string;
  jsonSchema: JsonSchemaDto;
};
export type ListContactPersonsResponse = {
  subjectType: ContactSubjectType;
  subjectId: string;
  contacts: ContactPersonDto[];
};
export type AddContactPersonRequest = {
  contact: ContactPersonDto;
};
export type EditContactPersonRequest = {
  contact: ContactPersonDto;
};
export type ExclusionGroundsCriterionDto = {
  id: string;
  name: string;
  nameNorwegian?: string | null;
  description: string;
  descriptionNorwegian?: string | null;
  mandatory: boolean;
};
export type ExclusionGroundsCategoryDto = {
  code: EspdCriterionCategory;
  criteria: ExclusionGroundsCriterionDto[];
};
export type ExclusionGroundsTaxonomyResponse = {
  specVersion: string;
  categories: ExclusionGroundsCategoryDto[];
};
export type SourcingEventV2SummaryDto = {
  id: string;
  title: string;
  status: SourcingEventStatus;
  bidSubmissionDeadline?: string | null;
  createdAt: string;
  modifiedAt: string;
};
export type ListSourcingEventsResponse = {
  events: SourcingEventV2SummaryDto[];
};
export type MilestonePlanDto = {
  announcementDate?: string | null;
  questionDaysBeforeBid?: number | null;
  tenderPeriodOffsetDays?: number | null;
  evaluationOffsetDays?: number | null;
  awardOffsetDays?: number | null;
  contractSigningOffsetDays?: number | null;
};
export type ContractDurationDto = {
  type: ContractDurationType;
  startDate?: string | null;
  endDate?: string | null;
  periodMonths?: number | null;
};
export type LowestPriceDto = {
  selected?: boolean;
};
export type AwardCriterionWeightDto = {
  type: WeightType;
  number: number;
};
export type AwardSubCriterionDto = {
  id?: string | null;
  name?: string | null;
  description: string;
  weight?: AwardCriterionWeightDto | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type AwardCriterionDto = {
  type: AwardCriterionType;
  id?: string | null;
  name?: string | null;
  description: string;
  weight?: AwardCriterionWeightDto | null;
  commonRationale?: string | null;
  subCriteria?: AwardSubCriterionDto[];
};
export type BestPriceQualityRatioDto = {
  criteria?: AwardCriterionDto[] | null;
  environmentWeightingJustification?: string | null;
  environmentWeightingJustificationIsStandardText?: boolean;
};
export type AwardCriteriaDto = {
  lowestPrice?: LowestPriceDto | null;
  bestPriceQualityRatio?: BestPriceQualityRatioDto | null;
};
export type SelectionCriterionDto = {
  type: SelectionCriterionType;
  name: string;
  description: string;
  requiresEvidence: boolean;
};
export type MinimumRequirementDto = {
  id?: string | null;
  title: string;
  description: string;
  responseType: MinimumRequirementResponseType;
};
export type PlaceOfPerformanceDto = {
  countryCode?: string | null;
  countrySubdivision?: string | null;
  servicesOther?: string | null;
};
export type EventOptionsDto = {
  hasOptions: boolean;
  descriptions?: string[];
};
export type ProportionalPriceModelDto = {
  selected?: boolean;
};
export type LinearPriceModelDto = {
  selected?: boolean;
};
export type HybridPriceModelDto = {
  breakpointPercent: number;
};
export type PriceModelDto = {
  proportional?: ProportionalPriceModelDto | null;
  linear?: LinearPriceModelDto | null;
  hybrid?: HybridPriceModelDto | null;
};
export type EventDataDto = {
  title: string;
  description?: string | null;
  bidSubmissionDeadline?: string | null;
  bidSubmissionDeadlineConfirmed?: boolean | null;
  tenderDeadlineAgreedWithCandidates?: boolean | null;
  requestDeadline?: string | null;
  requestDeadlineConfirmed?: boolean | null;
  milestonePlan?: MilestonePlanDto | null;
  contractDuration?: ContractDurationDto | null;
  awardCriteria?: AwardCriteriaDto | null;
  selectionCriteria: SelectionCriterionDto[];
  minimumRequirements: MinimumRequirementDto[];
  placeOfPerformance?: PlaceOfPerformanceDto | null;
  options?: EventOptionsDto | null;
  collectSupplierPrice: boolean;
  priceModel?: PriceModelDto | null;
  documents?: ViewDocumentAsOwnerDto[];
  uploads?: UploadDto[];
  projects?: string[] | null;
  referenceId?: string | null;
  includeProducts?: boolean | null;
  includeMinimumRequirements?: boolean | null;
  includeAwardCriteria?: boolean | null;
};
export type InvitedPersonV2Dto = {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};
export type OrganizationEmailInviteV2Dto = {
  email: string;
  language: EmailInviteLanguage;
};
export type OrganizationInviteV2Dto = {
  organizationId: string;
  persons?: InvitedPersonV2Dto[];
  emailInvites?: OrganizationEmailInviteV2Dto[];
  status?: OrganizationInviteStatusV2Dto;
};
export type Private = {
  type: "Private";
  organizationInvites: OrganizationInviteV2Dto[];
  emailInvites?: EmailInviteDto[];
  estimatedValue?: EventValueDto | null;
  contractNature?: ContractNature | null;
};
export type EFormsNoticeDataDto = {
  electronicOrdering?: boolean | null;
  electronicInvoicing?: boolean | null;
  electronicPayment?: boolean | null;
  submissionElectronic?: boolean | null;
  submissionLanguages?: string[];
  submissionLanguagesChosenByBuyer?: boolean | null;
  electronicCatalogue?: boolean | null;
  documentsRestricted?: boolean | null;
  exclusionGroundsSource?: string | null;
  selectionCriteriaSource?: string | null;
  variants?: boolean | null;
  tenderValidityMonths?: number | null;
  publicOpeningDate?: string | null;
  publicOpeningPlace?: string | null;
  documentsUrl?: string | null;
  reviewDeadlineDescription?: string | null;
  submissionUrl?: string | null;
};
export type PublicationDto = {
  id: string;
  channel: PublicationChannel;
  eFormType: EFormType;
  status: PublicationStatus;
  publishedAt?: string | null;
  externalId?: string | null;
  noticeVersion: string;
};
export type EventInvitationDto = {
  invitedOrganizationIds: string[];
  confirmedAt: string;
  bidSubmissionDeadline: string;
  tenderValidityMonths?: number | null;
  confirmedByName?: string | null;
};
export type QualificationRoundDto = {
  status: QualificationRoundStatus;
  requestDeadline: string;
  invitation?: EventInvitationDto | null;
};
export type CandidateLimitsDto = {
  minCandidates: number;
  maxCandidates?: number | null;
  selectionCriteria: string;
};
export type ProcedureJustificationDto = {
  ground: NegotiatedProcedureGround;
  rationale: string;
};
export type DpsSchemeDto = {
  validFrom: string;
  validTo: string;
};
export type QualificationSchemeDto = {
  validFrom: string;
  validTo: string;
};
export type DpsCompetitionDto = {
  schemeId: string;
  schemeTitle?: string | null;
  invitedOrganizationIds?: string[];
  invitedAt?: string | null;
};
export type Public = {
  type: "Public";
  regulation?: Regulation | null;
  procedureType?: ProcedureType | null;
  buyerLegalType?: BuyerLegalType | null;
  utilityActivity?: UtilityActivity | null;
  contractNature?: ContractNature | null;
  foaPart?: FoaPart | null;
  estimatedValue?: EventValueDto | null;
  cpvCodes?: string[];
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaxParticipants?: number | null;
  dynamicPurchasingSystem?: DynamicPurchasingSystemType | null;
  electronicAuction?: boolean | null;
  gpaCoverage?: boolean | null;
  euFunded?: boolean | null;
  reservedParticipation?: ReservedParticipationType | null;
  reservedExecution?: ReservedExecutionType | null;
  acceleratedProcedure?: boolean | null;
  acceleratedJustification?: string | null;
  eFormsNoticeData?: EFormsNoticeDataDto | null;
  activeExclusionGroundIds: string[];
  publications?: PublicationDto[];
  qualificationRound?: QualificationRoundDto | null;
  candidateLimits?: CandidateLimitsDto | null;
  procedureJustification?: ProcedureJustificationDto | null;
  noNegotiationNecessary?: boolean | null;
  dpsScheme?: DpsSchemeDto | null;
  qualificationScheme?: QualificationSchemeDto | null;
  dpsCompetition?: DpsCompetitionDto | null;
};
export type Unclassified = {
  type: "Unclassified";
  estimatedValue?: EventValueDto | null;
  contractNature?: ContractNature | null;
};
export type EventContextDto = Private | Public | Unclassified;
export type MilestoneDatesDto = {
  announcement?: string | null;
  questionDeadline?: string | null;
  bidSubmissionDeadline?: string | null;
  plannedTenderDeadline?: string | null;
  evaluationTarget?: string | null;
  awardTarget?: string | null;
  karensDate?: string | null;
  contractSigningTarget?: string | null;
};
export type RevokedAwardDecisionDto = {
  bidIds?: string[];
  internalNote?: string | null;
  awardedBy?: string | null;
  awardedAt: string;
  revokedBy?: string | null;
  revokedAt: string;
  revokeReason?: string | null;
  evaluationRevision: number;
};
export type AwardDto = {
  winningBidIds?: string[];
  internalNote?: string | null;
  awardedBy?: string | null;
  awardedAt?: string | null;
  confirmedAt?: string | null;
  contractIds?: string[];
  standstillDays?: number | null;
  standstillExpiresAt?: string | null;
  decisionHistory?: RevokedAwardDecisionDto[];
};
export type CancellationDto = {
  at: string;
  reason?: string | null;
};
export type SupplierRegistrationDto = {
  organizationId: string;
  organizationName: string;
  registeredAt: string;
};
export type EventRevisionDto = {
  id: string;
  state: EventRevisionState;
  bidSubmissionDeadline?: string | null;
  description?: string | null;
  requestDocumentIds: string[];
  dpsValidTo?: string | null;
  changeDescription?: string | null;
  reasonCode?: ChangeReasonCode | null;
  changedAreas?: ChangedArea[];
  bidSealWasOpen?: boolean;
  createdAt: string;
  publishedAt?: string | null;
  supersededAt?: string | null;
};
export type ViewingOrganizationDto = {
  organizationId: string;
  organizationName: string;
  lastViewedAt: string;
};
export type SourcingEventV2Dto = {
  id: string;
  status: SourcingEventStatus;
  createdAt: string;
  modifiedAt: string;
  responsiblePerson: PersonDto;
  homeDepartment?: DepartmentDto | null;
  eventData: EventDataDto;
  eventContext: EventContextDto;
  milestoneDates: MilestoneDatesDto;
  competitionStage?: CompetitionStageDto | null;
  collectsEspdWithBid?: boolean;
  award?: AwardDto | null;
  eventValue?: EventValueDto | null;
  questionDeadline?: string | null;
  evaluationStartedAt?: string | null;
  cancellation?: CancellationDto | null;
  supplierRegistrations?: SupplierRegistrationDto[];
  changes?: EventRevisionDto[];
  viewings?: ViewingOrganizationDto[];
  internalConversation?: InternalMessageDto[];
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
  derivedPlaceOfPerformance?: string | null;
  operations?: OperationAvailabilityDto[];
};
export type CreateSourcingEventV2Request = {
  title: string;
  description?: string | null;
  homeDepartmentId?: string | null;
};
export type EvaluateBidsWithAiRequest = {
  sourcingEventId: string;
  prompt: string;
  jsonSchema: JsonSchemaDto;
  negotiationRoundId?: string | null;
};
export type GenerateRequirementsWithAiRequest = {
  sourcingEventId: string;
  prompt: string;
  jsonSchema: JsonSchemaDto;
};
export type MilestonePlanPatchDto = {
  announcementDate?: string | null;
  questionDaysBeforeBid?: number | null;
  tenderPeriodOffsetDays?: number | null;
  evaluationOffsetDays?: number | null;
  awardOffsetDays?: number | null;
  contractSigningOffsetDays?: number | null;
};
export type ContractDurationPatchDto = {
  type?: ContractDurationType;
  startDate?: string | null;
  endDate?: string | null;
  periodMonths?: number | null;
};
export type LowestPricePatchDto = {
  selected?: boolean;
};
export type AwardCriterionWeightPatchDto = {
  type?: WeightType;
  number?: number;
};
export type AwardSubCriterionPatchDto = {
  id?: string;
  name?: string | null;
  description?: string;
  weight?: AwardCriterionWeightPatchDto | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type AwardCriterionPatchDto = {
  type?: AwardCriterionType;
  id?: string;
  name?: string | null;
  description?: string;
  weight?: AwardCriterionWeightPatchDto | null;
  commonRationale?: string | null;
  subCriteria?: AwardSubCriterionPatchDto[];
};
export type BestPriceQualityRatioPatchDto = {
  criteria?: AwardCriterionPatchDto[];
  environmentWeightingJustification?: string | null;
  environmentWeightingJustificationIsStandardText?: boolean;
};
export type AwardCriteriaPatchDto = {
  lowestPrice?: LowestPricePatchDto | null;
  bestPriceQualityRatio?: BestPriceQualityRatioPatchDto | null;
};
export type SelectionCriterionPatchDto = {
  type?: SelectionCriterionType;
  name?: string;
  description?: string;
  requiresEvidence?: boolean;
};
export type MinimumRequirementPatchDto = {
  id?: string;
  title?: string;
  description?: string;
  responseType?: MinimumRequirementResponseType;
};
export type PlaceOfPerformancePatchDto = {
  countryCode?: string | null;
  countrySubdivision?: string | null;
  servicesOther?: string | null;
};
export type EventOptionsPatchDto = {
  hasOptions?: boolean;
  descriptions?: string[];
};
export type ProportionalPriceModelPatchDto = {
  selected?: boolean;
};
export type LinearPriceModelPatchDto = {
  selected?: boolean;
};
export type HybridPriceModelPatchDto = {
  breakpointPercent?: number;
};
export type PriceModelPatchDto = {
  proportional?: ProportionalPriceModelPatchDto | null;
  linear?: LinearPriceModelPatchDto | null;
  hybrid?: HybridPriceModelPatchDto | null;
};
export type EventDataPatchDto = {
  title?: string;
  description?: string | null;
  bidSubmissionDeadline?: string | null;
  bidSubmissionDeadlineConfirmed?: boolean | null;
  tenderDeadlineAgreedWithCandidates?: boolean | null;
  requestDeadline?: string | null;
  requestDeadlineConfirmed?: boolean | null;
  milestonePlan?: MilestonePlanPatchDto | null;
  contractDuration?: ContractDurationPatchDto | null;
  awardCriteria?: AwardCriteriaPatchDto | null;
  selectionCriteria?: SelectionCriterionPatchDto[];
  minimumRequirements?: MinimumRequirementPatchDto[];
  placeOfPerformance?: PlaceOfPerformancePatchDto | null;
  options?: EventOptionsPatchDto | null;
  collectSupplierPrice?: boolean;
  priceModel?: PriceModelPatchDto | null;
  documents?: ViewDocumentAsOwnerDto[];
  projects?: string[] | null;
  referenceId?: string | null;
  includeProducts?: boolean | null;
  includeMinimumRequirements?: boolean | null;
  includeAwardCriteria?: boolean | null;
};
export type EventValuePatchDto = {
  value?: number | null;
  currency?: Currency;
};
export type EventContextPatchDto = {
  estimatedValue?: EventValuePatchDto | null;
  contractNature?: ContractNature | null;
};
export type EFormsNoticeDataPatchDto = {
  electronicOrdering?: boolean | null;
  electronicInvoicing?: boolean | null;
  electronicPayment?: boolean | null;
  submissionElectronic?: boolean | null;
  submissionLanguages?: string[];
  electronicCatalogue?: boolean | null;
  documentsRestricted?: boolean | null;
  exclusionGroundsSource?: string | null;
  selectionCriteriaSource?: string | null;
  variants?: boolean | null;
  tenderValidityMonths?: number | null;
  publicOpeningDate?: string | null;
  publicOpeningPlace?: string | null;
  documentsUrl?: string | null;
  reviewDeadlineDescription?: string | null;
  submissionUrl?: string | null;
};
export type CandidateLimitsPatchDto = {
  minCandidates?: number;
  maxCandidates?: number | null;
  selectionCriteria?: string;
};
export type ProcedureJustificationPatchDto = {
  ground?: NegotiatedProcedureGround;
  rationale?: string;
};
export type DpsSchemePatchDto = {
  validFrom?: string;
  validTo?: string;
};
export type QualificationSchemePatchDto = {
  validFrom?: string;
  validTo?: string;
};
export type PublicContextPatchDto = {
  regulation?: Regulation | null;
  procedureType?: ProcedureType | null;
  buyerLegalType?: BuyerLegalType | null;
  utilityActivity?: UtilityActivity | null;
  foaPart?: FoaPart | null;
  cpvCodes?: string[];
  frameworkAgreement?: FrameworkAgreementType | null;
  frameworkMaxParticipants?: number | null;
  dynamicPurchasingSystem?: DynamicPurchasingSystemType | null;
  electronicAuction?: boolean | null;
  gpaCoverage?: boolean | null;
  euFunded?: boolean | null;
  reservedParticipation?: ReservedParticipationType | null;
  reservedExecution?: ReservedExecutionType | null;
  acceleratedProcedure?: boolean | null;
  acceleratedJustification?: string | null;
  eFormsNoticeData?: EFormsNoticeDataPatchDto | null;
  activeExclusionGroundIds?: string[];
  candidateLimits?: CandidateLimitsPatchDto | null;
  procedureJustification?: ProcedureJustificationPatchDto | null;
  noNegotiationNecessary?: boolean | null;
  dpsScheme?: DpsSchemePatchDto | null;
  qualificationScheme?: QualificationSchemePatchDto | null;
};
export type InvitedPersonPatchDto = {
  id: string;
};
export type OrganizationEmailInvitePatchDto = {
  email: string;
  language: EmailInviteLanguage;
};
export type OrganizationInvitePatchDto = {
  organizationId: string;
  persons?: InvitedPersonPatchDto[];
  emailInvites?: OrganizationEmailInvitePatchDto[];
};
export type PrivateContextPatchDto = {
  organizationInvites?: OrganizationInvitePatchDto[];
};
export type SourcingEventV2PatchDto = {
  eventData?: EventDataPatchDto;
  eventContext?: EventContextPatchDto;
  publicContext?: PublicContextPatchDto;
  privateContext?: PrivateContextPatchDto;
};
export type SeV2AttachmentUploadDto = {
  documentId?: string | null;
};
export type AwardSourcingEventRequest = {
  winningBidIds: string[];
  internalNote?: string | null;
  eventValue?: EventValueDto | null;
};
export type AwardLetterContentDto = {
  criterionJustifications?: {
    [key: string]: string;
  };
  freeText?: string | null;
};
export type AwardLetterDto = {
  type: AwardLetterTypeDto;
  id: string;
  bidId: string;
  supplierName?: string | null;
  status: AwardLetterStatusDto;
  content: AwardLetterContentDto;
  approvedAt?: string | null;
  sentAt?: string | null;
};
export type WithdrawnAwardLettersRoundDto = {
  withdrawnAt: string;
  withdrawnBy?: string | null;
  letters: AwardLetterDto[];
};
export type AwardLettersDto = {
  letters: AwardLetterDto[];
  withdrawnRounds?: WithdrawnAwardLettersRoundDto[];
};
export type AwardLetterContentPatchDto = {
  criterionJustifications?: {
    [key: string]: string;
  };
  freeText?: string | null;
};
export type AwardLetterPatchDto = {
  content?: AwardLetterContentPatchDto;
};
export type CancelSourcingEventV2Request = {
  reason?: string | null;
};
export type EventRevisionPatchDto = {
  bidSubmissionDeadline?: string | null;
  description?: string | null;
  requestDocumentIds?: string[];
  dpsValidTo?: string | null;
  changeDescription?: string | null;
  reasonCode?: ChangeReasonCode | null;
};
export type SeV2AttachmentDto = {
  documentId: string;
  fileName: string;
  mimeType: string;
  source: SeV2AttachmentSource;
};
export type SeV2QuestionAnswerDto = {
  content: string;
  answeredBy: PersonDto;
  answeredAt: string;
  attachments?: SeV2AttachmentDto[];
};
export type SeV2QuestionMessageDto = {
  content: string;
  sentBy: PersonDto;
  sentByOrganizationId: string;
  sentByOrgName: string;
  sentAt: string;
  attachments?: SeV2AttachmentDto[];
};
export type SeV2QuestionDto = {
  id: string;
  eventId: string;
  createdAt: string;
  modifiedAt: string;
  kind: SeV2QuestionKind;
  status: SeV2QuestionStatus;
  subject: string;
  content: string;
  askedByPerson: PersonDto;
  askedByOrgName: string;
  supplierOrganizationId: string;
  supplierOrgName: string;
  attachments?: SeV2AttachmentDto[];
  answer?: SeV2QuestionAnswerDto | null;
  messages?: SeV2QuestionMessageDto[];
  publishedInformationId?: string | null;
  forNegotiationRound?: string | null;
};
export type SeV2AttachmentInputDto = {
  documentId: string;
  source: SeV2AttachmentSource;
};
export type CreateSeV2ClarificationRequest = {
  supplierOrganizationId: string;
  subject: string;
  content: string;
  attachments?: SeV2AttachmentInputDto[];
};
export type CloseSourcingEventV2Request = {
  reason?: string | null;
};
export type CopiedSourcingEventDto = {
  event: SourcingEventV2Dto;
  copiedInvitations: number;
  skippedInvitations: number;
};
export type DpsCompetitionRowDto = {
  eventId: string;
  title: string;
  status: SourcingEventStatus;
  bidSubmissionDeadline?: string | null;
  invitedCount: number;
  openedAt?: string | null;
};
export type DpsCompetitionsDto = {
  canStartCompetition: boolean;
  qualifiedMemberCount: number;
  rows?: DpsCompetitionRowDto[];
};
export type CreateDpsCompetitionRequestDto = {
  title: string;
  description?: string | null;
};
export type AddEmailInviteRequest = {
  email: string;
  language: EmailInviteLanguage;
  organizationEntryId: string;
};
export type EvalCriterionDto = {
  type: AwardCriterionType;
  id: string;
  name?: string | null;
  weightPercent?: number | null;
  isPrice: boolean;
  commonRationale?: string | null;
  parentId?: string | null;
  parentName?: string | null;
  effectiveWeightPercent?: number | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type PriceOverrideDto = {
  value: EventValueDto;
  comment?: string | null;
};
export type EvalAttachmentDto = {
  id: string;
  fileName: string;
};
export type EvalSupplierAnswerDto = {
  text?: string | null;
  number?: number | null;
  choice?: AwardCriterionAnswerChoice | null;
  partialElaboration?: string | null;
  attachments?: EvalAttachmentDto[];
};
export type EvalCellDto = {
  criterionId: string;
  supplierAnswer?: EvalSupplierAnswerDto | null;
  points?: number | null;
  isAutoComputed: boolean;
  comment?: string | null;
  weightedPoints?: number | null;
};
export type EvalMinimumRequirementsDto = {
  outcome: MinimumRequirementOutcome;
  fulfilled: number;
  notFulfilled: number;
  total: number;
};
export type EvalBidDto = {
  bidId: string;
  supplierName: string;
  status: BidV2Status;
  price?: EventValueDto | null;
  effectivePrice?: EventValueDto | null;
  priceOverride?: PriceOverrideDto | null;
  originalPrice?: EventValueDto | null;
  cells: EvalCellDto[];
  groupCells?: EvalCellDto[];
  weightedTotal: number;
  rank: number;
  minimumRequirements?: EvalMinimumRequirementsDto | null;
};
export type EvalProgressDto = {
  filled: number;
  total: number;
};
export type EvaluationDto = {
  eventId: string;
  model: EvaluationModelDto;
  awardMethod?: AwardMethodDto | null;
  criteria: EvalCriterionDto[];
  bids: EvalBidDto[];
  selectedBidIds?: string[];
  progress: EvalProgressDto;
  revision?: number;
};
export type UpsertPriceOverrideRequest = {
  bidId: string;
  value?: number | null;
  comment?: string | null;
};
export type SetRationaleRequest = {
  criterionId: string;
  text: string;
};
export type UpsertScoreRequest = {
  criterionId: string;
  bidId: string;
  points?: number | null;
  comment?: string | null;
};
export type SetEvaluationSelectionRequest = {
  bidIds: string[];
};
export type UpdateSourcingEventValueRequest = {
  eventValue?: EventValueDto | null;
};
export type SetHomeDepartmentRequest = {
  homeDepartmentId: string;
};
export type AddInternalMessageRequest = {
  value: string;
};
export type InvitationResultDto = {
  invitedOrganizationIds: string[];
  bidSubmissionDeadline: string;
  confirmedAt: string;
};
export type NotSelectedRequestDto = {
  requestId: string;
  reason: string;
};
export type ConfirmInvitationRequestDto = {
  bidSubmissionDeadline: string;
  tenderValidityMonths?: number | null;
  tenderDeadlineAgreedWithCandidates?: boolean | null;
  selectedRequestIds?: string[] | null;
  notSelected?: NotSelectedRequestDto[];
};
export type NegotiationRoundV2PersonDto = {
  id: string;
  name: string;
};
export type NegotiationRoundV2EmailInviteDto = {
  id: string;
  email: string;
};
export type NegotiationRoundV2InviteDto = {
  organizationId: string;
  organizationName: string;
  persons: NegotiationRoundV2PersonDto[];
  emailInvites?: NegotiationRoundV2EmailInviteDto[];
  message?: string | null;
};
export type NegotiationRoundV2InternalMessageDto = {
  id: string;
  message: string;
  createdAt: string;
};
export type NegotiationRoundV2Dto = {
  id: string;
  eventId: string;
  roundNumber: number;
  isFinalRound?: boolean | null;
  status: NegotiationRoundStatus;
  publishedAt?: string | null;
  completedAt?: string | null;
  reopenedAt?: string | null;
  title?: string | null;
  description?: string | null;
  deadline: string;
  documents: ViewDocumentAsOwnerDto[];
  invites: NegotiationRoundV2InviteDto[];
  internalConversation: NegotiationRoundV2InternalMessageDto[];
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
  viewingCount?: number;
};
export type ListNegotiationRoundsV2Response = {
  rounds: NegotiationRoundV2Dto[];
};
export type CreateNegotiationRoundV2Request = {
  deadline: string;
  isFinalRound?: boolean | null;
};
export type NegotiationRoundV2PatchDto = {
  title?: string | null;
  description?: string | null;
  deadline?: string;
  isFinalRound?: boolean | null;
  documents?: string[];
};
export type AddNegotiationRoundV2InviteRequest = {
  organizationId: string;
  personIds?: string[];
  message?: string | null;
};
export type UpdateNegotiationRoundV2InviteMessageRequest = {
  message?: string | null;
};
export type SelectProductBidsRequest = {
  selectedProductBids: WinningProductGroupBidsDto[];
};
export type AddOrganizationInviteRequest = {
  organizationId: string;
  persons?: InvitedPersonPatchDto[];
  emailInvites?: OrganizationEmailInvitePatchDto[];
};
export type EspdRequirementResponseDto = {
  requirementId: string;
  instanceIndex?: number | null;
  indicator?: boolean | null;
  description?: string | null;
  date?: string | null;
  amount?: number | null;
  currencyId?: string | null;
  code?: string | null;
  percentage?: number | null;
  quantity?: number | null;
  quantityUnitCode?: string | null;
  period?: string | null;
  evidenceUrl?: string | null;
  evidenceName?: string | null;
};
export type EspdRepresentativeDto = {
  firstName: string;
  familyName: string;
  birthDate?: string | null;
  email?: string | null;
  telephone?: string | null;
  role?: string | null;
};
export type EspdEconomicOperatorDto = {
  smeIndicator?: boolean | null;
  representatives?: EspdRepresentativeDto[];
};
export type EspdFinalDeclarationDto = {
  confirmed?: boolean;
};
export type EspdResponseDto = {
  specVersion: string;
  responses: EspdRequirementResponseDto[];
  economicOperator?: EspdEconomicOperatorDto | null;
  finalDeclaration?: EspdFinalDeclarationDto;
};
export type BuyerParticipationQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[];
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
  evidenceDocuments?: ViewDocumentAsOwnerDto[];
};
export type BuyerQualificationVerdictDto = {
  qualified: boolean;
  decidedAt: string;
  decidedByName?: string | null;
};
export type SelectionOutcomeDto = {
  selected: boolean;
  reason?: string | null;
  decidedAt: string;
};
export type RejectionGroundDto = {
  key: string;
  label: string;
  foaReference: string;
  mandatory: boolean;
};
export type ParticipationRequestRejectionDto = {
  grounds?: RejectionGroundDto[];
  message: string;
  attachmentIds?: string[];
  attachments?: ViewDocumentAsOwnerDto[];
};
export type SelectionDraftDto = {
  deselected: boolean;
  reason?: string | null;
  editedByName?: string | null;
  editedAt: string;
};
export type BuyerParticipationRequestDto = {
  id: string;
  organizationId: string;
  organizationName?: string | null;
  organizationNumber?: string | null;
  status: ParticipationRequestStatus;
  submittedAt?: string | null;
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: BuyerParticipationQualificationResponseDto[];
  qualificationVerdict?: BuyerQualificationVerdictDto | null;
  selectionOutcome?: SelectionOutcomeDto | null;
  internalNote?: string | null;
  rejectionReason?: string | null;
  rejection?: ParticipationRequestRejectionDto | null;
  selectionDraft?: SelectionDraftDto | null;
  assessmentDeadline?: string | null;
  assessmentWorkingDaysRemaining?: number | null;
  assessmentExtended?: boolean;
  membershipEndedAt?: string | null;
  membershipEndReason?: string | null;
};
export type BuyerParticipationRequestsDto = {
  requestDeadline?: string | null;
  identitiesVisible: boolean;
  count: number;
  requests?: BuyerParticipationRequestDto[];
  invitationConfirmed?: boolean;
};
export type BuyerBidV2EspdRequirementValueDto = {
  indicator?: boolean | null;
  description?: string | null;
  date?: string | null;
  amount?: number | null;
  currencyId?: string | null;
  code?: string | null;
  percentage?: number | null;
  quantity?: number | null;
  quantityUnitCode?: string | null;
  period?: string | null;
  evidenceUrl?: string | null;
  evidenceName?: string | null;
};
export type BuyerBidV2EspdRequirementDto = {
  id: string;
  label: string;
  labelSource?: string | null;
  labelTranslation?: string | null;
  responseDataType: EspdResponseDataType;
  optional: boolean;
  value?: BuyerBidV2EspdRequirementValueDto | null;
};
export type BuyerBidV2EspdRequirementGroupInstanceDto = {
  instanceIndex?: number | null;
  requirements: BuyerBidV2EspdRequirementDto[];
  subGroups: BuyerBidV2EspdRequirementGroupDto[];
};
export type BuyerBidV2EspdRequirementGroupDto = {
  id: string;
  repeatable: boolean;
  instances: BuyerBidV2EspdRequirementGroupInstanceDto[];
};
export type BuyerBidV2EspdCriterionDto = {
  id: string;
  name: string;
  nameSource?: string | null;
  nameTranslation?: string | null;
  answer: BuyerBidV2EspdAnswerDto;
  description?: string | null;
  descriptionSource?: string | null;
  descriptionTranslation?: string | null;
  responseGroups: BuyerBidV2EspdRequirementGroupDto[];
};
export type BuyerBidV2EspdCategoryDto = {
  code: string;
  name: string;
  okCount: number;
  deviationCount: number;
  unansweredCount: number;
  criteria: BuyerBidV2EspdCriterionDto[];
};
export type BuyerBidV2EspdDto = {
  hasResponse: boolean;
  okCount: number;
  deviationCount: number;
  unansweredCount: number;
  categories: BuyerBidV2EspdCategoryDto[];
};
export type BuyerParticipationRequestDetailDto = {
  request: BuyerParticipationRequestDto;
  eventTitle?: string | null;
  requestDeadline?: string | null;
  invitationConfirmed?: boolean;
  selectionCriteria?: SelectionCriterionDto[];
  espd?: BuyerBidV2EspdDto | null;
  foaPart?: FoaPart | null;
};
export type ExtendAssessmentRequestDto = {
  reason: string;
};
export type BuyerQualificationReviewResponsePatchDto = {
  criterionKey: string;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
};
export type BuyerQualificationReviewPatchDto = {
  responses?: BuyerQualificationReviewResponsePatchDto[];
};
export type ParticipationRequestRejectionDocumentsDto = {
  documents?: ViewDocumentAsOwnerDto[];
};
export type RemoveFromSchemeRequestDto = {
  reason: string;
};
export type BuyerReviewNotesPatchDto = {
  internalNote?: string | null;
  rejectionReason?: string | null;
};
export type SelectionDraftPatchDto = {
  deselected?: boolean;
  reason?: string | null;
};
export type SetParticipationRequestRejectionDto = {
  grounds?: RejectionGroundDto[];
  message: string;
  attachmentIds?: string[];
};
export type SetQualificationVerdictRequestDto = {
  qualified?: boolean | null;
  rejectionReason?: string | null;
  rejection?: SetParticipationRequestRejectionDto | null;
};
export type ProtocolFieldDto = {
  label: string;
  value?: string | null;
};
export type ProtocolBlockDto = {
  kind: string;
  label?: string | null;
  value?: string | null;
  editableKey?: string | null;
  columns?: string[];
  rows?: (string | null)[][];
  emphasizeFirstRow?: boolean;
  numericColumns?: number[];
  emptyText?: string | null;
  badge?: string | null;
  rankColumn?: number | null;
  fields?: ProtocolFieldDto[];
};
export type ProtocolSectionDto = {
  number: number;
  heading: string;
  blocks: ProtocolBlockDto[];
};
export type ProtocolDocumentDto = {
  sections: ProtocolSectionDto[];
  differsFromLatestVersion?: boolean;
};
export type ProtocolDraftPatchDto = {
  editableKey: string;
  value: string;
};
export type ProtocolVersionDto = {
  versionNumber: number;
  finalisedAt: string;
  downloadUrl: string;
};
export type ProtocolVersionListDto = {
  versions: ProtocolVersionDto[];
};
export type BidV2QualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[] | null;
  evidenceDocuments?: ViewDocumentAsOwnerDto[] | null;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
};
export type BidV2MinimumRequirementResponseDto = {
  minimumRequirementId: string;
  answer: boolean;
  comment?: string | null;
  attachmentIds?: string[] | null;
  attachments?: ViewDocumentAsOwnerDto[] | null;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
};
export type ReceivedBidV2Dto = {
  id: string;
  owner: string;
  ownerName: string;
  status: BidV2Status;
  submittedAt?: string | null;
  contractId?: string | null;
  contractState?: ContractStateDto | null;
  documents?: ViewDocumentAsOwnerDto[];
  qualificationResponses?: BidV2QualificationResponseDto[];
  minimumRequirementResponses?: BidV2MinimumRequirementResponseDto[];
  forNegotiationRound?: string | null;
  products?: ProductGroupBidDto[] | null;
  qualifiedAt?: string | null;
};
export type ListBidV2SResponse = {
  bids: ReceivedBidV2Dto[];
};
export type BidV2StatusTransitionDto = {
  type: BidV2StatusTransitionTypeDto;
  at: string;
};
export type BidV2AwardCriterionResponseDto = {
  criterionId: string;
  text?: string | null;
  number?: number | null;
  choice?: AwardCriterionAnswerChoice | null;
  partialElaboration?: string | null;
  attachmentIds?: string[] | null;
  attachments?: ViewDocumentAsOwnerDto[] | null;
};
export type BidV2RejectionDto = {
  grounds: RejectionGroundDto[];
  reason: string;
  message: string;
  rejectedAt?: string | null;
  rejectedBy?: string | null;
  attachmentIds?: string[];
  attachments?: ViewDocumentAsOwnerDto[];
};
export type BuyerBidV2Dto = {
  id: string;
  forEvent: string;
  status: BidV2Status;
  submittedAt?: string | null;
  statusHistory?: BidV2StatusTransitionDto[];
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: BidV2QualificationResponseDto[];
  minimumRequirementResponses?: BidV2MinimumRequirementResponseDto[];
  awardCriterionResponses?: BidV2AwardCriterionResponseDto[];
  price?: EventValueDto | null;
  coverLetter?: string | null;
  signedDocumentId?: string | null;
  documents?: ViewDocumentAsOwnerDto[];
  rejection?: BidV2RejectionDto | null;
  products?: ProductGroupBidDto[] | null;
  comment?: string | null;
  commentDocuments?: ViewDocumentAsOwnerDto[];
};
export type BuyerBidV2NamedEntityDto = {
  name: string;
  organizationNumber?: string | null;
  groupRole?: string | null;
};
export type BuyerBidV2DeclarationDto = {
  id: string;
  typeCode: string;
  question: string;
  questionSource?: string | null;
  questionTranslation?: string | null;
  answer?: boolean | null;
  responseGroups: BuyerBidV2EspdRequirementGroupDto[];
  namedEntities?: BuyerBidV2NamedEntityDto[];
};
export type BuyerBidV2DeclarationsDto = {
  hasResponse: boolean;
  declarations: BuyerBidV2DeclarationDto[];
};
export type BidV2QualificationDto = {
  decidedAt: string;
  decidedByName?: string | null;
};
export type AdmissionDeclarationDto = {
  schemeId: string;
  schemeTitle: string;
  participationRequestId: string;
  submittedAt: string;
};
export type BuyerBidV2DetailDto = {
  bid: BuyerBidV2Dto;
  ownerOrganizationId: string;
  ownerName: string;
  ownerOrganizationNumber?: string | null;
  eventTitle?: string | null;
  foaPart?: FoaPart | null;
  selectionCriteria?: SelectionCriterionDto[];
  minimumRequirements?: MinimumRequirementDto[];
  awardCriteria?: AwardCriterionDto[];
  bidOpenedAt?: string | null;
  espd?: BuyerBidV2EspdDto | null;
  declarations?: BuyerBidV2DeclarationsDto | null;
  qualification?: BidV2QualificationDto | null;
  admissionDeclaration?: AdmissionDeclarationDto | null;
  submittedBy?: PersonDto | null;
};
export type OrganizationEntryPitchDto = {
  id: string;
  name: string;
  contactPersons?: ContactPersonDto[] | null;
};
export type OrgPublicProfileDto = {
  id: string;
  owner: PersonDto;
  name: string;
  country: CountryDto;
  organizationNumber?: string | null;
  industries: IndustryDto[];
  aboutUs?: string | null;
  specializations?: string | null;
  homePageUrl?: string | null;
  size?: OrganizationSize | null;
  contactPersons?: PersonDto[] | null;
  linkedEntries: OrganizationEntryPitchDto[];
};
export type CounterpartyDto = {
  organization?: OrgPublicProfileDto | null;
  organizationEntry?: OrganizationEntryDto | null;
};
export type ContractTemplateMinDto = {
  id: string;
  name?: string | null;
  commonType?: CommonTemplateType | null;
};
export type ContractEditingMetaFieldsDto = {
  uploads: UploadDto[];
  descriptionUploads: UploadDto[];
};
export type CustomFieldIdentifierDto = {
  sectionId: string;
  fieldId: string;
};
export type CounterpartyContactPersonDto = {
  fullName?: string | null;
  email?: string | null;
  phoneNumber?: PhoneNumberDto | null;
  person?: PersonDto | null;
};
export type ContractEndDateDto = {
  date?: string | null;
  hasNoEndDate: boolean;
};
export type LinkedContractDto = {
  id: string;
  title: string;
};
export type OriginBasicSourcingEventDto = {
  type: "BasicSourcingEvent";
  id: string;
  title: string;
};
export type OriginSourcingEventV2Dto = {
  type: "SourcingEventV2";
  id: string;
  title: string;
};
export type OriginSourcingEventDto =
  | OriginBasicSourcingEventDto
  | OriginSourcingEventV2Dto;
export type TerminationDateDto = {
  date: string;
  reason: string;
};
export type IfrsAdjustmentDto = {
  type: IfrsAdjustmentType;
  monthNumber: number;
  value: number;
};
export type IfrsValuesDto = {
  startDate?: string | null;
  startDateSecondPeriod?: string | null;
  monthlyPayment?: number | null;
  paymentIntervalInMonths?: number | null;
  contractLengthInMonths?: number | null;
  interestRate?: number | null;
  adjustments: IfrsAdjustmentDto[];
  filled: boolean;
};
export type InternalPartyDto = {
  organizationId: string;
  organizationName: string;
};
export type InternalPartiesDto = {
  parties: InternalPartyDto[];
};
export type SupplierInfoDto = {
  isClimateCommitted: boolean;
  hasSignedCodeOfConduct: boolean;
  hasCustomerContact: boolean;
};
export type OptionDto = {
  id?: string;
  name?: string;
  description?: string;
  startDate?: string | null;
  deadline?: string | null;
  endDate?: string | null;
  duration?: number | null;
  isExecuted?: boolean;
};
export type ContractDataFieldsDto = {
  missingDataFields: ContractDataFieldNameDto[];
  requiredDataFields: ContractDataFieldDto[];
  addedDataFields: ContractDataFieldDto[];
  customFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  missingCustomFields?: CustomFieldIdentifierDto[] | null;
  requiredCustomFields?: CustomFieldIdentifierDto[] | null;
  awardDate?: string | null;
  renewalDate?: string | null;
  counterpartyContactPerson?: CounterpartyContactPersonDto | null;
  deliveryTerms?: string | null;
  estimatedValue?: number | null;
  endDate?: ContractEndDateDto | null;
  externalLink?: string | null;
  industries?: IndustryDto[] | null;
  internalReferenceNumber?: string | null;
  linkedContracts?: LinkedContractDto[] | null;
  originSourcingEvent?: OriginSourcingEventDto | null;
  paymentTermsInDays?: number | null;
  pricePerMonth?: number | null;
  pricePerYear?: number | null;
  priority?: ContractPriority | null;
  purchasingPolicy?: string | null;
  risk?: ContractRisk | null;
  startDate?: string | null;
  totalLiability?: number | null;
  totalPrice?: number | null;
  warrantyExpirationDate?: string | null;
  terminationDate?: TerminationDateDto | null;
  ifrsValues?: IfrsValuesDto | null;
  internalParties?: InternalPartiesDto | null;
  supplierInfo?: SupplierInfoDto | null;
  supplierCategory?: Category | null;
  noticePeriod?: number | null;
  options?: OptionDto[] | null;
  projects?: ProjectDto[] | null;
};
export type DocumentSignerDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: DocumentSignerStatusDto;
  statusTimestamp?: string | null;
};
export type SignedAttachmentDto = {
  id: string;
  title?: string | null;
  description?: string | null;
  fileName?: string | null;
};
export type MergedDocumentDto = {
  id: string;
  name: string;
};
export type MergedTextDocumentDto = {
  id: string;
  name: string;
};
export type MergedAttachmentDto = {
  type: string;
  id: string;
  name: string;
};
export type MergedDocumentsDto = {
  mainDocument?: MergedDocumentDto | null;
  mainTextDocument?: MergedTextDocumentDto | null;
  attachments?: MergedAttachmentDto[];
};
export type SignedDocumentDto = {
  id: string;
  name: string;
  uploadedAt: string;
  sentForSigningBy: PersonDto;
  status: SignedDocumentStatus;
  signers: DocumentSignerDto[];
  signicatDocumentId: string;
  signingCompleted: boolean;
  deadline?: string | null;
  attachments?: SignedAttachmentDto[] | null;
  mergedDocuments?: MergedDocumentsDto | null;
  tags: string[];
  fencyContentStatus?: FencyContentStatus | null;
};
export type ContractDocumentFieldsDto = {
  documents: ViewDocumentAsOwnerDto[];
  signedDocuments: SignedDocumentDto[];
  descriptionDocuments: ViewDocumentAsOwnerDto[];
};
export type NotificationInAdvanceConfigDto = {
  durationType: ContractNotificationDurationType;
  amount: number;
};
export type ContractNotificationDto = {
  type: ContractNotificationTypeDto;
  id: string;
  inAdvanceConfig?: NotificationInAdvanceConfigDto | null;
  receivers: PersonDto[];
};
export type ContractNotificationFieldsDto = {
  notifications: ContractNotificationDto[];
};
export type ContractDto = {
  id: string;
  owningOrganizationId: string;
  department?: DepartmentDto | null;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  title: string;
  description?: string | null;
  timezone: string;
  currency: Currency;
  counterparty?: CounterpartyDto | null;
  internalOwner: PersonDto;
  template?: ContractTemplateMinDto | null;
  editingMetaFields?: ContractEditingMetaFieldsDto | null;
  dataFields?: ContractDataFieldsDto | null;
  documentFields?: ContractDocumentFieldsDto | null;
  notificationFields?: ContractNotificationFieldsDto | null;
  canEditEverything: boolean;
  canViewDataFields: boolean;
  canViewDocuments: boolean;
  canViewNotifications: boolean;
  canViewTasks: boolean;
  canCreateTasks: boolean;
  canViewParticipants: boolean;
  canUpdateParticipants: boolean;
  owningOrgHasSignatureAccess: boolean;
};
export type CreateContractFromBidV2Request = {
  title?: string | null;
  templateId?: string | null;
  documentIds?: string[];
};
export type BuyerMinimumRequirementReviewResponsePatchDto = {
  minimumRequirementId: string;
  buyerVerdict?: boolean | null;
  buyerComment?: string | null;
};
export type BuyerMinimumRequirementReviewPatchDto = {
  responses?: BuyerMinimumRequirementReviewResponsePatchDto[];
};
export type SetBidQualificationRequestDto = {
  qualified: boolean;
};
export type RejectBidV2RequestDto = {
  grounds: RejectionGroundDto[];
  reason: string;
  message: string;
  attachmentIds?: string[];
};
export type BidV2RejectionDocumentsDto = {
  documents?: ViewDocumentAsOwnerDto[];
};
export type ListSeV2QuestionsResponse = {
  questions: SeV2QuestionDto[];
};
export type SeV2QuestionPatchDto = {
  answer?: string;
  attachments?: SeV2AttachmentInputDto[];
};
export type CreateSeV2QuestionMessageRequest = {
  content: string;
  attachments?: SeV2AttachmentInputDto[];
};
export type FieldStatusDto = {
  fieldKey: FieldKeys;
  gate: Gate;
  satisfied: boolean;
  error?: FieldErrorDto | null;
};
export type ValidationReadinessDto = {
  fields: FieldStatusDto[];
};
export type SetResponsiblePersonRequest = {
  responsiblePersonId: string;
};
export type RevokeAwardRequest = {
  reason: string;
};
export type SharedByDto = {
  personId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
};
export type EventShareRowDto = {
  personId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  sharedAt: string;
  sharedBy: SharedByDto;
  dormant: boolean;
  revoke: OperationAvailabilityDto;
};
export type EventSharesDto = {
  shares: EventShareRowDto[];
};
export type EventShareDto = {
  personId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  sharedAt: string;
};
export type ShareEventRequest = {
  personId: string;
};
export type SupplierInformationDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  title: string;
  content: string;
  question?: string | null;
  attachments?: SeV2AttachmentDto[];
};
export type ListSupplierInformationResponse = {
  supplierInformation: SupplierInformationDto[];
};
export type CreateInformationRequest = {
  title: string;
  content: string;
  fromQuestionId?: string | null;
  question?: string | null;
  attachments?: SeV2AttachmentInputDto[];
};
export type InviteInput = {
  organizationId: string;
  personIds: string[];
  message?: string | null;
};
export type SetInviteMessage = {
  inviteId: string;
  message: string;
};
export type EditNegotiationRequest = {
  title?: string | null;
  description?: EditDescription | null;
  deadline?: EditDeadline | null;
  removeDocument?: string | null;
  removeDescriptionDocument?: string | null;
  inviteInput?: InviteInput | null;
  setInviteMessage?: SetInviteMessage | null;
  inviteIdToRemove?: string | null;
  selectedProductBids?: WinningProductGroupBidsDto[] | null;
};
export type ProductTemplateFieldDto = {
  type: ProductFieldType;
  id: string;
  name: string;
  populatedBy: Populater;
  isRequired: boolean;
};
export type ProductCommentDto = {
  comment: string;
  createdBy?: PersonDto | null;
  createdAt: string;
  modifiedAt: string;
};
export type ProductDto = {
  id: string;
  quantity: NumberFieldDto;
  productFields: ProductFieldDto[];
  conversation?: ProductCommentDto[] | null;
};
export type ProductGroupDto = {
  id: string;
  sourcingEventId?: string | null;
  projectId?: string | null;
  name: string;
  originProductGroupId?: string | null;
  productFields: ProductTemplateFieldDto[];
  products: ProductDto[];
};
export type ProductGroupsDto = {
  productGroups: ProductGroupDto[];
};
export type EventListItemDto = {
  id: string;
  title: string;
  kind: EventKindDto;
  bseStatus?: BseStatusDto | null;
  publicStatus?: PublicEventStatusDto | null;
  negotiationRound?: number | null;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  responsible: PersonDto;
  contractNature?: ContractNature | null;
  deadline?: string | null;
  winners?: string[] | null;
  unansweredQuestionsCount: number;
  referenceId?: string | null;
  projects?: ProjectDto[] | null;
  canEdit: boolean;
  canView: boolean;
};
export type ListCombinedEventsResponse = {
  events: EventListItemDto[];
  count: number;
};
export type BuyerEventFilterOptionsResponse = {
  responsiblePersons: PersonDto[];
  contractNatures: ContractNature[];
  statuses: string[];
};
export type CombinedEventStatusCountDto = {
  bseStatus?: BseStateNameDto | null;
  publicStatus?: PublicEventStatusDto | null;
  count: number;
};
export type CombinedEventStatusCountsResponse = {
  counts: CombinedEventStatusCountDto[];
};
export type SeDto = {
  id: string;
  title: string;
  status: BseStatusDto;
  negotiationRound?: number | null;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  deadline?: string | null;
  winners?: string[] | null;
  unansweredQuestionsCount: number;
  referenceId?: string | null;
  projects?: ProjectDto[] | null;
  canEdit: boolean;
  canView: boolean;
};
export type ListSeDtosResponse = {
  events: SeDto[];
  count: number;
};
export type ProjectDetailDto = {
  projectId: string;
  projectName: string;
  externalId?: string | null;
};
export type LinkedContract = {
  id: string;
  title?: string | null;
};
export type ContractReportDto = {
  id: string;
  createdAt?: string | null;
  modifiedAt?: string | null;
  version: number;
  contractId: string;
  title: string;
  description?: string | null;
  templateId?: string | null;
  templateName?: string | null;
  timezone?: string | null;
  currency?: string | null;
  owningOrganizationId?: string | null;
  owningOrganizationName?: string | null;
  createdById?: string | null;
  createdByEmail?: string | null;
  createdByName?: string | null;
  internalOwnerId?: string | null;
  internalOwnerEmail?: string | null;
  internalOwnerName?: string | null;
  counterpartyId?: string | null;
  counterpartyName?: string | null;
  counterpartyType?: string | null;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  counterpartyContactFullName?: string | null;
  counterpartyContactEmail?: string | null;
  counterpartyContactPhoneNumber?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  hasNoEndDate?: boolean | null;
  totalPrice?: number | null;
  estimatedValue?: number | null;
  priority?: string | null;
  risk?: string | null;
  renewalDate?: string | null;
  referenceNumber?: string | null;
  originSourcingEventId?: string | null;
  originSourcingEventName?: string | null;
  publishedById?: string | null;
  publishedByName?: string | null;
  publishedAt?: string | null;
  noticePeriod?: number | null;
  documentIds?: string[] | null;
  signedDocumentIds?: string[] | null;
  industryIds?: string[] | null;
  projectIds?: string[] | null;
  projectDetails?: ProjectDetailDto[] | null;
  terminationDate?: string | null;
  terminatedById?: string | null;
  terminatedByName?: string | null;
  terminationReason?: string | null;
  externalLink?: string | null;
  linkedContracts?: LinkedContract[] | null;
  paymentTermsInDays?: number | null;
  pricePerMonth?: number | null;
  pricePerYear?: number | null;
  purchasingPolicy?: string | null;
  supplierInfo?: SupplierInfoDto | null;
  internalParties?: InternalPartyDto[] | null;
  totalLiability?: number | null;
  warrantyExpirationDate?: string | null;
  supplierCategory?: string | null;
  options?: OptionDto[] | null;
  customFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
};
export type ListContractReportsResponseDto = {
  reports: ContractReportDto[];
  count: number;
};
export type ContractReportFilterOptionDto = {
  value: string;
  label: string;
};
export type ListContractReportOptionsResponseDto = {
  options: ContractReportFilterOptionDto[];
  count: number;
};
export type CreateContractFromSourcingEventRequest = {
  eventId: string;
  bidId: string;
  title?: string | null;
  templateId?: string | null;
  documentIds?: string[];
  textDocumentIds?: string[];
};
export type DeleteCustomFieldDto = {
  sectionId: string;
  fieldId: string;
};
export type UpsertCustomContractFieldDto = {
  field: CustomContractDataFieldDto;
  sectionId: string;
};
export type CustomFieldSearchConfigDto = {
  fieldId: string;
  searchTerm: string;
};
export type CustomFieldSelectConfigDto = {
  fieldId: string;
  selected: boolean;
};
export type ContractReportQueryDto = {
  titleFilter?: string | null;
  templateIds?: string[] | null;
  templateNameSearchTerm?: string | null;
  owningOrganizationId: string;
  owningOrganizationIds?: string[] | null;
  owningOrganizationName?: string | null;
  projectIds?: string[] | null;
  projectSearchTerm?: string | null;
  internalPartyIds?: string[] | null;
  internalPartySearchTerm?: string | null;
  visibleCustomFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  startDateFrom?: string | null;
  startDateTo?: string | null;
  endDateFrom?: string | null;
  endDateTo?: string | null;
  hasNoEndDate?: boolean | null;
  createdAtFrom?: string | null;
  createdAtTo?: string | null;
  modifiedAtFrom?: string | null;
  modifiedAtTo?: string | null;
  publishedAtFrom?: string | null;
  publishedAtTo?: string | null;
  renewalDateFrom?: string | null;
  renewalDateTo?: string | null;
  terminationDateFrom?: string | null;
  terminationDateTo?: string | null;
  warrantyExpirationDateFrom?: string | null;
  warrantyExpirationDateTo?: string | null;
  internalOwnerIds?: string[] | null;
  internalOwnerSearchTerm?: string | null;
  counterpartyIds?: string[] | null;
  counterpartyName?: string | null;
  counterpartyContactFullName?: string | null;
  counterpartyContactFullNames?: string[] | null;
  counterpartyContactEmail?: string | null;
  counterpartyContactEmails?: string[] | null;
  counterpartyContactPhoneNumber?: string | null;
  counterpartyContactPhoneNumbers?: string[] | null;
  statuses?: ContractStatusDto[] | null;
  state?: string | null;
  originSourcingEventIds?: string[] | null;
  originSourcingEventName?: string | null;
  riskLevels?: ContractRisk[] | null;
  priorityLevels?: ContractPriority[] | null;
  supplierCategories?: Category[] | null;
  referenceNumberSearchTerm?: string | null;
  referenceNumbers?: string[] | null;
  descriptionSearchTerm?: string | null;
  currencies?: string[] | null;
  publishedByIds?: string[] | null;
  publishedBySearchTerm?: string | null;
  terminatedByIds?: string[] | null;
  terminatedBySearchTerm?: string | null;
  terminationReasons?: string[] | null;
  linkedContractIds?: string[] | null;
  linkedContractTitleSearchTerm?: string | null;
  noticePeriodFrom?: number | null;
  noticePeriodTo?: number | null;
  paymentTermsInDaysFrom?: number | null;
  paymentTermsInDaysTo?: number | null;
  pricePerMonthFrom?: number | null;
  pricePerMonthTo?: number | null;
  pricePerYearFrom?: number | null;
  pricePerYearTo?: number | null;
  totalLiabilityFrom?: number | null;
  totalLiabilityTo?: number | null;
  externalLinkSearchTerm?: string | null;
  externalLinks?: string[] | null;
  purchasingPolicySearchTerm?: string | null;
  purchasingPolicies?: string[] | null;
  documentIds?: string[] | null;
  signedDocumentIds?: string[] | null;
  industryIds?: string[] | null;
  isClimateCommitted?: boolean | null;
  hasSignedCodeOfConduct?: boolean | null;
  hasCustomerContact?: boolean | null;
  customFieldSearch?: CustomFieldSearchConfigDto[] | null;
  customFieldSelect?: CustomFieldSelectConfigDto[] | null;
  optionNameSearchTerm?: string | null;
  optionNames?: string[] | null;
  limit?: number | null;
  skip?: number | null;
};
export type ContractTaskCommentDto = {
  id: string;
  text?: string | null;
  createdBy: PersonDto;
  createdAt: string;
  modifiedAt: string;
  deletedAt?: string | null;
  canUpdate: boolean;
};
export type UpdateContractTaskCommentRequest = {
  text: string;
};
export type ResponsibleOrganizationDto = {
  id: string;
  name: string;
};
export type ContractTaskDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  status: ContractTaskStatus;
  displayStatus: ContractTaskStatusDto;
  owningOrganizationName: string;
  owningOrganizationId: string;
  title: string;
  description: string;
  dueDate: string;
  responsibleOrganization: ResponsibleOrganizationDto;
  responsiblePerson: PersonDto;
  responsibleParty: ContractTaskResponsiblePartyDto;
  contractId: string;
  contractTitle: string;
  canEdit: boolean;
  canDelete: boolean;
};
export type UpdateTaskRequest = {
  title?: string | null;
  description?: string | null;
  dueDate?: string | null;
  status?: ContractTaskStatus | null;
  responsiblePerson?: string | null;
};
export type ContractTaskChangeDto = {
  type: ContractTaskChangeType;
  id: string;
  createdAt: string;
  changedByFullName: string;
  oldValue: string;
  newValue: string;
};
export type ListChangesForContractTaskResponse = {
  changes: ContractTaskChangeDto[];
};
export type ListCommentsForContractTaskResponse = {
  comments: ContractTaskCommentDto[];
};
export type CreateContractTaskCommentRequest = {
  text: string;
};
export type TextDocumentDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  owner: string;
  createdBy?: PersonDto | null;
  modifiedBy?: PersonDto | null;
  name: string;
  text: string;
  tags: string[];
  documents: ViewDocumentAsOwnerDto[];
};
export type CreateContractTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  contractId: string;
};
export type TextDocumentsDto = {
  documents: TextDocumentDto[];
};
export type FencyConversationResponse = {
  id: string;
};
export type FencySessionResponse = {
  clientToken: string;
};
export type CreateExploreMemoriesSessionRequest = {
  conversationId?: string | null;
};
export type CreateFencyFileDownloadSessionRequest = {
  agentTaskFileId: string;
};
export type CreateMemoryChatSessionRequest = {
  memoryId: string;
};
export type FencyDownloadLinkResponse = {
  downloadLink: string;
};
export type CreateMemoryDownloadLinkRequest = {
  memoryId: string;
};
export type ContractStatisticsDto = {
  numberOfContracts: number;
  numberOfActiveContracts: number;
  annualValueOfActiveContracts: number;
  numberOfContractsExpiringThisYear: number;
  annualValueOfContractsExpiringThisYear: number;
};
export type AutofillOrganizationDto = {
  name?: string | null;
  organizationNumber?: string | null;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
  country?: string | null;
  contactEmail?: string | null;
  contactPhone?: PhoneNumberDto | null;
  contactPersons?: PersonDto[] | null;
};
export type ContractAutofillContextDto = {
  contractId: string;
  title: string;
  description?: string | null;
  currency: Currency;
  timezone: string;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  createdBy: PersonDto;
  internalOwner: PersonDto;
  owningOrganization: AutofillOrganizationDto;
  counterparty?: CounterpartyDto | null;
  dataFields: ContractDataFieldsDto;
};
export type CancelSignedDocumentRequest = {
  documentId: string;
  reason: string;
};
export type ContractMessageAttachmentUploadDto = {
  documentId?: string | null;
};
export type ContractMessageAttachmentDto = {
  documentId: string;
  fileName: string;
  mimeType: string;
  savedToContract: boolean;
};
export type ContractMessageDto = {
  id: string;
  contractId: string;
  createdAt: string;
  side: ContractMessageSide;
  author: PersonDto;
  text: string;
  attachments: ContractMessageAttachmentDto[];
  readByMe: boolean;
  readByOtherPartyAt?: string | null;
};
export type ListContractMessagesResponse = {
  messages: ContractMessageDto[];
  canPostMessage: boolean;
  isSharedWithCounterparty: boolean;
};
export type CreateContractMessageRequest = {
  text: string;
  attachmentDocumentIds?: string[];
};
export type MarkMessagesReadRequest = {
  messageIds: string[];
};
export type SaveMessageAttachmentResponse = {
  savedToContract: boolean;
  alreadyPresent: boolean;
};
export type SaveMessageAttachmentRequest = {
  messageId: string;
  documentId: string;
};
export type ContractOriginCommunicationDto = {
  sourcingEventV2Id?: string | null;
  supplierInformation: SupplierInformationDto[];
  questions: SeV2QuestionDto[];
};
export type DeleteContractParticipantRequest = {
  organizationId: string;
  personId?: string | null;
};
export type ContractOwningOrgDto = {
  id: string;
  name: string;
};
export type ContractOrgParticipantDto = {
  id: string;
  roleType: ContractRoleType;
  name: string;
};
export type ContractPersonParticipantDto = {
  id: string;
  roleType?: ContractRoleType | null;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  organizationId: string;
  organizationName: string;
};
export type ListParticipantsForContractResponse = {
  owningOrganization: ContractOwningOrgDto;
  organizationParticipants: ContractOrgParticipantDto[];
  personParticipants: ContractPersonParticipantDto[];
};
export type CreateContractParticipantRequest = {
  organizationId: string;
  personId?: string | null;
  roleType: ContractRoleType;
  shouldNotifyByEmail: boolean;
};
export type CreateContractTaskRequest = {
  title: string;
  description: string;
  dueDate: string;
  responsiblePersonId: string;
};
export type ContributingEntityInviteDto = {
  inviteId: string;
  status: ContributingEntityStatus;
  role: ContributingEntityRole;
  entityName: string;
  organizationNumber: string;
  invitedEmailMasked: string;
  eventTitle: string;
  eventReference?: string | null;
  buyerOrganizationName: string;
  leadSupplierName: string;
  bidSubmissionDeadline?: string | null;
};
export type ContributingEntityDto = {
  id: string;
  bidId: string;
  eventId: string;
  role: ContributingEntityRole;
  status: ContributingEntityStatus;
  name: string;
  organizationNumber: string;
  groupRole?: string | null;
  contactEmail: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  invitedAt?: string | null;
  respondedAt?: string | null;
  supportedCriterionKeys?: string[];
  validationIssues?: ContributingEntityValidationIssueDto[];
};
export type ResolvedEspdRequirementDto = {
  id: string;
  responseDataType: EspdResponseDataType;
  optional: boolean;
  supplierDeclarationField?: SupplierDeclarationField | null;
  label: string;
  labelNorwegian?: string | null;
};
export type ResolvedEspdRequirementGroupDto = {
  id: string;
  processingInstruction?: string | null;
  optionalFields?: boolean;
  repeatable: boolean;
  requirements: ResolvedEspdRequirementDto[];
  subGroups: ResolvedEspdRequirementGroupDto[];
};
export type ResolvedEspdCriterionDto = {
  id: string;
  typeCode: string;
  category: string;
  name: string;
  nameNorwegian?: string | null;
  description: string;
  descriptionNorwegian?: string | null;
  mandatory: boolean;
  requiresSeparateEspd?: boolean;
  requirementGroups: ResolvedEspdRequirementGroupDto[];
};
export type ContributingEntityContextDto = {
  eventTitle: string;
  eventReference?: string | null;
  buyerOrganizationName: string;
  leadSupplierName: string;
  bidSubmissionDeadline?: string | null;
  exclusionCriteria: ResolvedEspdCriterionDto[];
  selectionCriteria?: SelectionCriterionDto[];
  groupName?: string | null;
  otherParticipants?: string[];
};
export type ContributingEntityQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
};
export type ContributingEntityCommitmentDto = {
  confirmed?: boolean;
  resources?: string | null;
};
export type ContributingEntityDetailDto = {
  entity: ContributingEntityDto;
  context: ContributingEntityContextDto;
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: ContributingEntityQualificationResponseDto[];
  commitment?: ContributingEntityCommitmentDto | null;
  commitmentRequired?: boolean;
  responseEditable: boolean;
  responseReopenable?: boolean;
};
export type DeclineContributingEntityInviteRequestDto = {
  reason?: string | null;
};
export type CpvCodeDto = {
  code: string;
  nameEn: string;
  nameNb: string;
};
export type GetCpvCodesResponse = {
  codes: CpvCodeDto[];
};
export type FilterOptionDto = {
  id: string;
  name: string;
};
export type ContractFilterOptionsDto = {
  counterparties: FilterOptionDto[];
  internalParties: FilterOptionDto[];
  persons: FilterOptionDto[];
  projects: ProjectDto[];
};
export type ContractListItemDto = {
  id: string;
  status?: ContractStatusDto | null;
  state: ContractStateDto;
  title: string;
  timezone: string;
  currency: Currency;
  counterparty?: CounterpartyDto | null;
  internalParties?: InternalPartyDto[] | null;
  endDate?: string | null;
  hasNoEndDate?: boolean | null;
  estimatedValue?: number | null;
  template?: ContractTemplateMinDto | null;
  owningOrganization: OrgPitchDto;
  internalOwner: PersonDto;
  containsIfrsValues: boolean;
  iamParticipant: boolean;
  projects?: ProjectDto[] | null;
};
export type ListContractsResponseDto = {
  contracts: ContractListItemDto[];
};
export type ForceDeliverBidResponseDto = {
  status: BidV2Status;
};
export type ForcePublishResponseDto = {
  status: SourcingEventStatus;
};
export type SkipPastGateResponseDto = {
  gate: SkippableGateDto;
  skewSeconds: number;
  gateDeadline: string;
};
export type SkipPastGateRequestDto = {
  gate: SkippableGateDto;
};
export type StartDocumentChatRequest = {
  documentId?: string | null;
  signedDocumentId?: string | null;
  model: AiModelDto;
  messages: GptMessage[];
  reasoningEffort: string;
  responseFormat?: JsonSchemaDto | null;
};
export type UpdateDocumentMetaRequest = {
  name?: string | null;
  tags?: string[] | null;
  category?: DocumentCategory | null;
};
export type GetDownloadLinkResponse = {
  url: string;
};
export type CreateDocumentTemplateRequest = {
  name: string;
  text: string;
  tags: string[];
};
export type CreateBulkFencySessionRequest = {
  documentIds?: string[];
  signedDocumentIds?: string[];
};
export type DoffinSubmissionResponseDto = {
  status: string;
};
export type DownloadTextDocumentRequest = {
  fileName: string;
  content: string;
};
export type SeV2AttachmentDownloadLinkResponse = {
  url: string;
};
export type SearchIndustriesResponse = {
  industries: IndustryDto[];
};
export type LibraryElementOwnerDto = {
  global: boolean;
  organizationId?: string | null;
};
export type LibraryAwardSubCriterionDto = {
  criterionType: AwardCriterionType;
  name: string;
  description: string;
  id?: string | null;
  answerFormat?: AwardSubCriterionAnswerFormat;
  requiresDocumentation?: boolean;
};
export type LibraryElementContentDto = {
  type: LibraryElementTypeDto;
  minimum?: MinimumRequirementDto | null;
  selection?: SelectionCriterionDto | null;
  award?: AwardCriterionDto | null;
  awardSubCriterion?: LibraryAwardSubCriterionDto | null;
};
export type LibraryElementDto = {
  id: string;
  owner: LibraryElementOwnerDto;
  tags: string[];
  content: LibraryElementContentDto;
  createdAt: string;
  modifiedAt: string;
};
export type LibraryElementsDto = {
  elements: LibraryElementDto[];
};
export type CreateLibraryElementRequest = {
  content: LibraryElementContentDto;
  tags?: string[];
  global?: boolean;
};
export type UpdateLibraryElementRequest = {
  id: string;
  content: LibraryElementContentDto;
  tags?: string[];
};
export type SourcingEventNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  supplierOrganizationName?: string | null;
  changedAreas?: ChangedArea[];
  bidDeliveryKind?: SeV2BidDeliveryKind | null;
};
export type BidNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  supplierOrganizationName: string;
};
export type SourcingEventQuestionNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  questionId: string;
  questionSubject: string;
  receiverRole: ReceiverRoleDto;
};
export type SourcingEventQuestionCommentNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  questionId: string;
  questionSubject: string;
  receiverRole: ReceiverRoleDto;
};
export type SourcingEventAnnouncementNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  announcementId: string;
  announcementTitle: string;
};
export type ContractNotificationMetaDto = {
  triggeredByFirstName?: string | null;
  contractName: string;
  contractId: string;
};
export type ContractReminderNotificationMetaDto = {
  contractName: string;
  contractId: string;
  contractTimezone: string;
  reminderType: ContractDateReminderType;
  date: string;
};
export type ContractTaskNotificationMetaDto = {
  triggeredByFirstName?: string | null;
  taskId: string;
  taskName: string;
  contractName: string;
  contractId: string;
  projectName?: string | null;
  counterpartyName?: string | null;
};
export type ContractDocumentNotificationMetaDto = {
  documentId: string;
  documentName: string;
  contractName: string;
  contractId: string;
};
export type SeV2ResponsibleBuyerChangedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  previousResponsibleName: string;
  newResponsibleName: string;
};
export type SeV2InvitedToTenderNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  bidSubmissionDeadline: string;
};
export type SeV2OrganizationInviteNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  bidSubmissionDeadline: string;
};
export type SeV2RequestNotQualifiedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  verdictComment?: string | null;
};
export type SeV2BidRejectedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  rejectionReason?: string | null;
};
export type SeV2RequestNotSelectedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  selectionReason?: string | null;
};
export type SeV2DpsAdmittedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
};
export type SeV2QualificationSchemeAdmittedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
};
export type SeV2QualificationSchemeRemovedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  removalReason: string;
};
export type SeV2DpsRemovedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  removalReason: string;
};
export type SeV2DoffinPublishedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  doffinReference: string;
  isChangeNotice: boolean;
};
export type SeV2DoffinPublicationFailedNotificationMetaDto = {
  eventId: string;
  eventTitle: string;
  eventOwningOrganizationId: string;
  eventOwningOrganizationName: string;
  isChangeNotice: boolean;
};
export type NotificationTypeMetaDto = {
  sourcingEvent?: SourcingEventNotificationMetaDto | null;
  negotiationRoundId?: string | null;
  bid?: BidNotificationMetaDto | null;
  sourcingEventQuestion?: SourcingEventQuestionNotificationMetaDto | null;
  sourcingEventQuestionComment?: SourcingEventQuestionCommentNotificationMetaDto | null;
  sourcingEventAnnouncement?: SourcingEventAnnouncementNotificationMetaDto | null;
  contract?: ContractNotificationMetaDto | null;
  contractReminder?: ContractReminderNotificationMetaDto | null;
  contractTask?: ContractTaskNotificationMetaDto | null;
  contractDocument?: ContractDocumentNotificationMetaDto | null;
  seV2ResponsibleBuyerChanged?: SeV2ResponsibleBuyerChangedNotificationMetaDto | null;
  seV2InvitedToTender?: SeV2InvitedToTenderNotificationMetaDto | null;
  seV2OrganizationInvite?: SeV2OrganizationInviteNotificationMetaDto | null;
  seV2RequestNotQualified?: SeV2RequestNotQualifiedNotificationMetaDto | null;
  seV2BidRejected?: SeV2BidRejectedNotificationMetaDto | null;
  seV2RequestNotSelected?: SeV2RequestNotSelectedNotificationMetaDto | null;
  seV2DpsAdmitted?: SeV2DpsAdmittedNotificationMetaDto | null;
  seV2QualificationSchemeAdmitted?: SeV2QualificationSchemeAdmittedNotificationMetaDto | null;
  seV2QualificationSchemeRemoved?: SeV2QualificationSchemeRemovedNotificationMetaDto | null;
  seV2DpsRemoved?: SeV2DpsRemovedNotificationMetaDto | null;
  seV2DoffinPublished?: SeV2DoffinPublishedNotificationMetaDto | null;
  seV2DoffinPublicationFailed?: SeV2DoffinPublicationFailedNotificationMetaDto | null;
};
export type NotificationDto = {
  type: NotificationTypeDto;
  id: string;
  createdAt: string;
  peeked: boolean;
  viewed: boolean;
  meta: NotificationTypeMetaDto;
};
export type ListNotificationsResponse = {
  notifications: NotificationDto[];
};
export type OrgUserDto = {
  person: PersonDto;
  roles: OrganizationRoleType[];
};
export type ListOrganizationUsersResponse = {
  users: OrgUserDto[];
  count: number;
};
export type ListOrganizationsForMeResponse = {
  orgs: OrgDto[];
};
export type EmailInviteContextDto = {
  emailInviteId: string;
  emailInviteType: EmailInviteTypeDto;
  secret: string;
};
export type CreateOrgRequest = {
  companyName: string;
  countryId: string;
  organizationNumber?: string | null;
  emailInviteContext?: EmailInviteContextDto | null;
};
export type MarkNotificationsRequest = {
  notificationIds: string[];
};
export type RecordRecentlyViewedRequest = {
  entityKind: ViewableEntityKind;
  entityId: string;
};
export type RecentlyViewedContractDto = {
  id: string;
  title: string;
  state: ContractStateDto;
  status?: ContractStatusDto | null;
  endDate?: string | null;
  counterpartyName?: string | null;
  viewedAt: string;
};
export type ListRecentlyViewedContractsResponse = {
  contracts: RecentlyViewedContractDto[];
};
export type RecentlyViewedEventDto = {
  event: EventListItemDto;
  viewedAt: string;
};
export type ListRecentlyViewedEventsResponse = {
  events: RecentlyViewedEventDto[];
};
export type UpcomingDeadlineDto = {
  subject: DeadlineSubject;
  subjectId: string;
  subjectTitle: string;
  kind: DeadlineKind;
  dueAt: string;
  detail?: string | null;
};
export type ListUpcomingDeadlinesResponse = {
  deadlines: UpcomingDeadlineDto[];
};
export type NeedValueDto = {
  value?: number | null;
  currency?: Currency;
};
export type NeedHistoryEntryDto = {
  toStatus: NeedStatus;
  at: string;
  by: PersonDto;
};
export type ProcurementSummaryDto = {
  id: string;
  title?: string | null;
  status: SourcingEventStatus;
};
export type NeedDto = {
  id: string;
  createdAt: string;
  modifiedAt: string;
  status: NeedStatus;
  title?: string | null;
  description?: string | null;
  estimatedValue?: NeedValueDto | null;
  valueAssessment?: string | null;
  budgetLine?: string | null;
  deliveryDate?: string | null;
  departmentId?: string | null;
  priority?: NeedPriority | null;
  procurementType?: ContractNature | null;
  foaPart?: FoaPart | null;
  contactPersonId?: string | null;
  contactPerson?: PersonDto | null;
  documents?: ViewDocumentAsOwnerDto[] | null;
  createdBy: PersonDto;
  department?: DepartmentDto | null;
  history?: NeedHistoryEntryDto[];
  procurement?: ProcurementSummaryDto | null;
  canEdit?: boolean;
};
export type CreateNeedRequest = {
  title?: string | null;
  departmentId?: string | null;
};
export type CreateNeedTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  needId: string;
};
export type NeedValuePatchDto = {
  value?: number | null;
  currency?: Currency;
};
export type NeedPatchDto = {
  title?: string;
  description?: string | null;
  estimatedValue?: NeedValuePatchDto | null;
  valueAssessment?: string | null;
  budgetLine?: string | null;
  deliveryDate?: string | null;
  departmentId?: string | null;
  priority?: NeedPriority | null;
  procurementType?: ContractNature | null;
  contactPersonId?: string | null;
  documents?: ViewDocumentAsOwnerDto[];
  status?: NeedStatus;
};
export type ListNeedsResponse = {
  needs: NeedDto[];
};
export type CreateNegotiationTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  negotiationRoundId: string;
};
export type AccessTokenDto = {
  accessToken: string;
  expiresIn: number;
  scope: string;
  tokenType: string;
};
export type GetAccessTokenRequest = {
  organizationId: string;
  personId: string;
};
export type BrregAddressDto = {
  streetLines: string[];
  postCode?: string | null;
  city?: string | null;
  countryCode?: string | null;
};
export type BrregOrgDto = {
  organizationNumber: string;
  name: string;
  organizationForm?: string | null;
  businessAddress?: BrregAddressDto | null;
  isActive: boolean;
};
export type SearchBrregOrgsByNameResponse = {
  orgs: BrregOrgDto[];
};
export type CreateApiClientResponse = {
  clientId: string;
  secret: string;
};
export type CreateOrganizationEntryRequest = {
  name: string;
  industryIds: string[];
  countryId: string;
  organizationNumber: string;
  street?: string | null;
  city?: string | null;
  postCode?: string | null;
};
export type UpdateOrganizationEntryRequest = {
  name?: string | null;
  countryId?: string | null;
  organizationNumber?: string | null;
};
export type LinkOrganizationEntryRequest = {
  organizationId: string;
};
export type AcceptedInfoDto = {
  acceptedAt: string;
  organizationName: string;
  personFirstName?: string | null;
  personLastName?: string | null;
  personEmail: string;
};
export type SupplierEmailInviteDto = {
  id: string;
  sentAt: string;
  sentBy: PersonDto;
  email: string;
  organizationName: string;
  personFirstName: string;
  personLastName: string;
  acceptedInfo?: AcceptedInfoDto | null;
};
export type OrgUserEmailInviteDto = {
  id: string;
  sentAt: string;
  sentBy: PersonDto;
  email: string;
  role: OrgUserInviteRole;
  organizationName: string;
};
export type AssessmentTemplatesDto = {
  templates: AssessmentTemplateDto[];
  count: number;
};
export type UpdateCriterionScoreDto = {
  criterionId: string;
  score?: number | null;
  comment?: string | null;
};
export type UpdateDimensionScoreDto = {
  dimensionId: string;
  directScore?: number | null;
  scoreRange?: ScoreRangeDto | null;
  comment?: string | null;
  criterionScores?: UpdateCriterionScoreDto[] | null;
};
export type UpdateAssessmentRequestDto = {
  name?: string | null;
  description?: string | null;
  dimensionScores?: UpdateDimensionScoreDto[] | null;
  status?: string | null;
};
export type AssessmentsDto = {
  assessments: AssessmentDto[];
  count: number;
};
export type OrgWithOwnerDto = {
  organizationId: string;
  organizationName: string;
  ownerName: string;
  ownerEmail: string;
};
export type ListOrgsByNumberResponse = {
  orgs: OrgWithOwnerDto[];
};
export type EditName = {
  value: string;
};
export type EditCountry = {
  countryId: string;
};
export type EditAboutUs = {
  value?: string | null;
};
export type EditStandardTerms = {
  value?: string | null;
};
export type EditSpecializations = {
  value?: string | null;
};
export type EditHomePageUrl = {
  url?: string | null;
};
export type EditIndustries = {
  value: string[];
};
export type EditSize = {
  size?: OrganizationSize | null;
};
export type EditAdmins = {
  value: string[];
};
export type EditAzureUsersDefaultRole = {
  value: OrgUserInviteRole;
};
export type EditInternalParties = {
  parties?: string[] | null;
  selfRegisteredParties?: string[] | null;
};
export type EditContactPersons = {
  persons?: string[] | null;
};
export type EditStreet = {
  value?: string | null;
};
export type EditCity = {
  value?: string | null;
};
export type EditPostCode = {
  value?: string | null;
};
export type EditContactEmail = {
  value?: string | null;
};
export type EditContactPhone = {
  value?: PhoneNumberDto | null;
};
export type EditDefaultRegulation = {
  value?: Regulation | null;
};
export type EditOrganizationRequest = {
  name?: EditName | null;
  country?: EditCountry | null;
  organizationNumber?: string | null;
  aboutUs?: EditAboutUs | null;
  standardTerms?: EditStandardTerms | null;
  specializations?: EditSpecializations | null;
  homePageUrl?: EditHomePageUrl | null;
  industries?: EditIndustries | null;
  size?: EditSize | null;
  admins?: EditAdmins | null;
  azureUsersDefaultRole?: EditAzureUsersDefaultRole | null;
  allowScimUsersOnly?: boolean | null;
  enforceEntraIDAuthentication?: boolean | null;
  canOnlySeeCreatedContracts?: boolean | null;
  canOnlySeeCreatedEvents?: boolean | null;
  defaultNotificationSettings?: DefaultNotificationSettingsDto | null;
  internalParties?: EditInternalParties | null;
  contactPersons?: EditContactPersons | null;
  street?: EditStreet | null;
  city?: EditCity | null;
  postCode?: EditPostCode | null;
  contactEmail?: EditContactEmail | null;
  contactPhone?: EditContactPhone | null;
  buyerLegalType?: EditBuyerLegalType | null;
  defaultRegulation?: EditDefaultRegulation | null;
};
export type AccessGrantDto = {
  personId: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  role: GrantRole;
  scope: AccessScopeDto;
  departmentId?: string | null;
  departmentName?: string | null;
  eventId?: string | null;
  eventName?: string | null;
  source: AccessGrantSourceDto;
  issuedAt: string;
};
export type ListAccessGrantsResponse = {
  grants: AccessGrantDto[];
};
export type DepartmentAdministrationDto = {
  id: string;
  name: string;
  isDefault: boolean;
  active: boolean;
  events: number;
  contracts: number;
  projects: number;
  needs: number;
};
export type ListDepartmentsResponse = {
  departments: DepartmentAdministrationDto[];
};
export type DepartmentNameRequest = {
  name: string;
  defaultDepartmentName?: string | null;
};
export type DepartmentRoleRequest = {
  personId: string;
  role: GrantRole;
};
export type EntraGroupMappingDto = {
  id: string;
  role: OrganizationRoleType;
  departmentId?: string | null;
};
export type EntraGroupDto = {
  userGroupId: string;
  displayName: string;
  objectId?: string | null;
  memberCount: number;
  mapping?: EntraGroupMappingDto | null;
  suggestedRole?: OrganizationRoleType | null;
};
export type EntraConnectionDto = {
  id: string;
  tenantId: string;
  status: EntraConnectionStatus;
  lastReconciledAt?: string | null;
  jitEnabled: boolean;
  jitDefaultRole: OrgUserInviteRole;
  groups: EntraGroupDto[];
};
export type EntraConnectionsDto = {
  connections: EntraConnectionDto[];
};
export type CreateEntraConnectionRequest = {
  tenantId: string;
};
export type UpdateEntraConnectionRequest = {
  defaultRole: OrgUserInviteRole;
};
export type SaveEntraGroupMappingRequest = {
  userGroupId: string;
  role: OrganizationRoleType;
  departmentId?: string | null;
};
export type ListOrganizationInvitesResponse = {
  invitations: SupplierEmailInviteDto[];
};
export type SupplierInviteParams = {
  personFirstName: string;
  personLastName: string;
  organizationName: string;
};
export type CreateEmailInviteRequest = {
  email: string;
  supplierInvite: SupplierInviteParams;
  language: EmailInviteLanguage;
};
export type UpdateOrgTenantRequest = {
  tenantId?: string | null;
};
export type ListOrgUserEmailInvitesResponse = {
  invitations: OrgUserEmailInviteDto[];
};
export type CreateOrgUserEmailInviteRequest = {
  email: string;
  role: OrgUserInviteRole;
  language: EmailInviteLanguage;
  emailInviteSecretOverride?: string | null;
};
export type UpdateOrgUserRoleRequest = {
  newRoles: OrganizationRoleType[];
};
export type ListContractTasksResponseDto = {
  tasks: ContractTaskDto[];
};
export type ContractTemplateDto = {
  id: string;
  name?: string | null;
  description?: string | null;
  commonType?: CommonTemplateType | null;
  ownerType: ContractOwnerContextType;
  createdAt: string;
  createdBy?: PersonDto | null;
  requiredFields: ContractDataFieldDto[];
  requiredCustomDataFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
};
export type ListContractTemplatesResponseDto = {
  templates: ContractTemplateDto[];
};
export type UpsertContractTemplateRequest = {
  name: string;
  description?: string | null;
  requiredDataFields: ContractDataFieldNameDto[];
  requiredCustomDataFields: CustomFieldIdentifierDto[];
};
export type CounterpartyInputDto = {
  organizationId?: string | null;
  organizationEntryId?: string | null;
};
export type EditCounterparty = {
  counterparty: CounterpartyInputDto;
};
export type EditTemplate = {
  templateId?: string | null;
};
export type EditInternalOwner = {
  personId: string;
};
export type EditCounterpartyContactPerson = {
  fullName?: string | null;
  email?: string | null;
  phone?: PhoneNumberDto | null;
  personId?: string | null;
};
export type EditDeliveryTerms = {
  terms?: string | null;
};
export type EditPurchasingPolicy = {
  policy?: string | null;
};
export type EditOriginSourcingEvent = {
  eventId?: string | null;
};
export type EditIndustryIds = {
  industryIds: string[];
};
export type EditInternalReferenceNumber = {
  number?: string | null;
};
export type EditExternalLink = {
  link?: string | null;
};
export type EditRisk = {
  risk: ContractRisk;
};
export type EditPriority = {
  priority: ContractPriority;
};
export type EditLinkedContracts = {
  contractIds: string[];
};
export type EditPricePerYear = {
  amount?: number | null;
};
export type EditPricePerMonth = {
  amount?: number | null;
};
export type EditTotalPrice = {
  amount?: number | null;
};
export type EditTotalLiability = {
  amount?: number | null;
};
export type EditPaymentTermsInDays = {
  days?: number | null;
};
export type EditEndDate = {
  date?: string | null;
  hasNoEndDate: boolean;
};
export type EditStartDate = {
  date?: string | null;
};
export type EditAwardDate = {
  date?: string | null;
};
export type EditRenewalDate = {
  date?: string | null;
};
export type EditWarrantyExpirationDate = {
  date?: string | null;
};
export type EditValueAmount = {
  amount?: number | null;
};
export type EditIfrsValues = {
  startDate?: string | null;
  startDateSecondPeriod?: string | null;
  monthlyPayment?: number | null;
  paymentIntervalInMonths?: number | null;
  contractLengthInMonths?: number | null;
  interestRate?: number | null;
};
export type EditSupplierInfo = {
  isClimateCommitted: boolean;
  hasSignedCodeOfConduct: boolean;
  hasCustomerContact: boolean;
};
export type EditCurrency = {
  currency: Currency;
};
export type AddTerminationDate = {
  date: string;
  reason: string;
};
export type AddDateReminderNotification = {
  inAdvanceUnit: ContractNotificationDurationType;
  inAdvanceAmount: number;
  receiverIds: string[];
  dateReminderType: ContractDateReminderType;
};
export type AddAdjustment = {
  date: string;
  value: number;
};
export type EditSupplierCategory = {
  category?: Category | null;
};
export type EditNoticePeriod = {
  duration: number;
};
export type EditOption = {
  id: string;
  name?: string;
  description?: string;
  startDate?: string | null;
  deadline?: string | null;
  endDate?: string | null;
  duration?: number | null;
  isExecuted?: boolean;
};
export type ExecuteOption = {
  id: string;
};
export type RemoveOption = {
  id: string;
};
export type UpdateContractRequest = {
  title?: string | null;
  description?: string | null;
  removeDocument?: string | null;
  removeDescriptionDocument?: string | null;
  counterparty?: EditCounterparty | null;
  template?: EditTemplate | null;
  editProjects?: string[] | null;
  internalOwner?: EditInternalOwner | null;
  counterpartyContactPerson?: EditCounterpartyContactPerson | null;
  deliveryTerms?: EditDeliveryTerms | null;
  purchasingPolicy?: EditPurchasingPolicy | null;
  originSourcingEvent?: EditOriginSourcingEvent | null;
  industry?: EditIndustryIds | null;
  internalReferenceNumber?: EditInternalReferenceNumber | null;
  externalLink?: EditExternalLink | null;
  risk?: EditRisk | null;
  priority?: EditPriority | null;
  linkedContracts?: EditLinkedContracts | null;
  pricePerYear?: EditPricePerYear | null;
  pricePerMonth?: EditPricePerMonth | null;
  totalPrice?: EditTotalPrice | null;
  totalLiability?: EditTotalLiability | null;
  paymentTermsInDays?: EditPaymentTermsInDays | null;
  endDate?: EditEndDate | null;
  startDate?: EditStartDate | null;
  awardDate?: EditAwardDate | null;
  renewalDate?: EditRenewalDate | null;
  warrantyExpirationDate?: EditWarrantyExpirationDate | null;
  timezone?: EditTimezone | null;
  valueAmount?: EditValueAmount | null;
  ifrsValues?: EditIfrsValues | null;
  supplierInfo?: EditSupplierInfo | null;
  internalParties?: EditInternalParties | null;
  currency?: EditCurrency | null;
  terminationDate?: AddTerminationDate | null;
  addDateReminderNotification?: AddDateReminderNotification | null;
  removeNotification?: string | null;
  addDataFields?: ContractDataFieldNameDto[] | null;
  editCustomFields?: {
    [key: string]: ContractDataFieldSectionDto;
  } | null;
  removeDataField?: ContractDataFieldNameDto | null;
  addMonetaryValueAdjustment?: AddAdjustment | null;
  removeMonetaryValueAdjustment?: string | null;
  addPercentageValueAdjustment?: AddAdjustment | null;
  removePercentageValueAdjustment?: string | null;
  editSupplierCategory?: EditSupplierCategory | null;
  editNoticePeriod?: EditNoticePeriod | null;
  editOption?: EditOption | null;
  executeOption?: ExecuteOption | null;
  removeOption?: RemoveOption | null;
};
export type TextDocumentAttachmentInputDto = {
  textDocumentId: string;
  htmlContent: string;
};
export type AttachmentInputDto = {
  documentId?: string | null;
  textDocument?: TextDocumentAttachmentInputDto | null;
};
export type SignerDto = {
  firstName: string;
  lastName: string;
  email: string;
  signatureMethod: DocumentSignerMethod;
};
export type CreateSignedDocumentRequest = {
  mainDocumentId: string;
  attachments?: AttachmentInputDto[] | null;
  signers: SignerDto[];
  language: EmailInviteLanguage;
  deadline?: string | null;
};
export type CreateSignedTextDocumentRequest = {
  textDocumentId: string;
  htmlContent: string;
  attachments?: AttachmentInputDto[] | null;
  signers: SignerDto[];
  language: EmailInviteLanguage;
  deadline?: string | null;
};
export type CreateContractRequest = {
  title: string;
  timezone: string;
  templateId?: string | null;
  projects?: string[] | null;
};
export type ListPersonsResponse = {
  persons: PersonDto[];
  count: number;
};
export type ListPersonsByIdsResponse = {
  persons: PersonDto[];
};
export type MeDto = {
  id: string;
  identityId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  emailVerified: boolean;
  corporateTitle?: string | null;
  phoneNumber?: PhoneNumberDto | null;
  canCreateOrg: boolean;
  intercomSecretHash: string;
  isSystemAdmin: boolean;
};
export type EditPhoneNumber = {
  value?: PhoneNumberDto | null;
};
export type EditMeRequest = {
  firstName?: string | null;
  lastName?: string | null;
  corporateTitle?: string | null;
  phoneNumber?: EditPhoneNumber | null;
};
export type SupplierBidV2QualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[] | null;
  evidenceDocuments?: ViewDocumentAsOwnerDto[] | null;
};
export type SupplierBidV2MinimumRequirementResponseDto = {
  minimumRequirementId: string;
  answer: boolean;
  comment?: string | null;
  attachmentIds?: string[] | null;
  attachments?: ViewDocumentAsOwnerDto[] | null;
};
export type BidV2Dto = {
  id: string;
  forEvent: string;
  status: BidV2Status;
  isContentEditable?: boolean;
  submissionDeadlinePassed?: boolean;
  submissionDeadline?: string | null;
  submittedAt?: string | null;
  statusHistory?: BidV2StatusTransitionDto[];
  espdResponse?: EspdResponseDto | null;
  derivedEspdAnswers?: EspdRequirementResponseDto[];
  qualificationResponses?: SupplierBidV2QualificationResponseDto[];
  minimumRequirementResponses?: SupplierBidV2MinimumRequirementResponseDto[];
  awardCriterionResponses?: BidV2AwardCriterionResponseDto[];
  price?: EventValueDto | null;
  coverLetter?: string | null;
  signedDocumentId?: string | null;
  documents?: ViewDocumentAsOwnerDto[];
  previousSigningOutcome?: PreviousSigningOutcome | null;
  rejection?: BidV2RejectionDto | null;
  termsToAccept?: string | null;
  termsAccepted?: boolean;
  products?: ProductGroupBidDto[] | null;
  comment?: string | null;
  commentDocuments?: ViewDocumentAsOwnerDto[];
  espd?: BuyerBidV2EspdDto | null;
  declarations?: BuyerBidV2DeclarationsDto | null;
  ownerName?: string | null;
  ownerOrganizationNumber?: string | null;
};
export type BidV2PatchDto = {
  espdResponse?: EspdResponseDto;
  qualificationResponses?: SupplierBidV2QualificationResponseDto[];
  minimumRequirementResponses?: SupplierBidV2MinimumRequirementResponseDto[];
  awardCriterionResponses?: BidV2AwardCriterionResponseDto[];
  price?: EventValueDto;
  products?: ProductGroupBidDto[] | null;
  coverLetter?: string;
  documents?: ViewDocumentAsOwnerDto[];
};
export type ContributingEntityListDto = {
  items: ContributingEntityDto[];
};
export type AddContributingEntityRequestDto = {
  role: ContributingEntityRole;
  organizationNumber: string;
  name: string;
  groupRole?: string | null;
  contactEmail: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  language?: EmailInviteLanguage;
  supportedCriterionKeys?: string[];
};
export type UpdateContributingEntityRequestDto = {
  role: ContributingEntityRole;
  name: string;
  groupRole?: string | null;
  contactEmail: string;
  contactFirstName?: string | null;
  contactLastName?: string | null;
  supportedCriterionKeys: string[];
};
export type StartBidV2SigningResponseDto = {
  signingUrl: string;
  signedDocumentId: string;
};
export type StartBidV2SigningRequestDto = {
  successUrl: string;
  cancelUrl: string;
  errorUrl: string;
};
export type CancelBidV2SigningResponseDto = {
  bidId: string;
  outcome: CancelBidV2SigningOutcome;
};
export type CancelBidV2SigningRequestDto = {
  reason?: string | null;
};
export type BidV2PreflightDto = {
  ready: boolean;
  remaining: PreflightRequirementDto[];
  warnings?: PreflightWarningDto[];
};
export type UpdateContributingEntityResponseRequestDto = {
  espdResponse?: EspdResponseDto | null;
};
export type UpdateContributingEntityCommitmentRequestDto = {
  commitment: ContributingEntityCommitmentDto;
};
export type UpdateContributingEntityQualificationResponsesRequestDto = {
  responses?: ContributingEntityQualificationResponseDto[];
};
export type PortalLifecycleDto = {
  status: PortalLifecycleStatus;
  cancelledReason?: string | null;
};
export type PortalSourcingEventSummaryDto = {
  id: string;
  title: string;
  description?: string | null;
  bidSubmissionDeadline: string;
  competitionStage?: CompetitionStageDto | null;
  lifecycle: PortalLifecycleDto;
  buyerName: string;
  contextType: PortalEventContextType;
  referenceId?: string | null;
  procedureType?: ProcedureType | null;
  estimatedValue?: EventValueDto | null;
  cpvCodes?: CpvCodeDto[];
  publishedAt?: string | null;
};
export type PortalLifecycleCountDto = {
  status: PortalLifecycleStatus;
  count: number;
};
export type PortalSourcingEventsResponse = {
  events: PortalSourcingEventSummaryDto[];
  totalCount: number;
  nextCursor?: string | null;
  lifecycleCounts?: PortalLifecycleCountDto[];
};
export type PortalAwardCriteriaDto = {
  model: PortalAwardModel;
  criteria?: AwardCriterionDto[];
};
export type PortalPriceModelDto = {
  type: PortalPriceModelType;
  breakpointPercent?: number | null;
};
export type PortalDocumentDto = {
  id: string;
  name: string;
  mimeType: string;
  fileExtension: string;
  size: number;
  uploadedAt: string;
  category?: DocumentCategory | null;
};
export type PortalTextDocumentDto = {
  id: string;
  name: string;
  text: string;
  createdAt: string;
  documents?: PortalDocumentDto[];
};
export type PortalSourcingEventDetailDto = {
  id: string;
  title: string;
  description?: string | null;
  bidSubmissionDeadline?: string | null;
  questionDeadline?: string | null;
  requestDeadline?: string | null;
  competitionStage?: CompetitionStageDto | null;
  collectsEspdWithBid?: boolean;
  dpsValidFrom?: string | null;
  dpsValidTo?: string | null;
  qualificationSchemeValidFrom?: string | null;
  qualificationSchemeValidTo?: string | null;
  submissionDeadlinePassed?: boolean;
  lifecycle: PortalLifecycleDto;
  buyerName: string;
  contextType: PortalEventContextType;
  buyerRunsPublicProcurements?: boolean;
  myInviteStatus?: PortalInviteStatusDto;
  buyerOrganizationNumber?: string | null;
  buyerCity?: string | null;
  buyerContactName?: string | null;
  buyerContactTitle?: string | null;
  referenceId?: string | null;
  procedureType?: ProcedureType | null;
  contractNature?: ContractNature | null;
  deliveryPlace?: string | null;
  estimatedValue?: EventValueDto | null;
  cpvCodes?: CpvCodeDto[];
  publishedAt?: string | null;
  contractStartDate?: string | null;
  contractEndDate?: string | null;
  selectionCriteria?: SelectionCriterionDto[];
  minimumRequirements?: MinimumRequirementDto[];
  awardCriteria?: PortalAwardCriteriaDto | null;
  priceModel?: PortalPriceModelDto | null;
  collectSupplierPrice?: boolean;
  documents?: PortalDocumentDto[];
  textDocuments?: PortalTextDocumentDto[];
  applicableSupplierDeclarationCriteria?: ResolvedEspdCriterionDto[];
  applicableExclusionCriteria?: ResolvedEspdCriterionDto[];
  applicableQualificationCriteria?: ResolvedEspdCriterionDto[];
  changeLog?: EventRevisionDto[];
};
export type PortalAwardLetterDto = {
  letter?: AwardLetterDto | null;
  standstillExpiresAt?: string | null;
  regulation?: Regulation | null;
  winnerNames?: string[];
};
export type PortalDocumentDownloadLinkResponse = {
  url: string;
};
export type PortalBidDocumentDto = {
  documentId: string;
  fileName: string;
};
export type PortalBidDocumentsResponse = {
  documents: PortalBidDocumentDto[];
};
export type ParticipationQualificationResponseDto = {
  criterionKey: string;
  description?: string | null;
  evidenceDocumentIds?: string[];
};
export type QualificationVerdictDto = {
  qualified: boolean;
  decidedAt: string;
  rejectionReason?: string | null;
  rejection?: ParticipationRequestRejectionDto | null;
};
export type ParticipationRequestDto = {
  id: string;
  sourcingEventId: string;
  status: ParticipationRequestStatus;
  submittedAt?: string | null;
  espdResponse?: EspdResponseDto | null;
  qualificationResponses?: ParticipationQualificationResponseDto[];
  qualificationVerdict?: QualificationVerdictDto | null;
  selectionOutcome?: SelectionOutcomeDto | null;
};
export type MyParticipationDto = {
  request?: ParticipationRequestDto | null;
  invited?: boolean;
};
export type CreateSeV2QuestionRequest = {
  subject: string;
  content: string;
  attachments?: SeV2AttachmentInputDto[];
};
export type PortalRegisterInterestResponse = {
  hasRegistered: boolean;
};
export type PortalRegistrationStatusResponse = {
  hasRegistered: boolean;
  currentBidId?: string | null;
  currentBidStatus?: BidV2Status | null;
};
export type AcceptPortalInviteResponse = {
  accepted: boolean;
};
export type PortalRoundBidCreatedDto = {
  bidId: string;
  forNegotiationRound?: string | null;
  status: string;
};
export type DeclinePortalInviteResponse = {
  declined: boolean;
};
export type PortalRoundBidDto = {
  bidId: string;
  status: BidV2Status;
};
export type PortalNegotiationRoundDto = {
  id: string;
  roundNumber: number;
  isFinalRound?: boolean | null;
  status: NegotiationRoundStatus;
  deadline: string;
  title?: string | null;
  description?: string | null;
  publishedAt?: string | null;
  completedAt?: string | null;
  documents: PortalDocumentDto[];
  isCallerInvited: boolean;
  myBid?: PortalRoundBidDto | null;
};
export type ListPortalNegotiationRoundsResponse = {
  rounds: PortalNegotiationRoundDto[];
};
export type PortalMyBidDto = {
  eventId: string;
  bidId: string;
  status: BidV2Status;
  event: PortalSourcingEventSummaryDto;
};
export type PortalMyBidsResponse = {
  bids: PortalMyBidDto[];
};
export type ContributingEntityDetailListDto = {
  items: ContributingEntityDetailDto[];
};
export type MyParticipationRequestRowDto = {
  request: ParticipationRequestDto;
  eventId: string;
  eventTitle?: string | null;
  buyerOrganizationName?: string | null;
  requestDeadline?: string | null;
};
export type MyParticipationRequestsDto = {
  rows?: MyParticipationRequestRowDto[];
};
export type ParticipationRequestPatchDto = {
  espdResponse?: EspdResponseDto;
  qualificationResponses?: ParticipationQualificationResponseDto[];
};
export type CreateProductDto = {
  id?: string | null;
  quantity: NumberFieldDto;
  productFields: ProductFieldDto[];
};
export type AddProductDto = {
  product: CreateProductDto;
};
export type AddProductCommentDto = {
  comment: string;
};
export type EditProductDto = {
  id: string;
  quantity?: NumberFieldDto | null;
  productFields?: ProductFieldDto[] | null;
  comment?: AddProductCommentDto | null;
};
export type DeleteProductDto = {
  productId: string;
};
export type EditProductGroupDto = {
  id: string;
  addProduct?: AddProductDto | null;
  editProduct?: EditProductDto | null;
  upsertProducts?: ProductDto[] | null;
  deleteProduct?: DeleteProductDto | null;
};
export type CreateProductGroupDto = {
  sourcingEventId?: string | null;
  projectId?: string | null;
  name: string;
  originProductGroupId?: string | null;
  productFields: ProductTemplateFieldDto[];
  products: CreateProductDto[];
};
export type ProductTemplateDto = {
  id: string;
  name: string;
  createdAt: string;
  modifiedAt: string;
  productFields: ProductTemplateFieldDto[];
};
export type ProductTemplatesDto = {
  templates: ProductTemplateDto[];
};
export type CreateProjectRequest = {
  id?: string | null;
  homeDepartmentId?: string | null;
  externalId?: string | null;
  name: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  parent?: string | null;
  projectResponsible?: string | null;
  sourcingResponsible?: string | null;
  projectType?: string | null;
  documents?: string[] | null;
};
export type CreateProjectTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  projectId: string;
};
export type ProjectPatchDto = {
  externalId?: string | null;
  name?: string;
  description?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  parentId?: string | null;
  projectResponsibleId?: string | null;
  sourcingResponsibleId?: string | null;
  projectTypeId?: string | null;
  documents?: ProjectDocumentDto[];
  descriptionDocuments?: ProjectDocumentDto[];
};
export type ProjectsDto = {
  projects: ProjectDto[];
};
export type ScimMember = {
  value: string;
  display?: string | null;
};
export type GroupDto = {
  id: string;
  displayName: string;
  schemas: string[];
  members?: ScimMember[] | null;
};
export type GroupsDto = {
  Resources: GroupDto[];
  totalResults: number;
  schemas: string[];
};
export type MetaDto = {
  resourceType: string;
  location?: string | null;
};
export type CreateGroupDto = {
  schemas: string[];
  externalId?: string | null;
  displayName: string;
  members?: ScimMember[] | null;
  meta?: MetaDto | null;
};
export type OperationValueObject = {
  userName?: string | null;
  givenName?: string | null;
  familyName?: string | null;
  title?: string | null;
  active?: boolean | null;
  displayName?: string | null;
  members?: ScimMember[] | null;
  roles?: string | null;
};
export type ObjectPatchOperation = {
  op: PatchOperationType;
  value: OperationValueObject;
};
export type StringPatchOperation = {
  op: PatchOperationType;
  path: string;
  value: string;
};
export type BooleanPatchOperation = {
  op: PatchOperationType;
  path: string;
  value: boolean;
};
export type ListPatchOperationValue = {
  value: string;
};
export type ListPatchOperation = {
  op: PatchOperationType;
  path: string;
  value: ListPatchOperationValue[];
};
export type UpdateGroupRequest = {
  schemas: string[];
  Operations: (
    | ObjectPatchOperation
    | StringPatchOperation
    | BooleanPatchOperation
    | ListPatchOperation
  )[];
};
export type SchemaSubAttributeDto = {
  type: SchemaAttributeType;
  name: string;
  description: string;
  required: boolean;
  caseExact: boolean;
  mutability: SchemaAttributeMutability;
  returned: string;
  uniqueness: SchemaAttributeUniqueness;
  referenceTypes?: ScimResourceType[] | null;
  canonicalValues?: ScimResourceType[] | null;
  multiValued: boolean;
};
export type SchemaAttributeDto = {
  type: SchemaAttributeType;
  name: string;
  multiValued: boolean;
  description: string;
  required: boolean;
  subAttributes?: SchemaSubAttributeDto[] | null;
  caseExact: boolean;
  mutability: SchemaAttributeMutability;
  returned: string;
  uniqueness: SchemaAttributeUniqueness;
};
export type SchemaDto = {
  schemas: string[];
  id: string;
  name: string;
  description: string;
  attributes: SchemaAttributeDto[];
  meta: MetaDto;
};
export type SchemasDto = {
  schemas: string[];
  itemsPerPage: number;
  startIndex: number;
  totalResults: number;
  Resources: SchemaDto[];
};
export type TokenResponse = {
  token: string;
};
export type NameDto = {
  givenName?: string | null;
  familyName?: string | null;
};
export type RoleResponse = {
  value: string;
};
export type UserDto = {
  id: string;
  userName: string;
  name: NameDto;
  title?: string | null;
  roles: RoleResponse[];
  schemas: string[];
  active?: boolean;
};
export type UsersDto = {
  Resources: UserDto[];
  totalResults: number;
  schemas: string[];
};
export type RoleValueContent = {
  id?: string | null;
  value?: string | null;
  displayName?: string | null;
};
export type CreateUserDto = {
  userName: string;
  name?: NameDto | null;
  title?: string | null;
  roles?: RoleValueContent[] | null;
  active?: boolean | null;
};
export type SearchOrganizationsAndEntriesResponse = {
  organizations: MinimalOrgDto[];
  count: number;
};
export type UpdateSignedDocumentMetaRequest = {
  tags: string[];
};
export type TemplateOwnerDto = {
  global: boolean;
  organizationId?: string | null;
};
export type TemplateContentDto = {
  minimumRequirements?: MinimumRequirementDto[];
  selectionCriteria?: SelectionCriterionDto[];
  awardCriteria?: AwardCriteriaDto | null;
  priceModel?: PriceModelDto | null;
};
export type SourcingEventTemplateDto = {
  id: string;
  owner: TemplateOwnerDto;
  name: string;
  category?: string | null;
  description?: string | null;
  content: TemplateContentDto;
  createdAt: string;
  modifiedAt: string;
};
export type SourcingEventTemplatesDto = {
  templates: SourcingEventTemplateDto[];
};
export type CreateSourcingEventTemplateRequest = {
  name: string;
  category?: string | null;
  description?: string | null;
  content?: TemplateContentDto;
  global?: boolean;
};
export type UpdateSourcingEventTemplateRequest = {
  id: string;
  name: string;
  category?: string | null;
  description?: string | null;
  content?: TemplateContentDto;
};
export type CreateSourcingEventV2TextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  eventId: string;
};
export type CreateSourcingEventTextDocumentRequest = {
  name: string;
  text: string;
  tags: string[];
  sourcingEventId: string;
};
export type BseSupplierViewAwardedFieldsDto = {
  awardedAt: string;
  iamWinningDepartment: boolean;
  message?: string | null;
};
export type SupplierNegotiationRoundDto = {
  id: string;
  roundNumber: number;
  deadline: string;
  description?: string | null;
  documents: ViewSharedDocumentDto[];
  descriptionDocuments: ViewSharedDocumentDto[];
  isFinalRound?: boolean | null;
  createdAt: string;
  modifiedAt: string;
  bidId?: string | null;
  status: BseBidStatusDto;
  questions: BseQuestionDto[];
  canAskQuestions: boolean;
  hasRegisteredViewing: boolean;
};
export type SourcingEventSupplierView = {
  id: string;
  status: BseBidStatusDto;
  stateName: BseStatusDto;
  publishedAt: string;
  modifiedAt: string;
  contactPerson: PersonDto;
  owningOrganization: OrgPublicProfileDto;
  title: string;
  documents: ViewSharedDocumentDto[];
  descriptionDocuments: ViewSharedDocumentDto[];
  description: string;
  deadline: string;
  createdBidId?: string | null;
  invitationAccepted: boolean;
  awardedFieldsDto?: BseSupplierViewAwardedFieldsDto | null;
  questions: BseQuestionDto[];
  announcements: BseAnnouncementDto[];
  canDeliverBid: boolean;
  hasRegisteredViewing: boolean;
  canAskQuestions: boolean;
  negotiationRounds?: SupplierNegotiationRoundDto[] | null;
};
export type BseBidDraftFieldsDto = {
  comment?: string | null;
  products?: ProductGroupBidDto[] | null;
};
export type BseBidDeliveredFieldsDto = {
  comment: string;
  products?: ProductGroupBidDto[] | null;
  deliveredAt: string;
  deliveredBy: PersonDto;
  winningBid?: boolean | null;
};
export type BidViewForSupplierDto = {
  id: string;
  status: BseBidStatusDto;
  owningOrganization: OrgPitchDto;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  forEvent: SourcingEventSupplierView;
  forNegotiationRound?: string | null;
  documents: ViewDocumentAsOwnerDto[];
  commentDocuments: ViewDocumentAsOwnerDto[];
  uploads: UploadDto[];
  draftFields?: BseBidDraftFieldsDto | null;
  deliveredFields?: BseBidDeliveredFieldsDto | null;
  canEdit: boolean;
  termsToAccept?: string | null;
  termsAccepted: boolean;
  uniqueForBseBidDto?: boolean;
};
export type EditComment = {
  value?: string | null;
};
export type RemoveDocument = {
  value: string;
};
export type EditProducts = {
  products: ProductGroupBidDto[];
};
export type EditBidRequest = {
  comment?: EditComment | null;
  removeDocument?: RemoveDocument | null;
  editProducts?: EditProducts | null;
};
export type CreateBseAnnouncementRequest = {
  title: string;
  content: string;
};
export type GetProcurementProtocolRequest = {
  descriptionHtml: string;
};
export type CreateDraftBidRequest = {
  sourcingEventId: string;
  organizationId: string;
  negotiationRoundId?: string | null;
};
export type SourcingEventListItemForSupplier = {
  id: string;
  title: string;
  status: BseBidStatusDto;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  deadline: string;
  owningOrganizationName: string;
  contactPerson: PersonDto;
  timezone: string;
  negotiationRound?: number | null;
  negotiationRoundId?: string | null;
};
export type BidListItemForSupplierDto = {
  id: string;
  status: BseBidStatusDto;
  owningOrganization: OrgPitchDto;
  createdAt: string;
  modifiedAt: string;
  createdBy: PersonDto;
  forEvent: SourcingEventListItemForSupplier;
  forNegotiationRound?: number | null;
  forNegotiationRoundId?: string | null;
  winningBid?: boolean | null;
  canEdit: boolean;
  uniqueForBidDto?: boolean;
};
export type ListBidsResponse = {
  bids: BidListItemForSupplierDto[];
};
export type SeEmailInviteDto = {
  id: string;
  sentAt: string;
  sentByPersonFirstName?: string | null;
  sentByPersonLastName?: string | null;
  owningOrganizationName: string;
  eventTitle: string;
  eventDeadline?: string | null;
};
export type DeliverBidRequest = {
  eventId: string;
  bidId: string;
  negotiationRoundId?: string | null;
  acceptTerms?: boolean;
};
export type ListSeSupplierViewsResponse = {
  uniqueForListSourcingEventsAsSupplierResponse?: boolean;
  events: SourcingEventListItemForSupplier[];
};
export type SupplierProductDto = {
  id: string;
  quantity: NumberFieldDto;
  productFields: ProductFieldDto[];
};
export type SupplierProductGroupDto = {
  id: string;
  sourcingEventId: string;
  name: string;
  productFields: ProductTemplateFieldDto[];
  products: SupplierProductDto[];
};
export type SupplierProductGroupsDto = {
  productGroups: SupplierProductGroupDto[];
};
export type CreateBidV2AwardCriterionAttachmentUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  criterionId: string;
};
export type CreateBidV2MinimumRequirementAttachmentUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  minimumRequirementId: string;
};
export type CreateBidV2QualificationEvidenceUploadRequestDto = {
  fileName: string;
  fileSize: number;
  fileExtension: string;
  mimeType: string;
  criterionKey: string;
};
export type UpdateTextDocumentRequest = {
  id: string;
  name?: string | null;
  text?: string | null;
  tags?: string[] | null;
  removeEmbeddedDocument?: string | null;
};
export type UploadStatusDto = {
  status: UploadStatusValueDto;
};
export enum AdminEntityType {
  Bid = "Bid",
  Contract = "Contract",
  Document = "Document",
  EmailInvite = "EmailInvite",
  EmailOutboxItem = "EmailOutboxItem",
  Organization = "Organization",
  Person = "Person",
  SourcingEvent = "SourcingEvent",
  Upload = "Upload",
}
export enum MigrationDocumentType {
  Regular = "Regular",
  Signed = "Signed",
}
export enum OrganizationSize {
  OneToTen = "ONE_TO_TEN",
  TenToFifty = "TEN_TO_FIFTY",
  FiftyToTwoHundredAndFifty = "FIFTY_TO_TWO_HUNDRED_AND_FIFTY",
  TwoHundredAndFiftyToThousand = "TWO_HUNDRED_AND_FIFTY_TO_THOUSAND",
  ThousandToTenThousand = "THOUSAND_TO_TEN_THOUSAND",
  TenThousandPlus = "TEN_THOUSAND_PLUS",
}
export enum AvailabilityReasonCodeDto {
  MissingCapability = "MissingCapability",
  ScopeNotCovered = "ScopeNotCovered",
  CreatedOnlyRestriction = "CreatedOnlyRestriction",
  GrantResolutionFailed = "GrantResolutionFailed",
}
export enum ReasonKindDto {
  Authority = "authority",
  State = "state",
}
export enum OrgUserInviteRole {
  Admin = "Admin",
  SourcingCreator = "SourcingCreator",
  SourcingViewer = "SourcingViewer",
  ContractCreator = "ContractCreator",
  ContractViewer = "ContractViewer",
  ProjectViewer = "ProjectViewer",
  ProjectCreator = "ProjectCreator",
}
export enum BuyerLegalType {
  PublicLawBody = "PUBLIC_LAW_BODY",
  PublicLawBodyCentral = "PUBLIC_LAW_BODY_CENTRAL",
  CentralGovernment = "CENTRAL_GOVERNMENT",
  DefenceContractor = "DEFENCE_CONTRACTOR",
  EuInstitution = "EU_INSTITUTION",
  EuInternationalOrg = "EU_INTERNATIONAL_ORG",
  GroupOfPublicAuthorities = "GROUP_OF_PUBLIC_AUTHORITIES",
  InternationalOrg = "INTERNATIONAL_ORG",
  Municipality = "MUNICIPALITY",
  OrganisationPart = "ORGANISATION_PART",
  OrganisationPartCentral = "ORGANISATION_PART_CENTRAL",
  PublicUndertaking = "PUBLIC_UNDERTAKING",
  PublicUndertakingCentral = "PUBLIC_UNDERTAKING_CENTRAL",
  County = "COUNTY",
  RegionalOrLocal = "REGIONAL_OR_LOCAL",
  SpecialRightsEntity = "SPECIAL_RIGHTS_ENTITY",
  Private = "PRIVATE",
}
export enum Regulation {
  Foa = "FOA",
  Forsyningsforskriften = "FORSYNINGSFORSKRIFTEN",
  Konsesjonskontraktforskriften = "KONSESJONSKONTRAKTFORSKRIFTEN",
}
export enum OrganizationRoleType {
  Owner = "Owner",
  Admin = "Admin",
  SourcingCreator = "SourcingCreator",
  SourcingViewer = "SourcingViewer",
  ContractCreator = "ContractCreator",
  ContractViewer = "ContractViewer",
  ProjectViewer = "ProjectViewer",
  ProjectCreator = "ProjectCreator",
}
export enum LeadTimeUnit {
  Days = "Days",
  Months = "Months",
}
export enum ContractRole {
  InternalOwner = "InternalOwner",
  CounterParty = "CounterParty",
  InvitedParty = "InvitedParty",
}
export enum IntervalUnit {
  Days = "Days",
  Months = "Months",
}
export enum ContractTaskRole {
  Responsible = "Responsible",
}
export enum SourcingEventRole {
  Publisher = "Publisher",
  InvitedSupplier = "InvitedSupplier",
}
export enum OrganizationType {
  Organization = "Organization",
  OrganizationEntry = "OrganizationEntry",
}
export enum GPTRole {
  System = "system",
  Assistant = "assistant",
  User = "user",
  Function = "function",
  Tool = "tool",
}
export enum AiModelDto {
  Gpt52 = "Gpt52",
  Gpt5 = "Gpt5",
  Gpt5Mini = "Gpt5Mini",
  Gpt5Nano = "Gpt5Nano",
}
export enum ContractDataFieldType {
  Date = "Date",
  Financial = "Financial",
  Commercial = "Commercial",
  TermsAndConditions = "TermsAndConditions",
  Other = "Other",
}
export enum ContractDataFieldNameDto {
  StartDate = "StartDate",
  EndDate = "EndDate",
  AwardDate = "AwardDate",
  WarrantyExpirationDate = "WarrantyExpirationDate",
  RenewalDate = "RenewalDate",
  CounterpartyContactPerson = "CounterpartyContactPerson",
  DeliveryTerms = "DeliveryTerms",
  EstimatedValue = "EstimatedValue",
  ExternalLink = "ExternalLink",
  InternalReferenceNumber = "InternalReferenceNumber",
  LinkedContracts = "LinkedContracts",
  OriginSourcingEvent = "OriginSourcingEvent",
  PaymentTermsInDays = "PaymentTermsInDays",
  PricePerMonth = "PricePerMonth",
  PricePerYear = "PricePerYear",
  Priority = "Priority",
  PurchasingPolicy = "PurchasingPolicy",
  Risk = "Risk",
  TotalLiability = "TotalLiability",
  TotalPrice = "TotalPrice",
  TerminationDate = "TerminationDate",
  IfrsValues = "IfrsValues",
  SupplierInfo = "SupplierInfo",
  InternalParties = "InternalParties",
  SupplierCategory = "SupplierCategory",
  NoticePeriod = "NoticePeriod",
  Options = "Options",
  Projects = "Projects",
}
export enum AgentAuditOutcome {
  Proposed = "PROPOSED",
  Confirmed = "CONFIRMED",
  Rejected = "REJECTED",
  Executed = "EXECUTED",
  Failed = "FAILED",
}
export enum AgentDocumentScopeTypeDto {
  Contract = "CONTRACT",
  SourcingEventV1 = "SOURCING_EVENT_V1",
  SourcingEventV2 = "SOURCING_EVENT_V2",
  SourcingEventV2Bids = "SOURCING_EVENT_V2_BIDS",
}
export enum BseStatusDto {
  Draft = "Draft",
  Published = "Published",
  DeadlineHasPassed = "DeadlineHasPassed",
  Completed = "Completed",
  Awarded = "Awarded",
  Cancelled = "Cancelled",
  Closed = "Closed",
}
export enum BseStateNameDto {
  Draft = "Draft",
  Published = "Published",
  Completed = "Completed",
  Awarded = "Awarded",
  Cancelled = "Cancelled",
  Closed = "Closed",
}
export enum OrganizationInviteStatus {
  IsWinner = "IsWinner",
  IsLoser = "IsLoser",
  BidWasNotNotSubmitted = "BidWasNotNotSubmitted",
  BidIsSubmitted = "BidIsSubmitted",
  InvitationAccepted = "InvitationAccepted",
  DraftCreated = "DraftCreated",
  InvitationDeclined = "InvitationDeclined",
  HasSeenEvent = "HasSeenEvent",
  InvitationSent = "InvitationSent",
}
export enum EmailInviteLanguage {
  En = "En",
  No = "No",
}
export enum EmailInviteStatusDto {
  Sent = "Sent",
  Opened = "Opened",
  SendingFailed = "SendingFailed",
}
export enum FencyContentStatus {
  Empty = "EMPTY",
  Synchronizing = "SYNCHRONIZING",
  Synchronized = "SYNCHRONIZED",
  SynchronizationError = "SYNCHRONIZATION_ERROR",
}
export enum DocumentCategory {
  CompetitionBasis = "COMPETITION_BASIS",
  PriceSheet = "PRICE_SHEET",
  RequirementsSpec = "REQUIREMENTS_SPEC",
  Contract = "CONTRACT",
  Other = "OTHER",
}
export enum Currency {
  Nok = "NOK",
  Usd = "USD",
  Eur = "EUR",
  Dkk = "DKK",
}
export enum BseQuestionStatus {
  Unresolved = "Unresolved",
  Resolved = "Resolved",
}
export enum ProjectStatus {
  NotStarted = "NotStarted",
  Ongoing = "Ongoing",
  Ended = "Ended",
}
export enum ProjectTypeName {
  BidCalculation = "BidCalculation",
  Other = "Other",
}
export enum NegotiationStateName {
  Draft = "Draft",
  Published = "Published",
  Completed = "Completed",
}
export enum NegotiationRoundStatusDto {
  Draft = "Draft",
  Published = "Published",
  DeadlineHasPassed = "DeadlineHasPassed",
  Completed = "Completed",
}
export enum Populater {
  Buyer = "Buyer",
  Supplier = "Supplier",
}
export enum ContactSubjectType {
  RegisteredOrganization = "RegisteredOrganization",
  OrganizationEntry = "OrganizationEntry",
}
export enum EspdCriterionCategory {
  ExclusionConvictions = "EXCLUSION_CONVICTIONS",
  ExclusionContributions = "EXCLUSION_CONTRIBUTIONS",
  ExclusionSocial = "EXCLUSION_SOCIAL",
  ExclusionBusiness = "EXCLUSION_BUSINESS",
  ExclusionMisconduct = "EXCLUSION_MISCONDUCT",
  ExclusionConflict = "EXCLUSION_CONFLICT",
  ExclusionNational = "EXCLUSION_NATIONAL",
  SelectionSuitability = "SELECTION_SUITABILITY",
  SelectionEconomic = "SELECTION_ECONOMIC",
  SelectionTechnical = "SELECTION_TECHNICAL",
  SelectionQuality = "SELECTION_QUALITY",
  OtherEoData = "OTHER_EO_DATA",
}
export enum SourcingEventStatus {
  Draft = "DRAFT",
  PublicationPending = "PUBLICATION_PENDING",
  Published = "PUBLISHED",
  PublicationFailed = "PUBLICATION_FAILED",
  Evaluation = "EVALUATION",
  Evaluated = "EVALUATED",
  AwardDecision = "AWARD_DECISION",
  Awarded = "AWARDED",
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Completed = "COMPLETED",
}
export enum ContractDurationType {
  FixedDates = "FIXED_DATES",
  PeriodBased = "PERIOD_BASED",
  OpenEnded = "OPEN_ENDED",
}
export enum AwardCriterionType {
  Price = "PRICE",
  Cost = "COST",
  Quality = "QUALITY",
  QualityEnvironmentalCriteria = "QUALITY_ENVIRONMENTAL_CRITERIA",
  QualityEnvironmentalSpecification = "QUALITY_ENVIRONMENTAL_SPECIFICATION",
  QualityEnvironmentalExemptInsignificant = "QUALITY_ENVIRONMENTAL_EXEMPT_INSIGNIFICANT",
  QualityEnvironmentalExemptCriticalInterest = "QUALITY_ENVIRONMENTAL_EXEMPT_CRITICAL_INTEREST",
  QualityEnvironmentalExemptNationalMinimum = "QUALITY_ENVIRONMENTAL_EXEMPT_NATIONAL_MINIMUM",
}
export enum WeightType {
  Percentage = "PERCENTAGE",
  Decimal = "DECIMAL",
  PointsOfRange = "POINTS_OF_RANGE",
  OrderOfImportance = "ORDER_OF_IMPORTANCE",
}
export enum AwardSubCriterionAnswerFormat {
  FreeText = "FREE_TEXT",
  Document = "DOCUMENT",
  Number = "NUMBER",
  YesNoPartial = "YES_NO_PARTIAL",
}
export enum SelectionCriterionType {
  EconomicFinancial = "ECONOMIC_FINANCIAL",
  TechnicalProfessional = "TECHNICAL_PROFESSIONAL",
  Suitability = "SUITABILITY",
  QualityEnvironment = "QUALITY_ENVIRONMENT",
  Other = "OTHER",
}
export enum MinimumRequirementResponseType {
  YesNo = "YES_NO",
  YesNoComment = "YES_NO_COMMENT",
  YesNoDocument = "YES_NO_DOCUMENT",
}
export enum OrganizationInviteStatusV2Dto {
  Invited = "INVITED",
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
}
export enum ContractNature {
  Works = "WORKS",
  Supplies = "SUPPLIES",
  Services = "SERVICES",
  Combined = "COMBINED",
}
export enum ProcedureType {
  Open = "OPEN",
  Restricted = "RESTRICTED",
  NegotiatedWithPriorCall = "NEGOTIATED_WITH_PRIOR_CALL",
  NegotiatedWithoutPriorCall = "NEGOTIATED_WITHOUT_PRIOR_CALL",
  CompetitiveDialogue = "COMPETITIVE_DIALOGUE",
  InnovationPartnership = "INNOVATION_PARTNERSHIP",
  CompetitiveNegotiation = "COMPETITIVE_NEGOTIATION",
  OtherSingleStage = "OTHER_SINGLE_STAGE",
  DynamicPurchasingSystem = "DYNAMIC_PURCHASING_SYSTEM",
  DpsCompetition = "DPS_COMPETITION",
  QualificationScheme = "QUALIFICATION_SCHEME",
}
export enum UtilityActivity {
  Airport = "AIRPORT",
  Electricity = "ELECTRICITY",
  GasHeat = "GAS_HEAT",
  GasOil = "GAS_OIL",
  Port = "PORT",
  Post = "POST",
  Rail = "RAIL",
  SolidFuel = "SOLID_FUEL",
  UrbanTransport = "URBAN_TRANSPORT",
  Water = "WATER",
}
export enum FoaPart {
  OutsideFoa = "OUTSIDE_FOA",
  PartI = "PART_I",
  PartIi = "PART_II",
  PartIii = "PART_III",
  PartIv = "PART_IV",
}
export enum FrameworkAgreementType {
  None = "NONE",
  WithReopening = "WITH_REOPENING",
  WithoutReopening = "WITHOUT_REOPENING",
  Mixed = "MIXED",
}
export enum DynamicPurchasingSystemType {
  None = "NONE",
  OnlyListedBuyers = "ONLY_LISTED_BUYERS",
  AlsoUnlistedBuyers = "ALSO_UNLISTED_BUYERS",
}
export enum ReservedParticipationType {
  None = "NONE",
  ShelteredWorkshop = "SHELTERED_WORKSHOP",
  PublicServiceMission = "PUBLIC_SERVICE_MISSION",
}
export enum ReservedExecutionType {
  None = "NONE",
  ShelteredEmployment = "SHELTERED_EMPLOYMENT",
  NotKnown = "NOT_KNOWN",
}
export enum PublicationChannel {
  Doffin = "DOFFIN",
  Ted = "TED",
}
export enum EFormType {
  Cn16 = "CN_16",
  Can29 = "CAN_29",
  Pin7 = "PIN_7",
}
export enum PublicationStatus {
  Pending = "PENDING",
  Published = "PUBLISHED",
  Failed = "FAILED",
}
export enum QualificationRoundStatus {
  Open = "OPEN",
  Completed = "COMPLETED",
}
export enum NegotiatedProcedureGround {
  NeedsAdaptationOfAvailableSolutions = "NEEDS_ADAPTATION_OF_AVAILABLE_SOLUTIONS",
  DesignOrInnovation = "DESIGN_OR_INNOVATION",
  NatureComplexityLegalOrFinancialCircumstances = "NATURE_COMPLEXITY_LEGAL_OR_FINANCIAL_CIRCUMSTANCES",
  SpecificationsCannotBeEstablishedPrecisely = "SPECIFICATIONS_CANNOT_BE_ESTABLISHED_PRECISELY",
}
export enum CompetitionStageDto {
  RequestsOpen = "REQUESTS_OPEN",
  Qualification = "QUALIFICATION",
  Tendering = "TENDERING",
}
export enum EventRevisionState {
  Draft = "Draft",
  PublicationPending = "PublicationPending",
  Published = "Published",
  Failed = "Failed",
  Canceled = "Canceled",
}
export enum ChangeReasonCode {
  UpdateAdd = "UPDATE_ADD",
  CorrectionBuyer = "CORRECTION_BUYER",
}
export enum ChangedArea {
  Title = "TITLE",
  Deadline = "DEADLINE",
  Description = "DESCRIPTION",
  Documents = "DOCUMENTS",
  ReferenceId = "REFERENCE_ID",
  AwardCriteria = "AWARD_CRITERIA",
  MinimumRequirements = "MINIMUM_REQUIREMENTS",
  PriceModel = "PRICE_MODEL",
  ContractTerms = "CONTRACT_TERMS",
  Products = "PRODUCTS",
  DpsValidity = "DPS_VALIDITY",
  Invitations = "INVITATIONS",
}
export enum AwardLetterTypeDto {
  Winner = "WINNER",
  Rejection = "REJECTION",
}
export enum AwardLetterStatusDto {
  Draft = "DRAFT",
  Approved = "APPROVED",
  Sent = "SENT",
}
export enum SeV2QuestionKind {
  Question = "QUESTION",
  Clarification = "CLARIFICATION",
}
export enum SeV2QuestionStatus {
  Unanswered = "UNANSWERED",
  Answered = "ANSWERED",
  Published = "PUBLISHED",
}
export enum SeV2AttachmentSource {
  Request = "REQUEST",
  Offer = "OFFER",
  Upload = "UPLOAD",
}
export enum EvaluationModelDto {
  Criteria = "CRITERIA",
  Price = "PRICE",
}
export enum AwardMethodDto {
  LowestPrice = "LOWEST_PRICE",
  BestPriceQualityRatio = "BEST_PRICE_QUALITY_RATIO",
}
export enum BidV2Status {
  Draft = "DRAFT",
  Submitted = "SUBMITTED",
  Awarded = "AWARDED",
  Rejected = "REJECTED",
}
export enum AwardCriterionAnswerChoice {
  Yes = "YES",
  No = "NO",
  Partial = "PARTIAL",
}
export enum MinimumRequirementOutcome {
  Fulfilled = "FULFILLED",
  NotFulfilled = "NOT_FULFILLED",
  Pending = "PENDING",
}
export enum NegotiationRoundStatus {
  Draft = "DRAFT",
  Published = "PUBLISHED",
  Completed = "COMPLETED",
}
export enum ParticipationRequestStatus {
  Draft = "DRAFT",
  Submitted = "SUBMITTED",
  Qualified = "QUALIFIED",
  Rejected = "REJECTED",
  Withdrawn = "WITHDRAWN",
  Removed = "REMOVED",
}
export enum BuyerBidV2EspdAnswerDto {
  Ok = "OK",
  Deviation = "DEVIATION",
  Unanswered = "UNANSWERED",
}
export enum EspdResponseDataType {
  Indicator = "INDICATOR",
  Date = "DATE",
  Description = "DESCRIPTION",
  Amount = "AMOUNT",
  Code = "CODE",
  CodeCountry = "CODE_COUNTRY",
  Percentage = "PERCENTAGE",
  Period = "PERIOD",
  QuantityInteger = "QUANTITY_INTEGER",
  QuantityYear = "QUANTITY_YEAR",
  Quantity = "QUANTITY",
  EvidenceUrl = "EVIDENCE_URL",
}
export enum ContractStateDto {
  Draft = "Draft",
  Published = "Published",
}
export enum BidV2StatusTransitionTypeDto {
  Submitted = "SUBMITTED",
  Withdrawn = "WITHDRAWN",
  Awarded = "AWARDED",
  Rejected = "REJECTED",
  AwardRevoked = "AWARD_REVOKED",
  RejectionRevoked = "REJECTION_REVOKED",
}
export enum ContractStatusDto {
  Awarded = "Awarded",
  Active = "Active",
  Expired = "Expired",
  Terminated = "Terminated",
}
export enum CommonTemplateType {
  ExpirationDate = "ExpirationDate",
}
export enum ContractPriority {
  VeryLow = "VeryLow",
  BelowAverage = "BelowAverage",
  Average = "Average",
  AboveAverage = "AboveAverage",
  VeryHigh = "VeryHigh",
}
export enum ContractRisk {
  VeryLow = "VeryLow",
  BelowAverage = "BelowAverage",
  Average = "Average",
  AboveAverage = "AboveAverage",
  VeryHigh = "VeryHigh",
}
export enum IfrsAdjustmentType {
  Monetary = "Monetary",
  Percentage = "Percentage",
}
export enum Category {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}
export enum SignedDocumentStatus {
  Unsigned = "Unsigned",
  WaitingForAttachments = "WaitingForAttachments",
  PartiallySigned = "PartiallySigned",
  Signed = "Signed",
  Canceled = "Canceled",
  Expired = "Expired",
}
export enum DocumentSignerStatusDto {
  DocumentEmailNotOpened = "DocumentEmailNotOpened",
  DocumentEmailOpened = "DocumentEmailOpened",
  DocumentLinkOpened = "DocumentLinkOpened",
  DocumentRead = "DocumentRead",
  DocumentSigned = "DocumentSigned",
  EmailSendingFailed = "EmailSendingFailed",
}
export enum ContractNotificationTypeDto {
  EndDateReminder = "EndDateReminder",
  RenewalDateReminder = "RenewalDateReminder",
  WarrantyExpirationDateReminder = "WarrantyExpirationDateReminder",
  StartDateReminder = "StartDateReminder",
  TerminationDateReminder = "TerminationDateReminder",
  NoticePeriodReminder = "NoticePeriodReminder",
  OptionExecutionDeadlineReminder = "OptionExecutionDeadlineReminder",
  OptionStartDateReminder = "OptionStartDateReminder",
  NoEndDateReminder = "NoEndDateReminder",
}
export enum ContractNotificationDurationType {
  Days = "Days",
  Months = "Months",
}
export enum FieldKeys {
  ClassificationConfirmed = "ClassificationConfirmed",
  TitlePresent = "TitlePresent",
  HomeDepartmentPresent = "HomeDepartmentPresent",
  DescriptionPresent = "DescriptionPresent",
  BidSubmissionDeadlinePresent = "BidSubmissionDeadlinePresent",
  BidSubmissionDeadlineInFuture = "BidSubmissionDeadlineInFuture",
  BidSubmissionDeadlinePassed = "BidSubmissionDeadlinePassed",
  BidSubmissionDeadlineAboveMinimum = "BidSubmissionDeadlineAboveMinimum",
  BidSubmissionDeadlineConfirmed = "BidSubmissionDeadlineConfirmed",
  RequestDeadlinePresent = "RequestDeadlinePresent",
  RequestDeadlineAboveMinimum = "RequestDeadlineAboveMinimum",
  RequestDeadlineConfirmed = "RequestDeadlineConfirmed",
  ProcedureSupportedByProfile = "ProcedureSupportedByProfile",
  ProcedureRequiresEeaTier = "ProcedureRequiresEeaTier",
  CandidateMinimumAboveFloor = "CandidateMinimumAboveFloor",
  CandidateMaximumNotBelowMinimum = "CandidateMaximumNotBelowMinimum",
  CandidateSelectionCriteriaPresent = "CandidateSelectionCriteriaPresent",
  ProcedureJustificationPresent = "ProcedureJustificationPresent",
  DpsUsageSet = "DpsUsageSet",
  DpsValidityPresent = "DpsValidityPresent",
  DpsValidityOrdered = "DpsValidityOrdered",
  QualificationSchemeValidityPresent = "QualificationSchemeValidityPresent",
  QualificationSchemeValidityOrdered = "QualificationSchemeValidityOrdered",
  ProcedureRequiresUtilitiesRegulation = "ProcedureRequiresUtilitiesRegulation",
  DpsCompetitionHasMembers = "DpsCompetitionHasMembers",
  AwardCriterionModelSet = "AwardCriterionModelSet",
  AwardCriteriaWeightsValid = "AwardCriteriaWeightsValid",
  AwardSubCriteriaWeightsValid = "AwardSubCriteriaWeightsValid",
  AwardSubCriteriaDescribed = "AwardSubCriteriaDescribed",
  AwardCriteriaDescriptionsPresent = "AwardCriteriaDescriptionsPresent",
  AwardCriteriaPresentWhenIncluded = "AwardCriteriaPresentWhenIncluded",
  MinimumRequirementsPresentWhenIncluded = "MinimumRequirementsPresentWhenIncluded",
  ProductsPresentWhenIncluded = "ProductsPresentWhenIncluded",
  AwardPriceCriterionUnique = "AwardPriceCriterionUnique",
  EnvironmentCriterionWeightingJustified = "EnvironmentCriterionWeightingJustified",
  AtLeastOneInvitation = "AtLeastOneInvitation",
  RegulationSet = "RegulationSet",
  RegulationSupportsPublishing = "RegulationSupportsPublishing",
  ProcedureTypeSet = "ProcedureTypeSet",
  BuyerLegalTypeSet = "BuyerLegalTypeSet",
  UtilityActivitySet = "UtilityActivitySet",
  EstimatedValueSet = "EstimatedValueSet",
  ContractNatureSet = "ContractNatureSet",
  FoaPartSet = "FoaPartSet",
  FoaPartUsesPublicFlow = "FoaPartUsesPublicFlow",
  MainCpvCodeSet = "MainCpvCodeSet",
  MainCpvCodeValid = "MainCpvCodeValid",
  OrganizationCityPresent = "OrganizationCityPresent",
  OrganizationPostCodePresent = "OrganizationPostCodePresent",
  BuyerNutsResolvable = "BuyerNutsResolvable",
  PlaceOfPerformanceNutsResolvable = "PlaceOfPerformanceNutsResolvable",
  SubmissionLanguagesValid = "SubmissionLanguagesValid",
  SelectionCriteriaPresent = "SelectionCriteriaPresent",
  SelectionCriteriaUnique = "SelectionCriteriaUnique",
  EuFundedSet = "EuFundedSet",
  ReservedParticipationSet = "ReservedParticipationSet",
  ReservedExecutionSet = "ReservedExecutionSet",
  FrameworkAgreementSet = "FrameworkAgreementSet",
  FrameworkMaxParticipantsRequiredWhenSet = "FrameworkMaxParticipantsRequiredWhenSet",
  PublicationContactPhonePresent = "PublicationContactPhonePresent",
  DynamicPurchasingSystemSet = "DynamicPurchasingSystemSet",
  ElectronicAuctionSet = "ElectronicAuctionSet",
  GpaCoverageSet = "GpaCoverageSet",
  SubmissionElectronicSet = "SubmissionElectronicSet",
  SubmissionLanguagesSet = "SubmissionLanguagesSet",
  ElectronicCatalogueSet = "ElectronicCatalogueSet",
  ElectronicInvoicingSet = "ElectronicInvoicingSet",
  DocumentsRestrictedSet = "DocumentsRestrictedSet",
  ExclusionGroundsSourceSet = "ExclusionGroundsSourceSet",
  SelectionCriteriaSourceSet = "SelectionCriteriaSourceSet",
  TenderValidityMonthsSet = "TenderValidityMonthsSet",
  ContractDurationTypeSet = "ContractDurationTypeSet",
  OpenEndedStartDatePresent = "OpenEndedStartDatePresent",
  ContractStartBeforeEnd = "ContractStartBeforeEnd",
  MainCpvCodeMatchesReservedParticipation = "MainCpvCodeMatchesReservedParticipation",
  ReservedParticipationDurationWithinThreeYears = "ReservedParticipationDurationWithinThreeYears",
  MainCpvCodeMatchesContractNature = "MainCpvCodeMatchesContractNature",
}
export enum Gate {
  Publish = "PUBLISH",
  CloseSubmissions = "CLOSE_SUBMISSIONS",
  Award = "AWARD",
  ConfirmAward = "CONFIRM_AWARD",
  SignContract = "SIGN_CONTRACT",
}
export enum ProductFieldType {
  Text = "Text",
  Number = "Number",
  Boolean = "Boolean",
}
export enum EventKindDto {
  V1 = "V1",
  V2 = "V2",
}
export enum PublicEventStatusDto {
  Draft = "DRAFT",
  PublicationPending = "PUBLICATION_PENDING",
  Published = "PUBLISHED",
  PublicationFailed = "PUBLICATION_FAILED",
  Evaluation = "EVALUATION",
  Evaluated = "EVALUATED",
  AwardDecision = "AWARD_DECISION",
  Awarded = "AWARDED",
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Completed = "COMPLETED",
}
export enum SourcingEventSortField {
  Title = "TITLE",
  ReferenceNumber = "REFERENCE_NUMBER",
  Deadline = "DEADLINE",
  CreatedAt = "CREATED_AT",
  ModifiedAt = "MODIFIED_AT",
}
export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}
export enum ContractReportSortColumn {
  Id = "ID",
  Title = "TITLE",
  TemplateName = "TEMPLATE_NAME",
  CreatedAt = "CREATED_AT",
  ModifiedAt = "MODIFIED_AT",
  OwningOrganizationName = "OWNING_ORGANIZATION_NAME",
  InternalOwnerName = "INTERNAL_OWNER_NAME",
  CounterpartyName = "COUNTERPARTY_NAME",
  CounterpartyContactFullName = "COUNTERPARTY_CONTACT_FULL_NAME",
  CounterpartyContactEmail = "COUNTERPARTY_CONTACT_EMAIL",
  CounterpartyContactPhoneNumber = "COUNTERPARTY_CONTACT_PHONE_NUMBER",
  Status = "STATUS",
  State = "STATE",
  StartDate = "START_DATE",
  EndDate = "END_DATE",
  TotalPrice = "TOTAL_PRICE",
  EstimatedValue = "ESTIMATED_VALUE",
  Priority = "PRIORITY",
  Risk = "RISK",
  RenewalDate = "RENEWAL_DATE",
  PublishedAt = "PUBLISHED_AT",
  SupplierCategory = "SUPPLIER_CATEGORY",
  ReferenceNumber = "REFERENCE_NUMBER",
  Description = "DESCRIPTION",
  Currency = "CURRENCY",
  OriginSourcingEventName = "ORIGIN_SOURCING_EVENT_NAME",
  PublishedByName = "PUBLISHED_BY_NAME",
  TerminatedByName = "TERMINATED_BY_NAME",
  TerminationReason = "TERMINATION_REASON",
  WarrantyExpirationDate = "WARRANTY_EXPIRATION_DATE",
  NoticePeriod = "NOTICE_PERIOD",
  PaymentTermsInDays = "PAYMENT_TERMS_IN_DAYS",
  PricePerMonth = "PRICE_PER_MONTH",
  PricePerYear = "PRICE_PER_YEAR",
  TotalLiability = "TOTAL_LIABILITY",
  ExternalLink = "EXTERNAL_LINK",
  PurchasingPolicy = "PURCHASING_POLICY",
}
export enum ContractReportOptionParameter {
  ProjectName = "PROJECT_NAME",
  ProjectId = "PROJECT_ID",
  InternalPartyName = "INTERNAL_PARTY_NAME",
  InternalPartyId = "INTERNAL_PARTY_ID",
  LinkedContractTitle = "LINKED_CONTRACT_TITLE",
  LinkedContractId = "LINKED_CONTRACT_ID",
  TemplateName = "TEMPLATE_NAME",
  TemplateId = "TEMPLATE_ID",
  OwningOrganizationName = "OWNING_ORGANIZATION_NAME",
  OwningOrganizationId = "OWNING_ORGANIZATION_ID",
  InternalOwnerName = "INTERNAL_OWNER_NAME",
  InternalOwnerId = "INTERNAL_OWNER_ID",
  CounterpartyName = "COUNTERPARTY_NAME",
  CounterpartyId = "COUNTERPARTY_ID",
  CounterpartyContactFullName = "COUNTERPARTY_CONTACT_FULL_NAME",
  CounterpartyContactEmail = "COUNTERPARTY_CONTACT_EMAIL",
  CounterpartyContactPhoneNumber = "COUNTERPARTY_CONTACT_PHONE_NUMBER",
  Status = "STATUS",
  Risk = "RISK",
  Priority = "PRIORITY",
  SupplierCategory = "SUPPLIER_CATEGORY",
  ReferenceNumber = "REFERENCE_NUMBER",
  Description = "DESCRIPTION",
  Currency = "CURRENCY",
  OriginSourcingEventName = "ORIGIN_SOURCING_EVENT_NAME",
  OriginSourcingEventId = "ORIGIN_SOURCING_EVENT_ID",
  PublishedByName = "PUBLISHED_BY_NAME",
  PublishedById = "PUBLISHED_BY_ID",
  TerminatedByName = "TERMINATED_BY_NAME",
  TerminatedById = "TERMINATED_BY_ID",
  TerminationReason = "TERMINATION_REASON",
  StartDate = "START_DATE",
  EndDate = "END_DATE",
  CreatedAt = "CREATED_AT",
  ModifiedAt = "MODIFIED_AT",
  PublishedAt = "PUBLISHED_AT",
  RenewalDate = "RENEWAL_DATE",
  TerminationDate = "TERMINATION_DATE",
  WarrantyExpirationDate = "WARRANTY_EXPIRATION_DATE",
  NoticePeriod = "NOTICE_PERIOD",
  PaymentTermsInDays = "PAYMENT_TERMS_IN_DAYS",
  PricePerMonth = "PRICE_PER_MONTH",
  PricePerYear = "PRICE_PER_YEAR",
  TotalLiability = "TOTAL_LIABILITY",
  ExternalLink = "EXTERNAL_LINK",
  PurchasingPolicy = "PURCHASING_POLICY",
  DocumentId = "DOCUMENT_ID",
  SignedDocumentId = "SIGNED_DOCUMENT_ID",
  IndustryId = "INDUSTRY_ID",
  IsClimateCommitted = "IS_CLIMATE_COMMITTED",
  HasSignedCodeOfConduct = "HAS_SIGNED_CODE_OF_CONDUCT",
  HasCustomerContact = "HAS_CUSTOMER_CONTACT",
  OptionName = "OPTION_NAME",
}
export enum ContractTaskStatus {
  Open = "Open",
  Completed = "Completed",
}
export enum ContractTaskStatusDto {
  Open = "Open",
  Completed = "Completed",
  Overdue = "Overdue",
}
export enum ContractTaskResponsiblePartyDto {
  Organization = "Organization",
  PersonInOrganization = "PersonInOrganization",
}
export enum ContractTaskChangeType {
  Description = "Description",
  DueDate = "DueDate",
  ResponsibleParty = "ResponsibleParty",
  Status = "Status",
  Title = "Title",
}
export enum ContractMessageSide {
  Owner = "Owner",
  Counterparty = "Counterparty",
}
export enum ContractRoleType {
  Editor = "Editor",
  Viewer = "Viewer",
  Counterparty = "Counterparty",
}
export enum ContributingEntityStatus {
  NotSent = "NOT_SENT",
  InvitationSent = "INVITATION_SENT",
  InvitationAccepted = "INVITATION_ACCEPTED",
  InvitationDeclined = "INVITATION_DECLINED",
  ResponseSubmitted = "RESPONSE_SUBMITTED",
  ResponseNotApproved = "RESPONSE_NOT_APPROVED",
  ResponseValidated = "RESPONSE_VALIDATED",
}
export enum ContributingEntityRole {
  ConsortiumMember = "CONSORTIUM_MEMBER",
  CapacityProvider = "CAPACITY_PROVIDER",
  Subcontractor = "SUBCONTRACTOR",
}
export enum ContributingEntityValidationIssueDto {
  EntityInfoIncomplete = "ENTITY_INFO_INCOMPLETE",
  ExclusionGroundsIncomplete = "EXCLUSION_GROUNDS_INCOMPLETE",
  QualificationAnswerMissing = "QUALIFICATION_ANSWER_MISSING",
  CommitmentMissing = "COMMITMENT_MISSING",
  ExclusionGroundApplies = "EXCLUSION_GROUND_APPLIES",
  FinalDeclarationMissing = "FINAL_DECLARATION_MISSING",
  ResponseNotSubmitted = "RESPONSE_NOT_SUBMITTED",
}
export enum SupplierDeclarationField {
  GroupRole = "GROUP_ROLE",
  GroupName = "GROUP_NAME",
  ParticipantList = "PARTICIPANT_LIST",
}
export enum SkippableGateDto {
  RequestDeadline = "REQUEST_DEADLINE",
  DpsSchemeStart = "DPS_SCHEME_START",
  BidSubmissionDeadline = "BID_SUBMISSION_DEADLINE",
  NegotiationRoundDeadline = "NEGOTIATION_ROUND_DEADLINE",
  Standstill = "STANDSTILL",
}
export enum LibraryElementTypeDto {
  Minimum = "MINIMUM",
  Selection = "SELECTION",
  Award = "AWARD",
  AwardSubCriterion = "AWARD_SUB_CRITERION",
}
export enum NotificationTypeDto {
  ContractTaskCommentAdded = "ContractTaskCommentAdded",
  ContractTaskDelegated = "ContractTaskDelegated",
  ContractTaskDeleted = "ContractTaskDeleted",
  ContractTaskDueDateUpdated = "ContractTaskDueDateUpdated",
  ContractTaskStatusUpdated = "ContractTaskStatusUpdated",
  ContractTaskDueDateReminder = "ContractTaskDueDateReminder",
  ContractSharedWithOrg = "ContractSharedWithOrg",
  ContractSharedWithDepartment = "ContractSharedWithDepartment",
  ContractSharedWithPerson = "ContractSharedWithPerson",
  ContractDocumentCompletedSigning = "ContractDocumentCompletedSigning",
  ContractMessageReceived = "ContractMessageReceived",
  ContractSignatureDeadlineExpired = "ContractSignatureDeadlineExpired",
  ContractDateReminder = "ContractDateReminder",
  SourcingEventOrganizationInvite = "SourcingEventOrganizationInvite",
  NegotiationInvite = "NegotiationInvite",
  SourcingEventAnnouncement = "SourcingEventAnnouncement",
  SourcingEventAwarded = "SourcingEventAwarded",
  SourcingEventNewQuestion = "SourcingEventNewQuestion",
  SourcingEventNewQuestionComment = "SourcingEventNewQuestionComment",
  SourcingEventQuestionStatusUpdated = "SourcingEventQuestionStatusUpdated",
  SourcingEventCancelled = "SourcingEventCancelled",
  SourcingEventClosed = "SourcingEventClosed",
  BidDeliveryDeadline = "BidDeliveryDeadline",
  BidDelivered = "BidDelivered",
  SeV2NewQuestion = "SeV2NewQuestion",
  SeV2QuestionAnswered = "SeV2QuestionAnswered",
  SeV2ClarificationMessageToSupplier = "SeV2ClarificationMessageToSupplier",
  SeV2ClarificationMessageToBuyer = "SeV2ClarificationMessageToBuyer",
  SeV2InformationPublished = "SeV2InformationPublished",
  SeV2AwardLetterDispatched = "SeV2AwardLetterDispatched",
  SeV2AwardDecided = "SeV2AwardDecided",
  SeV2BidRejected = "SeV2BidRejected",
  SeV2InvitedToTender = "SeV2InvitedToTender",
  SeV2OrganizationInvite = "SeV2OrganizationInvite",
  SeV2RequestNotQualified = "SeV2RequestNotQualified",
  SeV2RequestNotSelected = "SeV2RequestNotSelected",
  SeV2DpsAdmitted = "SeV2DpsAdmitted",
  SeV2QualificationSchemeAdmitted = "SeV2QualificationSchemeAdmitted",
  SeV2QualificationSchemeRemoved = "SeV2QualificationSchemeRemoved",
  SeV2DpsRemoved = "SeV2DpsRemoved",
  SeV2AwardDecisionRevoked = "SeV2AwardDecisionRevoked",
  SeV2BidDeadlineReminder = "SeV2BidDeadlineReminder",
  SeV2ResponsibleBuyerChanged = "SeV2ResponsibleBuyerChanged",
  SeV2EventChanged = "SeV2EventChanged",
  SeV2EventCancelled = "SeV2EventCancelled",
  SeV2BidDelivered = "SeV2BidDelivered",
  SeV2RoundPublished = "SeV2RoundPublished",
  SeV2EventClosed = "SeV2EventClosed",
  SeV2DoffinPublished = "SeV2DoffinPublished",
  SeV2DoffinPublicationFailed = "SeV2DoffinPublicationFailed",
}
export enum SeV2BidDeliveryKind {
  First = "FIRST",
  Revised = "REVISED",
  Round = "ROUND",
}
export enum ReceiverRoleDto {
  Supplier = "Supplier",
  Buyer = "Buyer",
}
export enum ContractDateReminderType {
  EndDateReminder = "EndDateReminder",
  WarrantyExpirationDateReminder = "WarrantyExpirationDateReminder",
  RenewalDateReminder = "RenewalDateReminder",
  StartDateReminder = "StartDateReminder",
  TerminationDateReminder = "TerminationDateReminder",
  NoticePeriodReminder = "NoticePeriodReminder",
  OptionExecutionDeadlineReminder = "OptionExecutionDeadlineReminder",
  OptionStartDateReminder = "OptionStartDateReminder",
  NoEndDateReminder = "NoEndDateReminder",
}
export enum EmailInviteTypeDto {
  Supplier = "Supplier",
  SourcingEvent = "SourcingEvent",
  OrgUser = "OrgUser",
  ContributingEntity = "ContributingEntity",
}
export enum ViewableEntityKind {
  SourcingEvent = "SOURCING_EVENT",
  Contract = "CONTRACT",
}
export enum DeadlineSubject {
  SourcingEventV1 = "SOURCING_EVENT_V1",
  SourcingEventV2 = "SOURCING_EVENT_V2",
  Contract = "CONTRACT",
}
export enum DeadlineKind {
  BidSubmission = "BID_SUBMISSION",
  RequestToParticipate = "REQUEST_TO_PARTICIPATE",
  NegotiationRound = "NEGOTIATION_ROUND",
  StandstillExpiry = "STANDSTILL_EXPIRY",
  ContractStart = "CONTRACT_START",
  ContractEnd = "CONTRACT_END",
  ContractRenewal = "CONTRACT_RENEWAL",
  ContractTermination = "CONTRACT_TERMINATION",
  ContractNoticeDeadline = "CONTRACT_NOTICE_DEADLINE",
  ContractWarrantyExpiration = "CONTRACT_WARRANTY_EXPIRATION",
  ContractOptionDeadline = "CONTRACT_OPTION_DEADLINE",
  ContractOptionStart = "CONTRACT_OPTION_START",
}
export enum NeedStatus {
  Draft = "DRAFT",
  Reported = "REPORTED",
  Approved = "APPROVED",
  FrameworkRecommended = "FRAMEWORK_RECOMMENDED",
  ProcurementCreated = "PROCUREMENT_CREATED",
  UnderProcurement = "UNDER_PROCUREMENT",
  UnderCallOff = "UNDER_CALL_OFF",
  Completed = "COMPLETED",
  Rejected = "REJECTED",
  Withdrawn = "WITHDRAWN",
}
export enum NeedPriority {
  High = "HIGH",
  Medium = "MEDIUM",
  Low = "LOW",
}
export enum GrantRole {
  Owner = "Owner",
  Admin = "Admin",
  SourcingCreator = "SourcingCreator",
  SourcingViewer = "SourcingViewer",
  ContractCreator = "ContractCreator",
  ContractViewer = "ContractViewer",
  ProjectCreator = "ProjectCreator",
  ProjectViewer = "ProjectViewer",
  Creator = "Creator",
  Viewer = "Viewer",
}
export enum AccessScopeDto {
  Organization = "Organization",
  Department = "Department",
  Event = "Event",
}
export enum AccessGrantSourceDto {
  Manual = "Manual",
  Entra = "Entra",
  Share = "Share",
}
export enum EntraConnectionStatus {
  Active = "Active",
  Disabled = "Disabled",
}
export enum ContractTaskSortDto {
  DueDate = "DueDate",
  RecentlyChanged = "RecentlyChanged",
}
export enum ContractOwnerContextType {
  Common = "Common",
  OrganizationOwner = "OrganizationOwner",
}
export enum DocumentSignerMethod {
  NoBankId = "NoBankId",
  Handwritten = "Handwritten",
}
export enum PreviousSigningOutcome {
  Canceled = "Canceled",
  Expired = "Expired",
  Failed = "Failed",
}
export enum CancelBidV2SigningOutcome {
  Canceled = "Canceled",
  CompletedInstead = "CompletedInstead",
}
export enum PreflightRequirementDto {
  NotDraft = "NOT_DRAFT",
  SigningInProgress = "SIGNING_IN_PROGRESS",
  DeadlinePassed = "DEADLINE_PASSED",
  SupplierInfoIncomplete = "SUPPLIER_INFO_INCOMPLETE",
  EspdResponseIncomplete = "ESPD_RESPONSE_INCOMPLETE",
  QualificationResponseIncomplete = "QUALIFICATION_RESPONSE_INCOMPLETE",
  MinimumRequirementResponseIncomplete = "MINIMUM_REQUIREMENT_RESPONSE_INCOMPLETE",
  EspdFinalDeclarationIncomplete = "ESPD_FINAL_DECLARATION_INCOMPLETE",
  ContributingEntityMissing = "CONTRIBUTING_ENTITY_MISSING",
  UnsupportedSeparateEspdRequired = "UNSUPPORTED_SEPARATE_ESPD_REQUIRED",
  TermsNotAccepted = "TERMS_NOT_ACCEPTED",
}
export enum PreflightWarningDto {
  PriceMissing = "PRICE_MISSING",
  ProductPricesIncomplete = "PRODUCT_PRICES_INCOMPLETE",
  AwardCriteriaIncomplete = "AWARD_CRITERIA_INCOMPLETE",
  ContributingEntityNotValidated = "CONTRIBUTING_ENTITY_NOT_VALIDATED",
}
export enum PortalLifecycleStatus {
  Open = "OPEN",
  DeadlinePassed = "DEADLINE_PASSED",
  UnderEvaluation = "UNDER_EVALUATION",
  Awarded = "AWARDED",
  Cancelled = "CANCELLED",
  Concluded = "CONCLUDED",
}
export enum PortalEventContextType {
  Public = "PUBLIC",
  Private = "PRIVATE",
}
export enum PortalInviteStatusDto {
  NotInvited = "NOT_INVITED",
  Invited = "INVITED",
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
}
export enum PortalAwardModel {
  LowestPrice = "LOWEST_PRICE",
  BestPriceQualityRatio = "BEST_PRICE_QUALITY_RATIO",
}
export enum PortalPriceModelType {
  Proportional = "PROPORTIONAL",
  Linear = "LINEAR",
  Hybrid = "HYBRID",
}
export enum PortalEventScope {
  All = "ALL",
  ActiveInvitations = "ACTIVE_INVITATIONS",
  InvitationsIncludingExpired = "INVITATIONS_INCLUDING_EXPIRED",
}
export enum PatchOperationType {
  Replace = "Replace",
  Add = "Add",
  Remove = "Remove",
}
export enum SchemaAttributeType {
  String = "string",
  Boolean = "boolean",
  Complex = "complex",
  Reference = "reference",
}
export enum SchemaAttributeMutability {
  ReadWrite = "readWrite",
  ReadOnly = "readOnly",
  Immutable = "immutable",
}
export enum SchemaAttributeUniqueness {
  None = "none",
  Server = "server",
}
export enum ScimResourceType {
  User = "User",
  Group = "Group",
}
export enum BseBidStatusDto {
  InviteNotAccepted = "InviteNotAccepted",
  InviteAccepted = "InviteAccepted",
  InviteDeclined = "InviteDeclined",
  DraftCreated = "DraftCreated",
  BidDelivered = "BidDelivered",
  DeadlinePassedAndBidDelivered = "DeadlinePassedAndBidDelivered",
  DeadlinePassedWithoutBidDelivered = "DeadlinePassedWithoutBidDelivered",
  IsWinner = "IsWinner",
  IsLoser = "IsLoser",
  EventCancelledAndBidDelivered = "EventCancelledAndBidDelivered",
  EventCancelledWithoutBidDelivered = "EventCancelledWithoutBidDelivered",
  EventClosedAndBidDelivered = "EventClosedAndBidDelivered",
  EventClosedWithoutBidDelivered = "EventClosedWithoutBidDelivered",
}
export enum UploadStatusValueDto {
  Processing = "Processing",
  Confirmed = "Confirmed",
  Failed = "Failed",
}
export const {
  useAdminListAllEntitiesQuery,
  useAdminMigrateFencyDocumentsMutation,
  useAdminRestampFencyAccessMutation,
  useAdminMigrateFencyContractMetadataMutation,
  useAdminGetFencyMigrationStatsQuery,
  useAdminListOrganizationsQuery,
  useAdminUpdateOrganizationMutation,
  useAdminChangeOrganizationOwnerMutation,
  useSendAiChatMessageMutation,
  useCreateAiCompletionMutation,
  useCreateAssessmentTemplateMutation,
  useGetAssessmentTemplateQuery,
  useCreateAssessmentMutation,
  useGetAssessmentQuery,
  useGetBaseDataQuery,
  useGetTypesQuery,
  useRecordAgentAuditEntryMutation,
  useListAgentConversationsQuery,
  useCreateAgentConversationMutation,
  useDeleteAgentConversationMutation,
  useGetAgentConversationQuery,
  useUpdateAgentConversationMutation,
  useCreateAgentDocumentSearchSessionMutation,
  useResolveAgentDocumentSourcesMutation,
  useGetAgentModelsQuery,
  usePlanAgentTurnMutation,
  useCreateBasicSourcingEventMutation,
  useGetNegotiationRoundQuery,
  useGetBasicSourcingEventQuery,
  useUpdateBasicSourcingEventMutation,
  useAwardToBidMutation,
  useListReceivedBidsQuery,
  useGetReceivedBseBidQuery,
  useCancelSourcingEventMutation,
  useCloseSourcingEventMutation,
  useCompleteEvaluationMutation,
  useCreateSourcingEventCopyMutation,
  useCreateUploadForSourcingEventDescriptionMutation,
  useCreateEmailInviteReminderMutation,
  useCreateNegotiationRoundMutation,
  useOpenCompletedEventMutation,
  usePublishBasicSourcingEventMutation,
  useCreateBseQuestionAsBuyerMutation,
  useUpdateBseQuestionMutation,
  useCreateBseQuestionCommentAsBuyerMutation,
  useCreateUploadForBseMutation,
  useEvaluateSingleBidWithAiMutation,
  useRemoveContactPersonMutation,
  useListContactPersonsQuery,
  useAddContactPersonMutation,
  useEditContactPersonMutation,
  useGetExclusionGroundsTaxonomyQuery,
  useListSourcingEventsForBuyerQuery,
  useCreateSourcingEventMutation,
  useEvaluateBidsWithAiMutation,
  useGenerateRequirementsWithAiMutation,
  useDeleteSourcingEventMutation,
  useGetSourcingEventQuery,
  useUpdateSourcingEventMutation,
  useCreateUploadForSeV2AnnouncementAttachmentMutation,
  useGetBuyerSeV2AttachmentUploadQuery,
  useAwardSourcingEventMutation,
  useGetAwardLettersQuery,
  useDispatchAwardLettersMutation,
  useUpdateAwardLetterMutation,
  useApproveAwardLetterMutation,
  useReopenAwardLetterMutation,
  useBeginEvaluationMutation,
  useCancelSourcingEventV2Mutation,
  useCreateEventChangeMutation,
  useUpdateEventChangeMutation,
  useCancelEventChangeMutation,
  useSubmitEventChangeMutation,
  useStartSeV2ClarificationMutation,
  useCloseSourcingEventV2Mutation,
  useCompleteSourcingEventV2Mutation,
  useConfirmAwardMutation,
  useConfirmSourcingEventClassificationMutation,
  useCopySourcingEventV2Mutation,
  useGetDpsCompetitionsQuery,
  useCreateDpsCompetitionMutation,
  useAddEmailInviteToPrivateSourcingEventMutation,
  useRemoveEmailInviteFromPrivateSourcingEventMutation,
  useCreateEmailInviteReminderForPrivateSourcingEventMutation,
  useGetEvaluationQuery,
  useUpsertPriceOverrideMutation,
  useSetCriterionRationaleMutation,
  useUpsertCriterionScoreMutation,
  useSetEvaluationSelectionMutation,
  useUpdateSourcingEventValueMutation,
  useSetHomeDepartmentMutation,
  useAddInternalMessageToSeV2Mutation,
  useConfirmInvitationMutation,
  useCreateOrganizationInviteEmailReminderMutation,
  useListNegotiationRoundsV2Query,
  useCreateNegotiationRoundV2Mutation,
  usePatchNegotiationRoundV2Mutation,
  useCompleteNegotiationRoundV2Mutation,
  useAddNegotiationRoundV2InviteMutation,
  useRemoveNegotiationRoundV2InviteMutation,
  useUpdateNegotiationRoundV2InviteMessageMutation,
  useSelectNegotiationRoundV2ProductBidsMutation,
  usePublishNegotiationRoundV2Mutation,
  useReopenNegotiationRoundV2Mutation,
  useCreateUploadForNegotiationRoundV2Mutation,
  useCompleteNegotiationRoundEvaluationMutation,
  useOpenNegotiationRoundMutation,
  usePublishNegotiationRoundMutation,
  useAddOrganizationInviteToPrivateSourcingEventMutation,
  useRemoveOrganizationInviteFromPrivateSourcingEventMutation,
  useListParticipationRequestsForBuyerQuery,
  useGetParticipationRequestForBuyerQuery,
  useExtendDpsAssessmentWindowMutation,
  useUpdateParticipationRequestReviewMutation,
  useGetParticipationRequestRejectionDocumentsQuery,
  useCreateUploadForParticipationRequestRejectionMutation,
  useRemoveFromDpsSchemeMutation,
  useUpdateParticipationRequestNotesMutation,
  useUpdateParticipationRequestSelectionDraftMutation,
  useSetQualificationVerdictMutation,
  useSelectSourcingEventProductBidsMutation,
  useGetProtocolDraftQuery,
  usePatchProtocolNarrativeMutation,
  useFinaliseProtocolMutation,
  useListProtocolVersionsQuery,
  useDownloadProtocolVersionQuery,
  useListBidV2SForEventQuery,
  useGetBidV2ForBuyerQuery,
  useCreateContractFromBidV2Mutation,
  useUpdateBuyerMinimumRequirementReviewMutation,
  useSetBidQualificationMutation,
  useUpdateBuyerQualificationReviewMutation,
  useRejectBidV2Mutation,
  useGetBidV2RejectionDocumentsQuery,
  useCreateUploadForBidV2RejectionMutation,
  useRevokeBidRejectionMutation,
  usePublishDpsCompetitionMutation,
  usePublishPrivateSourcingEventMutation,
  useDownloadSeV2QaReportQuery,
  useGetBuyerSeV2QuestionsQuery,
  useAnswerSeV2QuestionMutation,
  useCreateUploadForSeV2AnswerAttachmentMutation,
  useSendSeV2ClarificationMessageAsBuyerMutation,
  useGetSourcingEventReadinessQuery,
  useReopenCompletedSourcingEventV2Mutation,
  useSetResponsiblePersonMutation,
  useRevokeAwardMutation,
  useGetEventSharesQuery,
  useShareEventMutation,
  useUnshareEventMutation,
  useGetBuyerSupplierInformationQuery,
  usePublishInformationMutation,
  useCreateUploadForSourcingEventV2Mutation,
  useEditNegotiationRoundMutation,
  useCreateUploadForNegotiationRoundDescriptionMutation,
  useCreateUploadForNegotiationRoundMutation,
  useGetProductGroupsForSourcingEventQuery,
  useListCombinedEventsForBuyerQuery,
  useListBuyerEventFilterOptionsQuery,
  useCountCombinedEventsByStatusQuery,
  useListEventsForBuyerQuery,
  useListContractReportsQuery,
  useListContractReportOptionsQuery,
  useCreateContractFromSourcingEventMutation,
  useDeleteCustomContractDataFieldMutation,
  useUpsertCustomContractDataFieldMutation,
  useUpsertContractDataFieldsSectionMutation,
  useContractReportQueryDummyMutation,
  useSignatureWebhookMutation,
  useDeleteContractTaskCommentMutation,
  useUpdateContractTaskCommentMutation,
  useDeleteContractTaskMutation,
  useUpdateContractTaskMutation,
  useListChangesForContractTaskQuery,
  useListCommentsForContractTaskQuery,
  useCreateContractTaskCommentMutation,
  useCreateContractTextDocumentMutation,
  useListTextDocumentsForContractQuery,
  useCreateFencyConversationMutation,
  useCreateExploreMemoriesSessionMutation,
  useCreateFencyFileDownloadSessionMutation,
  useDownloadMultiIfrsReportQuery,
  useCreateMemoryChatSessionMutation,
  useCreateMemoryDownloadLinkMutation,
  useCreateContractSearchSessionMutation,
  useGetContractStatisticsQuery,
  useGetContractAutofillContextQuery,
  useCancelSignedDocumentMutation,
  useCreateUploadForContractDescriptionMutation,
  useDownloadIfrsReportQuery,
  useGetContractMessageAttachmentUploadQuery,
  useCreateUploadForContractMessageAttachmentMutation,
  useListContractMessagesQuery,
  useCreateContractMessageMutation,
  useMarkContractMessagesReadMutation,
  useSaveContractMessageAttachmentMutation,
  useGetContractOriginCommunicationQuery,
  useDeleteContractParticipantMutation,
  useListParticipantsForContractsQuery,
  useCreateContractParticipantMutation,
  useCreateContractTaskMutation,
  useCreateUploadForContractMutation,
  useGetContributingEntityInviteQuery,
  useAcceptContributingEntityInviteMutation,
  useDeclineContributingEntityInviteMutation,
  useGetCpvCodesQuery,
  useListContractFilterOptionsQuery,
  useListContractsQuery,
  useForceDeliverBidMutation,
  useForcePublishEventMutation,
  useSkipPastGateMutation,
  useStartDocumentChatMutation,
  useUpdateDocumentMetaMutation,
  useGetDownloadLinkQuery,
  useListDocumentTemplatesQuery,
  useCreateDocumentTemplateMutation,
  useCreateBulkFencySessionMutation,
  useCreateFencyStreamSessionMutation,
  useCreateFencyDocumentSessionMutation,
  useFencySyncDocumentMutation,
  useSubmitDoffinNoticeMutation,
  useValidateDoffinNoticeMutation,
  useDownloadTextDocumentMutation,
  useUpdateEmailStatusMutation,
  useGetSeV2AttachmentDownloadLinkQuery,
  useConfirmFencyEventMutation,
  useMarkUploadFailedMutation,
  useConfirmUploadMutation,
  useSearchIndustriesQuery,
  useListLibraryElementsQuery,
  useCreateLibraryElementMutation,
  useUpdateLibraryElementMutation,
  useDeleteLibraryElementMutation,
  useListMyNotificationsQuery,
  useListOrganizationUsersQuery,
  useListOrganizationsForMeQuery,
  useCreateOrganizationForMeMutation,
  useMarkNotificationsAsPeekedMutation,
  useRecordRecentlyViewedMutation,
  useListMyRecentlyViewedContractsQuery,
  useListMyRecentlyViewedSourcingEventsQuery,
  useListMyUpcomingDeadlinesQuery,
  useMarkNotificationsAsViewedMutation,
  useCreateNeedMutation,
  useCreateNeedTextDocumentMutation,
  useListTextDocumentsForNeedQuery,
  useGetNeedQuery,
  useUpdateNeedMutation,
  useCreateProcurementForNeedMutation,
  useSubmitNeedMutation,
  useListNeedsQuery,
  useCreateUploadForNeedMutation,
  useCreateNegotiationTextDocumentMutation,
  useListTextDocumentsForNegotiationRoundQuery,
  useGetAccessTokenMutation,
  useSearchBrregOrgsByNameQuery,
  useLookupBrregOrgQuery,
  useListContractsForOrgQuery,
  useCreateApiClientMutation,
  useCreateOrganizationEntryMutation,
  useGetOrganizationEntryQuery,
  useUpdateOrganizationEntryMutation,
  useLinkOrganizationEntryMutation,
  useGetSupplierEmailInviteQuery,
  useGetOrgUserEmailInviteQuery,
  useAcceptOrgUserEmailInviteMutation,
  useListAssessmentTemplatesQuery,
  useUpdateAssessmentMutation,
  useListAssessmentsQuery,
  useListOrgsByNumberQuery,
  useUpdateOrganizationMutation,
  useListAccessGrantsQuery,
  useListDepartmentsQuery,
  useCreateDepartmentMutation,
  useRenameDepartmentMutation,
  useActivateDepartmentMutation,
  useDeactivateDepartmentMutation,
  useAssignDepartmentRoleMutation,
  useRevokeDepartmentRoleMutation,
  useListEntraConnectionsQuery,
  useCreateEntraConnectionMutation,
  useDeleteEntraConnectionMutation,
  useUpdateEntraConnectionMutation,
  useSaveEntraGroupMappingMutation,
  useDeleteEntraGroupMappingMutation,
  useGetOrganizationQuery,
  useListSupplierEmailInvitesQuery,
  useCreateSupplierEmailInviteMutation,
  useDeleteSupplierEmailInviteMutation,
  useCreateSupplierEmailInviteReminderMutation,
  useUpdateOrganizationTenantMutation,
  useListOrgUserEmailInvitesQuery,
  useCreateOrgUserEmailInviteMutation,
  useDeleteOrgUserEmailInviteMutation,
  useDeleteOrgUserMutation,
  useUpdateOrgUserRoleMutation,
  useListContractTasksForOrganizationQuery,
  useListContractTemplatesQuery,
  useCreateContractTemplateMutation,
  useGetTaskQuery,
  useUpdateContractTemplateMutation,
  useGetContractQuery,
  useUpdateContractMutation,
  useCopyContractMutation,
  usePublishContractMutation,
  useCreateSignedDocumentMutation,
  useCreateSignedTextDocumentMutation,
  useListContractTasksQuery,
  useCreateContractMutation,
  useListPersonsQuery,
  useGetPersonsByIdsQuery,
  useGetMeQuery,
  useUpdateMeMutation,
  useGetBidV2Query,
  useUpdateBidV2Mutation,
  useListContributingEntitiesQuery,
  useAddContributingEntityMutation,
  useRemoveContributingEntityMutation,
  useGetContributingEntityResponseQuery,
  useUpdateContributingEntityMutation,
  useResendContributingEntityInvitationMutation,
  useReopenContributingEntityResponseMutation,
  usePreviewBidV2ReportQuery,
  useStartBidV2SigningMutation,
  useCancelBidV2SigningMutation,
  useGetBidV2SigningPreflightQuery,
  useAcceptBidTermsMutation,
  useCreateUploadForBidV2Mutation,
  useWithdrawBidV2Mutation,
  useGetContributingEntityQuery,
  useUpdateContributingEntityResponseMutation,
  useUpdateContributingEntityCommitmentMutation,
  useUpdateContributingEntityQualificationResponsesMutation,
  useSubmitContributingEntityResponseMutation,
  useGetPortalSourcingEventsQuery,
  useGetPortalSourcingEventQuery,
  useGetPortalSeV2AttachmentUploadQuery,
  useGetPortalAwardLetterQuery,
  useCreateBidV2Mutation,
  useGetPortalDocumentDownloadLinkQuery,
  useGetPortalMyBidDocumentsQuery,
  useCreateParticipationRequestMutation,
  useGetMyParticipationQuery,
  useCreateUploadForSeV2QuestionAttachmentMutation,
  useGetPortalSeV2QuestionsQuery,
  useAskSeV2QuestionMutation,
  useSendSeV2ClarificationMessageAsSupplierMutation,
  useRegisterPortalInterestMutation,
  useGetPortalRegistrationStatusQuery,
  useGetPortalSupplierInformationQuery,
  useGetAuthenticatedPortalSourcingEventsQuery,
  useGetAuthenticatedPortalSourcingEventQuery,
  useAcceptPortalInviteMutation,
  useCreatePortalInitialBidMutation,
  useSubmitPortalPrivateBidMutation,
  useWithdrawPortalPrivateBidMutation,
  useDeclinePortalInviteMutation,
  useGetPortalNegotiationRoundsQuery,
  useCreatePortalRoundBidMutation,
  useGetPortalMyBidsQuery,
  useListMyContributionsQuery,
  useListMyParticipationRequestsQuery,
  useGetParticipationRequestQuery,
  useUpdateParticipationRequestMutation,
  useSubmitParticipationRequestMutation,
  useWithdrawParticipationRequestMutation,
  useEditProductGroupMutation,
  useCreateProductGroupMutation,
  useDeleteProductGroupMutation,
  useGetProductGroupsForProjectQuery,
  useGetProductTemplatesQuery,
  useCreateProjectMutation,
  useCreateProjectTextDocumentMutation,
  useListTextDocumentsForProjectQuery,
  useGetProjectQuery,
  useUpdateProjectMutation,
  useGetProjectsQuery,
  useGetProjectsByIdsQuery,
  useCreateUploadForProjectDescriptionMutation,
  useCreateUploadForProjectMutation,
  useGetGroupsQuery,
  useCreateGroupMutation,
  useDeleteGroupMutation,
  useGetGroupQuery,
  useUpdateGroupMutation,
  useGetSchemasQuery,
  useGetTokenQuery,
  useGetTokenForConnectionQuery,
  useGetUsersQuery,
  useCreateUserMutation,
  useDeleteUserMutation,
  useGetUserQuery,
  useUpdateUserMutation,
  useSearchOrganizationsAndEntriesQuery,
  useUpdateSignedDocumentMetaMutation,
  useGetSignedDocumentDownloadLinkQuery,
  useGetSignedAttachmentDownloadLinkQuery,
  useCreateFencySignedDocumentSessionMutation,
  useFencySyncSignedDocumentMutation,
  useListSourcingEventTemplatesQuery,
  useCreateSourcingEventTemplateMutation,
  useUpdateSourcingEventTemplateMutation,
  useDeleteSourcingEventTemplateMutation,
  useCreateSourcingEventV2TextDocumentMutation,
  useListTextDocumentsForSourcingEventV2Query,
  useCreateSourcingEventTextDocumentMutation,
  useListTextDocumentsForSourcingEventQuery,
  useGetBseBidQuery,
  useUpdateBseBidMutation,
  useCreateUploadForBseBidDescriptionMutation,
  useCreateUploadForBseBidMutation,
  useGetBseSupplierViewQuery,
  useCreateBseAnnouncementMutation,
  useUnDeliverBseBidMutation,
  useAcceptInvitationToBidMutation,
  useDeclineInvitationToBidMutation,
  useDownloadPublicProcurementProtocolPartOneMutation,
  useDownloadQaReportQuery,
  useCreateBseQuestionAsSupplierMutation,
  useCreateBseQuestionCommentAsSupplierMutation,
  useMarkAsViewedMutation,
  useCreateDraftBidMutation,
  useDeleteBidMutation,
  useListBidsCreatedByDepartmentQuery,
  useGetSeEmailInviteQuery,
  useAcceptSeEmailInviteMutation,
  useDeliverBidMutation,
  useListSeSupplierViewsQuery,
  useGetProductGroupsAsSupplierQuery,
  useCreateUploadForBidV2AwardCriterionAttachmentMutation,
  useCreateUploadForBidV2MinimumRequirementAttachmentMutation,
  useCreateUploadForBidV2QualificationEvidenceMutation,
  useUpdateTextDocumentMutation,
  useDeleteTextDocumentMutation,
  useGetTextDocumentUploadStatusQuery,
  useCreateUploadForTextDocumentMutation,
  useDeleteUploadMutation,
} = injectedRtkApi;
